var T4SThemeSP = {},
  isStorageSpSession = !1,
  isStorageSpSessionAll = !1,
  isStorageSpdLocal = !1,
  isStorageSpdLocalAll = !1,
  T4Sconfigs = window.T4Sconfigs,
  IsDesignMode = window.T4Srequest.design_mode,
  isThemeRTL = "rtl" == document.documentElement.getAttribute("dir");
(T4stt_var = {
  HoverInterval: 35,
  HoverTimeout: 150,
  dragThreshold: 10,
  prevOnHref: !1,
}),
  (function (t, e) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports
      ? (module.exports = t.document
          ? e(t, !0)
          : function (t) {
              if (!t.document)
                throw new Error("jQuery requires a window with a document");
              return e(t);
            })
      : e(t);
  })("undefined" != typeof window ? window : this, function (t, e) {
    "use strict";
    function i(t, e, i) {
      var n,
        o,
        s = (i = i || ht).createElement("script");
      if (((s.text = t), e))
        for (n in dt)
          (o = e[n] || (e.getAttribute && e.getAttribute(n))) &&
            s.setAttribute(n, o);
      i.head.appendChild(s).parentNode.removeChild(s);
    }
    function n(t) {
      return null == t
        ? t + ""
        : "object" == typeof t || "function" == typeof t
        ? nt[ot.call(t)] || "object"
        : typeof t;
    }
    function o(t) {
      var e = !!t && "length" in t && t.length,
        i = n(t);
      return (
        !ct(t) &&
        !ut(t) &&
        ("array" === i ||
          0 === e ||
          ("number" == typeof e && 0 < e && e - 1 in t))
      );
    }
    function s(t, e) {
      return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase();
    }
    function r(t, e, i) {
      return ct(e)
        ? pt.grep(t, function (t, n) {
            return !!e.call(t, n, t) !== i;
          })
        : e.nodeType
        ? pt.grep(t, function (t) {
            return (t === e) !== i;
          })
        : "string" != typeof e
        ? pt.grep(t, function (t) {
            return -1 < it.call(e, t) !== i;
          })
        : pt.filter(e, t, i);
    }
    function a(t, e) {
      for (; (t = t[e]) && 1 !== t.nodeType; );
      return t;
    }
    function l(t) {
      return t;
    }
    function c(t) {
      throw t;
    }
    function u(t, e, i, n) {
      var o;
      try {
        t && ct((o = t.promise))
          ? o.call(t).done(e).fail(i)
          : t && ct((o = t.then))
          ? o.call(t, e, i)
          : e.apply(void 0, [t].slice(n));
      } catch (t) {
        i.apply(void 0, [t]);
      }
    }
    function h() {
      ht.removeEventListener("DOMContentLoaded", h),
        t.removeEventListener("load", h),
        pt.ready();
    }
    function d(t, e) {
      return e.toUpperCase();
    }
    function f(t) {
      return t.replace(It, "ms-").replace(Pt, d);
    }
    function p() {
      this.expando = pt.expando + p.uid++;
    }
    function g(t, e, i) {
      var n, o;
      if (void 0 === i && 1 === t.nodeType)
        if (
          ((n = "data-" + e.replace(Nt, "-$&").toLowerCase()),
          "string" == typeof (i = t.getAttribute(n)))
        ) {
          try {
            i =
              "true" === (o = i) ||
              ("false" !== o &&
                ("null" === o
                  ? null
                  : o === +o + ""
                  ? +o
                  : zt.test(o)
                  ? JSON.parse(o)
                  : o));
          } catch (t) {}
          Lt.set(t, e, i);
        } else i = void 0;
      return i;
    }
    function m(t, e, i, n) {
      var o,
        s,
        r = 20,
        a = n
          ? function () {
              return n.cur();
            }
          : function () {
              return pt.css(t, e, "");
            },
        l = a(),
        c = (i && i[3]) || (pt.cssNumber[e] ? "" : "px"),
        u =
          t.nodeType &&
          (pt.cssNumber[e] || ("px" !== c && +l)) &&
          jt.exec(pt.css(t, e));
      if (u && u[3] !== c) {
        for (l /= 2, c = c || u[3], u = +l || 1; r--; )
          pt.style(t, e, u + c),
            (1 - s) * (1 - (s = a() / l || 0.5)) <= 0 && (r = 0),
            (u /= s);
        (u *= 2), pt.style(t, e, u + c), (i = i || []);
      }
      return (
        i &&
          ((u = +u || +l || 0),
          (o = i[1] ? u + (i[1] + 1) * i[2] : +i[2]),
          n && ((n.unit = c), (n.start = u), (n.end = o))),
        o
      );
    }
    function v(t, e) {
      for (var i, n, o, s, r, a, l, c = [], u = 0, h = t.length; u < h; u++)
        (n = t[u]).style &&
          ((i = n.style.display),
          e
            ? ("none" === i &&
                ((c[u] = At.get(n, "display") || null),
                c[u] || (n.style.display = "")),
              "" === n.style.display &&
                Ht(n) &&
                (c[u] =
                  ((l = r = s = void 0),
                  (r = (o = n).ownerDocument),
                  (a = o.nodeName),
                  (l = Rt[a]) ||
                    ((s = r.body.appendChild(r.createElement(a))),
                    (l = pt.css(s, "display")),
                    s.parentNode.removeChild(s),
                    "none" === l && (l = "block"),
                    (Rt[a] = l)))))
            : "none" !== i && ((c[u] = "none"), At.set(n, "display", i)));
      for (u = 0; u < h; u++) null != c[u] && (t[u].style.display = c[u]);
      return t;
    }
    function y(t, e) {
      var i;
      return (
        (i =
          void 0 !== t.getElementsByTagName
            ? t.getElementsByTagName(e || "*")
            : void 0 !== t.querySelectorAll
            ? t.querySelectorAll(e || "*")
            : []),
        void 0 === e || (e && s(t, e)) ? pt.merge([t], i) : i
      );
    }
    function b(t, e) {
      for (var i = 0, n = t.length; i < n; i++)
        At.set(t[i], "globalEval", !e || At.get(e[i], "globalEval"));
    }
    function x(t, e, i, o, s) {
      for (
        var r,
          a,
          l,
          c,
          u,
          h,
          d = e.createDocumentFragment(),
          f = [],
          p = 0,
          g = t.length;
        p < g;
        p++
      )
        if ((r = t[p]) || 0 === r)
          if ("object" === n(r)) pt.merge(f, r.nodeType ? [r] : r);
          else if (Yt.test(r)) {
            for (
              a = a || d.appendChild(e.createElement("div")),
                l = (Vt.exec(r) || ["", ""])[1].toLowerCase(),
                c = Xt[l] || Xt._default,
                a.innerHTML = c[1] + pt.htmlPrefilter(r) + c[2],
                h = c[0];
              h--;

            )
              a = a.lastChild;
            pt.merge(f, a.childNodes), ((a = d.firstChild).textContent = "");
          } else f.push(e.createTextNode(r));
      for (d.textContent = "", p = 0; (r = f[p++]); )
        if (o && -1 < pt.inArray(r, o)) s && s.push(r);
        else if (
          ((u = qt(r)), (a = y(d.appendChild(r), "script")), u && b(a), i)
        )
          for (h = 0; (r = a[h++]); ) Gt.test(r.type || "") && i.push(r);
      return d;
    }
    function S() {
      return !0;
    }
    function w() {
      return !1;
    }
    function T(t, e) {
      return (
        (t ===
          (function () {
            try {
              return ht.activeElement;
            } catch (t) {}
          })()) ==
        ("focus" === e)
      );
    }
    function C(t, e, i, n, o, s) {
      var r, a;
      if ("object" == typeof e) {
        for (a in ("string" != typeof i && ((n = n || i), (i = void 0)), e))
          C(t, a, i, n, e[a], s);
        return t;
      }
      if (
        (null == n && null == o
          ? ((o = i), (n = i = void 0))
          : null == o &&
            ("string" == typeof i
              ? ((o = n), (n = void 0))
              : ((o = n), (n = i), (i = void 0))),
        !1 === o)
      )
        o = w;
      else if (!o) return t;
      return (
        1 === s &&
          ((r = o),
          ((o = function (t) {
            return pt().off(t), r.apply(this, arguments);
          }).guid = r.guid || (r.guid = pt.guid++))),
        t.each(function () {
          pt.event.add(this, e, o, n, i);
        })
      );
    }
    function E(t, e, i) {
      i
        ? (At.set(t, e, !1),
          pt.event.add(t, e, {
            namespace: !1,
            handler: function (t) {
              var n,
                o,
                s = At.get(this, e);
              if (1 & t.isTrigger && this[e]) {
                if (s.length)
                  (pt.event.special[e] || {}).delegateType &&
                    t.stopPropagation();
                else if (
                  ((s = Z.call(arguments)),
                  At.set(this, e, s),
                  (n = i(this, e)),
                  this[e](),
                  s !== (o = At.get(this, e)) || n
                    ? At.set(this, e, !1)
                    : (o = {}),
                  s !== o)
                )
                  return (
                    t.stopImmediatePropagation(),
                    t.preventDefault(),
                    o && o.value
                  );
              } else
                s.length &&
                  (At.set(this, e, {
                    value: pt.event.trigger(
                      pt.extend(s[0], pt.Event.prototype),
                      s.slice(1),
                      this
                    ),
                  }),
                  t.stopImmediatePropagation());
            },
          }))
        : void 0 === At.get(t, e) && pt.event.add(t, e, S);
    }
    function _(t, e) {
      return (
        (s(t, "table") &&
          s(11 !== e.nodeType ? e : e.firstChild, "tr") &&
          pt(t).children("tbody")[0]) ||
        t
      );
    }
    function k(t) {
      return (t.type = (null !== t.getAttribute("type")) + "/" + t.type), t;
    }
    function I(t) {
      return (
        "true/" === (t.type || "").slice(0, 5)
          ? (t.type = t.type.slice(5))
          : t.removeAttribute("type"),
        t
      );
    }
    function P(t, e) {
      var i, n, o, s, r, a;
      if (1 === e.nodeType) {
        if (At.hasData(t) && (a = At.get(t).events))
          for (o in (At.remove(e, "handle events"), a))
            for (i = 0, n = a[o].length; i < n; i++)
              pt.event.add(e, o, a[o][i]);
        Lt.hasData(t) &&
          ((s = Lt.access(t)), (r = pt.extend({}, s)), Lt.set(e, r));
      }
    }
    function D(t, e, n, o) {
      e = tt(e);
      var s,
        r,
        a,
        l,
        c,
        u,
        h = 0,
        d = t.length,
        f = d - 1,
        p = e[0],
        g = ct(p);
      if (g || (1 < d && "string" == typeof p && !lt.checkClone && Kt.test(p)))
        return t.each(function (i) {
          var s = t.eq(i);
          g && (e[0] = p.call(this, i, s.html())), D(s, e, n, o);
        });
      if (
        d &&
        ((r = (s = x(e, t[0].ownerDocument, !1, t, o)).firstChild),
        1 === s.childNodes.length && (s = r),
        r || o)
      ) {
        for (l = (a = pt.map(y(s, "script"), k)).length; h < d; h++)
          (c = s),
            h !== f &&
              ((c = pt.clone(c, !0, !0)), l && pt.merge(a, y(c, "script"))),
            n.call(t[h], c, h);
        if (l)
          for (
            u = a[a.length - 1].ownerDocument, pt.map(a, I), h = 0;
            h < l;
            h++
          )
            (c = a[h]),
              Gt.test(c.type || "") &&
                !At.access(c, "globalEval") &&
                pt.contains(u, c) &&
                (c.src && "module" !== (c.type || "").toLowerCase()
                  ? pt._evalUrl &&
                    !c.noModule &&
                    pt._evalUrl(
                      c.src,
                      { nonce: c.nonce || c.getAttribute("nonce") },
                      u
                    )
                  : i(c.textContent.replace(Zt, ""), c, u));
      }
      return t;
    }
    function A(t, e, i) {
      for (var n, o = e ? pt.filter(e, t) : t, s = 0; null != (n = o[s]); s++)
        i || 1 !== n.nodeType || pt.cleanData(y(n)),
          n.parentNode &&
            (i && qt(n) && b(y(n, "script")), n.parentNode.removeChild(n));
      return t;
    }
    function L(t, e, i) {
      var n,
        o,
        s,
        r,
        a = t.style;
      return (
        (i = i || ee(t)) &&
          ("" !== (r = i.getPropertyValue(e) || i[e]) ||
            qt(t) ||
            (r = pt.style(t, e)),
          !lt.pixelBoxStyles() &&
            te.test(r) &&
            ne.test(e) &&
            ((n = a.width),
            (o = a.minWidth),
            (s = a.maxWidth),
            (a.minWidth = a.maxWidth = a.width = r),
            (r = i.width),
            (a.width = n),
            (a.minWidth = o),
            (a.maxWidth = s))),
        void 0 !== r ? r + "" : r
      );
    }
    function z(t, e) {
      return {
        get: function () {
          if (!t()) return (this.get = e).apply(this, arguments);
          delete this.get;
        },
      };
    }
    function N(t) {
      return (
        pt.cssProps[t] ||
        re[t] ||
        (t in se
          ? t
          : (re[t] =
              (function (t) {
                for (
                  var e = t[0].toUpperCase() + t.slice(1), i = oe.length;
                  i--;

                )
                  if ((t = oe[i] + e) in se) return t;
              })(t) || t))
      );
    }
    function M(t, e, i) {
      var n = jt.exec(e);
      return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : e;
    }
    function j(t, e, i, n, o, s) {
      var r = "width" === e ? 1 : 0,
        a = 0,
        l = 0;
      if (i === (n ? "border" : "content")) return 0;
      for (; r < 4; r += 2)
        "margin" === i && (l += pt.css(t, i + Wt[r], !0, o)),
          n
            ? ("content" === i && (l -= pt.css(t, "padding" + Wt[r], !0, o)),
              "margin" !== i &&
                (l -= pt.css(t, "border" + Wt[r] + "Width", !0, o)))
            : ((l += pt.css(t, "padding" + Wt[r], !0, o)),
              "padding" !== i
                ? (l += pt.css(t, "border" + Wt[r] + "Width", !0, o))
                : (a += pt.css(t, "border" + Wt[r] + "Width", !0, o)));
      return (
        !n &&
          0 <= s &&
          (l +=
            Math.max(
              0,
              Math.ceil(
                t["offset" + e[0].toUpperCase() + e.slice(1)] - s - l - a - 0.5
              )
            ) || 0),
        l
      );
    }
    function W(t, e, i) {
      var n = ee(t),
        o =
          (!lt.boxSizingReliable() || i) &&
          "border-box" === pt.css(t, "boxSizing", !1, n),
        r = o,
        a = L(t, e, n),
        l = "offset" + e[0].toUpperCase() + e.slice(1);
      if (te.test(a)) {
        if (!i) return a;
        a = "auto";
      }
      return (
        ((!lt.boxSizingReliable() && o) ||
          (!lt.reliableTrDimensions() && s(t, "tr")) ||
          "auto" === a ||
          (!parseFloat(a) && "inline" === pt.css(t, "display", !1, n))) &&
          t.getClientRects().length &&
          ((o = "border-box" === pt.css(t, "boxSizing", !1, n)),
          (r = l in t) && (a = t[l])),
        (a = parseFloat(a) || 0) +
          j(t, e, i || (o ? "border" : "content"), r, n, a) +
          "px"
      );
    }
    function O(t, e, i, n, o) {
      return new O.prototype.init(t, e, i, n, o);
    }
    function q() {
      de &&
        (!1 === ht.hidden && t.requestAnimationFrame
          ? t.requestAnimationFrame(q)
          : t.setTimeout(q, pt.fx.interval),
        pt.fx.tick());
    }
    function $() {
      return (
        t.setTimeout(function () {
          he = void 0;
        }),
        (he = Date.now())
      );
    }
    function H(t, e) {
      var i,
        n = 0,
        o = { height: t };
      for (e = e ? 1 : 0; n < 4; n += 2 - e)
        o["margin" + (i = Wt[n])] = o["padding" + i] = t;
      return e && (o.opacity = o.width = t), o;
    }
    function R(t, e, i) {
      for (
        var n,
          o = (B.tweeners[e] || []).concat(B.tweeners["*"]),
          s = 0,
          r = o.length;
        s < r;
        s++
      )
        if ((n = o[s].call(i, e, t))) return n;
    }
    function B(t, e, i) {
      var n,
        o,
        s = 0,
        r = B.prefilters.length,
        a = pt.Deferred().always(function () {
          delete l.elem;
        }),
        l = function () {
          if (o) return !1;
          for (
            var e = he || $(),
              i = Math.max(0, c.startTime + c.duration - e),
              n = 1 - (i / c.duration || 0),
              s = 0,
              r = c.tweens.length;
            s < r;
            s++
          )
            c.tweens[s].run(n);
          return (
            a.notifyWith(t, [c, n, i]),
            n < 1 && r
              ? i
              : (r || a.notifyWith(t, [c, 1, 0]), a.resolveWith(t, [c]), !1)
          );
        },
        c = a.promise({
          elem: t,
          props: pt.extend({}, e),
          opts: pt.extend(
            !0,
            { specialEasing: {}, easing: pt.easing._default },
            i
          ),
          originalProperties: e,
          originalOptions: i,
          startTime: he || $(),
          duration: i.duration,
          tweens: [],
          createTween: function (e, i) {
            var n = pt.Tween(
              t,
              c.opts,
              e,
              i,
              c.opts.specialEasing[e] || c.opts.easing
            );
            return c.tweens.push(n), n;
          },
          stop: function (e) {
            var i = 0,
              n = e ? c.tweens.length : 0;
            if (o) return this;
            for (o = !0; i < n; i++) c.tweens[i].run(1);
            return (
              e
                ? (a.notifyWith(t, [c, 1, 0]), a.resolveWith(t, [c, e]))
                : a.rejectWith(t, [c, e]),
              this
            );
          },
        }),
        u = c.props;
      for (
        !(function (t, e) {
          var i, n, o, s, r;
          for (i in t)
            if (
              ((o = e[(n = f(i))]),
              (s = t[i]),
              Array.isArray(s) && ((o = s[1]), (s = t[i] = s[0])),
              i !== n && ((t[n] = s), delete t[i]),
              (r = pt.cssHooks[n]) && ("expand" in r))
            )
              for (i in ((s = r.expand(s)), delete t[n], s))
                (i in t) || ((t[i] = s[i]), (e[i] = o));
            else e[n] = o;
        })(u, c.opts.specialEasing);
        s < r;
        s++
      )
        if ((n = B.prefilters[s].call(c, t, u, c.opts)))
          return (
            ct(n.stop) &&
              (pt._queueHooks(c.elem, c.opts.queue).stop = n.stop.bind(n)),
            n
          );
      return (
        pt.map(u, R, c),
        ct(c.opts.start) && c.opts.start.call(t, c),
        c
          .progress(c.opts.progress)
          .done(c.opts.done, c.opts.complete)
          .fail(c.opts.fail)
          .always(c.opts.always),
        pt.fx.timer(pt.extend(l, { elem: t, anim: c, queue: c.opts.queue })),
        c
      );
    }
    function F(t) {
      return (t.match(Ct) || []).join(" ");
    }
    function U(t) {
      return (t.getAttribute && t.getAttribute("class")) || "";
    }
    function V(t) {
      return Array.isArray(t) ? t : ("string" == typeof t && t.match(Ct)) || [];
    }
    function G(t, e, i, o) {
      var s;
      if (Array.isArray(e))
        pt.each(e, function (e, n) {
          i || ke.test(t)
            ? o(t, n)
            : G(
                t + "[" + ("object" == typeof n && null != n ? e : "") + "]",
                n,
                i,
                o
              );
        });
      else if (i || "object" !== n(e)) o(t, e);
      else for (s in e) G(t + "[" + s + "]", e[s], i, o);
    }
    function X(t) {
      return function (e, i) {
        "string" != typeof e && ((i = e), (e = "*"));
        var n,
          o = 0,
          s = e.toLowerCase().match(Ct) || [];
        if (ct(i))
          for (; (n = s[o++]); )
            "+" === n[0]
              ? ((n = n.slice(1) || "*"), (t[n] = t[n] || []).unshift(i))
              : (t[n] = t[n] || []).push(i);
      };
    }
    function Y(t, e, i, n) {
      function o(a) {
        var l;
        return (
          (s[a] = !0),
          pt.each(t[a] || [], function (t, a) {
            var c = a(e, i, n);
            return "string" != typeof c || r || s[c]
              ? r
                ? !(l = c)
                : void 0
              : (e.dataTypes.unshift(c), o(c), !1);
          }),
          l
        );
      }
      var s = {},
        r = t === Oe;
      return o(e.dataTypes[0]) || (!s["*"] && o("*"));
    }
    function Q(t, e) {
      var i,
        n,
        o = pt.ajaxSettings.flatOptions || {};
      for (i in e) void 0 !== e[i] && ((o[i] ? t : n || (n = {}))[i] = e[i]);
      return n && pt.extend(!0, t, n), t;
    }
    var J = [],
      K = Object.getPrototypeOf,
      Z = J.slice,
      tt = J.flat
        ? function (t) {
            return J.flat.call(t);
          }
        : function (t) {
            return J.concat.apply([], t);
          },
      et = J.push,
      it = J.indexOf,
      nt = {},
      ot = nt.toString,
      st = nt.hasOwnProperty,
      rt = st.toString,
      at = rt.call(Object),
      lt = {},
      ct = function (t) {
        return (
          "function" == typeof t &&
          "number" != typeof t.nodeType &&
          "function" != typeof t.item
        );
      },
      ut = function (t) {
        return null != t && t === t.window;
      },
      ht = t.document,
      dt = { type: !0, src: !0, nonce: !0, noModule: !0 },
      ft = "3.6.0",
      pt = function (t, e) {
        return new pt.fn.init(t, e);
      };
    (pt.fn = pt.prototype =
      {
        jquery: ft,
        constructor: pt,
        length: 0,
        toArray: function () {
          return Z.call(this);
        },
        get: function (t) {
          return null == t
            ? Z.call(this)
            : t < 0
            ? this[t + this.length]
            : this[t];
        },
        pushStack: function (t) {
          var e = pt.merge(this.constructor(), t);
          return (e.prevObject = this), e;
        },
        each: function (t) {
          return pt.each(this, t);
        },
        map: function (t) {
          return this.pushStack(
            pt.map(this, function (e, i) {
              return t.call(e, i, e);
            })
          );
        },
        slice: function () {
          return this.pushStack(Z.apply(this, arguments));
        },
        first: function () {
          return this.eq(0);
        },
        last: function () {
          return this.eq(-1);
        },
        even: function () {
          return this.pushStack(
            pt.grep(this, function (t, e) {
              return (e + 1) % 2;
            })
          );
        },
        odd: function () {
          return this.pushStack(
            pt.grep(this, function (t, e) {
              return e % 2;
            })
          );
        },
        eq: function (t) {
          var e = this.length,
            i = +t + (t < 0 ? e : 0);
          return this.pushStack(0 <= i && i < e ? [this[i]] : []);
        },
        end: function () {
          return this.prevObject || this.constructor();
        },
        push: et,
        sort: J.sort,
        splice: J.splice,
      }),
      (pt.extend = pt.fn.extend =
        function () {
          var t,
            e,
            i,
            n,
            o,
            s,
            r = arguments[0] || {},
            a = 1,
            l = arguments.length,
            c = !1;
          for (
            "boolean" == typeof r && ((c = r), (r = arguments[a] || {}), a++),
              "object" == typeof r || ct(r) || (r = {}),
              a === l && ((r = this), a--);
            a < l;
            a++
          )
            if (null != (t = arguments[a]))
              for (e in t)
                (n = t[e]),
                  "__proto__" !== e &&
                    r !== n &&
                    (c && n && (pt.isPlainObject(n) || (o = Array.isArray(n)))
                      ? ((i = r[e]),
                        (s =
                          o && !Array.isArray(i)
                            ? []
                            : o || pt.isPlainObject(i)
                            ? i
                            : {}),
                        (o = !1),
                        (r[e] = pt.extend(c, s, n)))
                      : void 0 !== n && (r[e] = n));
          return r;
        }),
      pt.extend({
        expando: "jQuery" + (ft + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function (t) {
          throw new Error(t);
        },
        noop: function () {},
        isPlainObject: function (t) {
          var e, i;
          return !(
            !t ||
            "[object Object]" !== ot.call(t) ||
            ((e = K(t)) &&
              ("function" !=
                typeof (i = st.call(e, "constructor") && e.constructor) ||
                rt.call(i) !== at))
          );
        },
        isEmptyObject: function (t) {
          var e;
          for (e in t) return !1;
          return !0;
        },
        globalEval: function (t, e, n) {
          i(t, { nonce: e && e.nonce }, n);
        },
        each: function (t, e) {
          var i,
            n = 0;
          if (o(t))
            for (i = t.length; n < i && !1 !== e.call(t[n], n, t[n]); n++);
          else for (n in t) if (!1 === e.call(t[n], n, t[n])) break;
          return t;
        },
        makeArray: function (t, e) {
          var i = e || [];
          return (
            null != t &&
              (o(Object(t))
                ? pt.merge(i, "string" == typeof t ? [t] : t)
                : et.call(i, t)),
            i
          );
        },
        inArray: function (t, e, i) {
          return null == e ? -1 : it.call(e, t, i);
        },
        merge: function (t, e) {
          for (var i = +e.length, n = 0, o = t.length; n < i; n++)
            t[o++] = e[n];
          return (t.length = o), t;
        },
        grep: function (t, e, i) {
          for (var n = [], o = 0, s = t.length, r = !i; o < s; o++)
            !e(t[o], o) !== r && n.push(t[o]);
          return n;
        },
        map: function (t, e, i) {
          var n,
            s,
            r = 0,
            a = [];
          if (o(t))
            for (n = t.length; r < n; r++)
              null != (s = e(t[r], r, i)) && a.push(s);
          else for (r in t) null != (s = e(t[r], r, i)) && a.push(s);
          return tt(a);
        },
        guid: 1,
        support: lt,
      }),
      "function" == typeof Symbol &&
        (pt.fn[Symbol.iterator] = J[Symbol.iterator]),
      pt.each(
        "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
          " "
        ),
        function (t, e) {
          nt["[object " + e + "]"] = e.toLowerCase();
        }
      );
    var gt = (function (t) {
      function e(t, e, i, n) {
        var o,
          s,
          r,
          a,
          l,
          c,
          u,
          d = e && e.ownerDocument,
          p = e ? e.nodeType : 9;
        if (
          ((i = i || []),
          "string" != typeof t || !t || (1 !== p && 9 !== p && 11 !== p))
        )
          return i;
        if (!n && (D(e), (e = e || A), z)) {
          if (11 !== p && (l = vt.exec(t)))
            if ((o = l[1])) {
              if (9 === p) {
                if (!(r = e.getElementById(o))) return i;
                if (r.id === o) return i.push(r), i;
              } else if (
                d &&
                (r = d.getElementById(o)) &&
                W(e, r) &&
                r.id === o
              )
                return i.push(r), i;
            } else {
              if (l[2]) return J.apply(i, e.getElementsByTagName(t)), i;
              if (
                (o = l[3]) &&
                x.getElementsByClassName &&
                e.getElementsByClassName
              )
                return J.apply(i, e.getElementsByClassName(o)), i;
            }
          if (
            x.qsa &&
            !U[t + " "] &&
            (!N || !N.test(t)) &&
            (1 !== p || "object" !== e.nodeName.toLowerCase())
          ) {
            if (((u = t), (d = e), 1 === p && (ct.test(t) || lt.test(t)))) {
              for (
                ((d = (yt.test(t) && h(e.parentNode)) || e) === e && x.scope) ||
                  ((a = e.getAttribute("id"))
                    ? (a = a.replace(St, wt))
                    : e.setAttribute("id", (a = O))),
                  s = (c = C(t)).length;
                s--;

              )
                c[s] = (a ? "#" + a : ":scope") + " " + f(c[s]);
              u = c.join(",");
            }
            try {
              return J.apply(i, d.querySelectorAll(u)), i;
            } catch (e) {
              U(t, !0);
            } finally {
              a === O && e.removeAttribute("id");
            }
          }
        }
        return _(t.replace(rt, "$1"), e, i, n);
      }
      function i() {
        var t = [];
        return function e(i, n) {
          return (
            t.push(i + " ") > S.cacheLength && delete e[t.shift()],
            (e[i + " "] = n)
          );
        };
      }
      function n(t) {
        return (t[O] = !0), t;
      }
      function o(t) {
        var e = A.createElement("fieldset");
        try {
          return !!t(e);
        } catch (t) {
          return !1;
        } finally {
          e.parentNode && e.parentNode.removeChild(e), (e = null);
        }
      }
      function s(t, e) {
        for (var i = t.split("|"), n = i.length; n--; ) S.attrHandle[i[n]] = e;
      }
      function r(t, e) {
        var i = e && t,
          n =
            i &&
            1 === t.nodeType &&
            1 === e.nodeType &&
            t.sourceIndex - e.sourceIndex;
        if (n) return n;
        if (i) for (; (i = i.nextSibling); ) if (i === e) return -1;
        return t ? 1 : -1;
      }
      function a(t) {
        return function (e) {
          return "input" === e.nodeName.toLowerCase() && e.type === t;
        };
      }
      function l(t) {
        return function (e) {
          var i = e.nodeName.toLowerCase();
          return ("input" === i || "button" === i) && e.type === t;
        };
      }
      function c(t) {
        return function (e) {
          return "form" in e
            ? e.parentNode && !1 === e.disabled
              ? "label" in e
                ? "label" in e.parentNode
                  ? e.parentNode.disabled === t
                  : e.disabled === t
                : e.isDisabled === t || (e.isDisabled !== !t && Ct(e) === t)
              : e.disabled === t
            : "label" in e && e.disabled === t;
        };
      }
      function u(t) {
        return n(function (e) {
          return (
            (e = +e),
            n(function (i, n) {
              for (var o, s = t([], i.length, e), r = s.length; r--; )
                i[(o = s[r])] && (i[o] = !(n[o] = i[o]));
            })
          );
        });
      }
      function h(t) {
        return t && void 0 !== t.getElementsByTagName && t;
      }
      function d() {}
      function f(t) {
        for (var e = 0, i = t.length, n = ""; e < i; e++) n += t[e].value;
        return n;
      }
      function p(t, e, i) {
        var n = e.dir,
          o = e.next,
          s = o || n,
          r = i && "parentNode" === s,
          a = H++;
        return e.first
          ? function (e, i, o) {
              for (; (e = e[n]); ) if (1 === e.nodeType || r) return t(e, i, o);
              return !1;
            }
          : function (e, i, l) {
              var c,
                u,
                h,
                d = [$, a];
              if (l) {
                for (; (e = e[n]); )
                  if ((1 === e.nodeType || r) && t(e, i, l)) return !0;
              } else
                for (; (e = e[n]); )
                  if (1 === e.nodeType || r)
                    if (
                      ((u =
                        (h = e[O] || (e[O] = {}))[e.uniqueID] ||
                        (h[e.uniqueID] = {})),
                      o && o === e.nodeName.toLowerCase())
                    )
                      e = e[n] || e;
                    else {
                      if ((c = u[s]) && c[0] === $ && c[1] === a)
                        return (d[2] = c[2]);
                      if (((u[s] = d)[2] = t(e, i, l))) return !0;
                    }
              return !1;
            };
      }
      function g(t) {
        return 1 < t.length
          ? function (e, i, n) {
              for (var o = t.length; o--; ) if (!t[o](e, i, n)) return !1;
              return !0;
            }
          : t[0];
      }
      function m(t, e, i, n, o) {
        for (var s, r = [], a = 0, l = t.length, c = null != e; a < l; a++)
          (s = t[a]) && ((i && !i(s, n, o)) || (r.push(s), c && e.push(a)));
        return r;
      }
      function v(t, i, o, s, r, a) {
        return (
          s && !s[O] && (s = v(s)),
          r && !r[O] && (r = v(r, a)),
          n(function (n, a, l, c) {
            var u,
              h,
              d,
              f = [],
              p = [],
              g = a.length,
              v =
                n ||
                (function (t, i, n) {
                  for (var o = 0, s = i.length; o < s; o++) e(t, i[o], n);
                  return n;
                })(i || "*", l.nodeType ? [l] : l, []),
              y = !t || (!n && i) ? v : m(v, f, t, l, c),
              b = o ? (r || (n ? t : g || s) ? [] : a) : y;
            if ((o && o(y, b, l, c), s))
              for (u = m(b, p), s(u, [], l, c), h = u.length; h--; )
                (d = u[h]) && (b[p[h]] = !(y[p[h]] = d));
            if (n) {
              if (r || t) {
                if (r) {
                  for (u = [], h = b.length; h--; )
                    (d = b[h]) && u.push((y[h] = d));
                  r(null, (b = []), u, c);
                }
                for (h = b.length; h--; )
                  (d = b[h]) &&
                    -1 < (u = r ? Z(n, d) : f[h]) &&
                    (n[u] = !(a[u] = d));
              }
            } else (b = m(b === a ? b.splice(g, b.length) : b)), r ? r(null, a, b, c) : J.apply(a, b);
          })
        );
      }
      function y(t) {
        for (
          var e,
            i,
            n,
            o = t.length,
            s = S.relative[t[0].type],
            r = s || S.relative[" "],
            a = s ? 1 : 0,
            l = p(
              function (t) {
                return t === e;
              },
              r,
              !0
            ),
            c = p(
              function (t) {
                return -1 < Z(e, t);
              },
              r,
              !0
            ),
            u = [
              function (t, i, n) {
                var o =
                  (!s && (n || i !== k)) ||
                  ((e = i).nodeType ? l(t, i, n) : c(t, i, n));
                return (e = null), o;
              },
            ];
          a < o;
          a++
        )
          if ((i = S.relative[t[a].type])) u = [p(g(u), i)];
          else {
            if ((i = S.filter[t[a].type].apply(null, t[a].matches))[O]) {
              for (n = ++a; n < o && !S.relative[t[n].type]; n++);
              return v(
                1 < a && g(u),
                1 < a &&
                  f(
                    t
                      .slice(0, a - 1)
                      .concat({ value: " " === t[a - 2].type ? "*" : "" })
                  ).replace(rt, "$1"),
                i,
                a < n && y(t.slice(a, n)),
                n < o && y((t = t.slice(n))),
                n < o && f(t)
              );
            }
            u.push(i);
          }
        return g(u);
      }
      var b,
        x,
        S,
        w,
        T,
        C,
        E,
        _,
        k,
        I,
        P,
        D,
        A,
        L,
        z,
        N,
        M,
        j,
        W,
        O = "sizzle" + 1 * new Date(),
        q = t.document,
        $ = 0,
        H = 0,
        R = i(),
        B = i(),
        F = i(),
        U = i(),
        V = function (t, e) {
          return t === e && (P = !0), 0;
        },
        G = {}.hasOwnProperty,
        X = [],
        Y = X.pop,
        Q = X.push,
        J = X.push,
        K = X.slice,
        Z = function (t, e) {
          for (var i = 0, n = t.length; i < n; i++) if (t[i] === e) return i;
          return -1;
        },
        tt =
          "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        et = "[\\x20\\t\\r\\n\\f]",
        it =
          "(?:\\\\[\\da-fA-F]{1,6}" +
          et +
          "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
        nt =
          "\\[" +
          et +
          "*(" +
          it +
          ")(?:" +
          et +
          "*([*^$|!~]?=)" +
          et +
          "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
          it +
          "))|)" +
          et +
          "*\\]",
        ot =
          ":(" +
          it +
          ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
          nt +
          ")*)|.*)\\)|)",
        st = new RegExp(et + "+", "g"),
        rt = new RegExp(
          "^" + et + "+|((?:^|[^\\\\])(?:\\\\.)*)" + et + "+$",
          "g"
        ),
        at = new RegExp("^" + et + "*," + et + "*"),
        lt = new RegExp("^" + et + "*([>+~]|" + et + ")" + et + "*"),
        ct = new RegExp(et + "|>"),
        ut = new RegExp(ot),
        ht = new RegExp("^" + it + "$"),
        dt = {
          ID: new RegExp("^#(" + it + ")"),
          CLASS: new RegExp("^\\.(" + it + ")"),
          TAG: new RegExp("^(" + it + "|[*])"),
          ATTR: new RegExp("^" + nt),
          PSEUDO: new RegExp("^" + ot),
          CHILD: new RegExp(
            "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
              et +
              "*(even|odd|(([+-]|)(\\d*)n|)" +
              et +
              "*(?:([+-]|)" +
              et +
              "*(\\d+)|))" +
              et +
              "*\\)|)",
            "i"
          ),
          bool: new RegExp("^(?:" + tt + ")$", "i"),
          needsContext: new RegExp(
            "^" +
              et +
              "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
              et +
              "*((?:-\\d)?\\d*)" +
              et +
              "*\\)|)(?=[^-]|$)",
            "i"
          ),
        },
        ft = /HTML$/i,
        pt = /^(?:input|select|textarea|button)$/i,
        gt = /^h\d$/i,
        mt = /^[^{]+\{\s*\[native \w/,
        vt = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        yt = /[+~]/,
        bt = new RegExp(
          "\\\\[\\da-fA-F]{1,6}" + et + "?|\\\\([^\\r\\n\\f])",
          "g"
        ),
        xt = function (t, e) {
          var i = "0x" + t.slice(1) - 65536;
          return (
            e ||
            (i < 0
              ? String.fromCharCode(i + 65536)
              : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320))
          );
        },
        St = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
        wt = function (t, e) {
          return e
            ? "\0" === t
              ? "�"
              : t.slice(0, -1) +
                "\\" +
                t.charCodeAt(t.length - 1).toString(16) +
                " "
            : "\\" + t;
        },
        Tt = function () {
          D();
        },
        Ct = p(
          function (t) {
            return !0 === t.disabled && "fieldset" === t.nodeName.toLowerCase();
          },
          { dir: "parentNode", next: "legend" }
        );
      try {
        J.apply((X = K.call(q.childNodes)), q.childNodes),
          X[q.childNodes.length].nodeType;
      } catch (b) {
        J = {
          apply: X.length
            ? function (t, e) {
                Q.apply(t, K.call(e));
              }
            : function (t, e) {
                for (var i = t.length, n = 0; (t[i++] = e[n++]); );
                t.length = i - 1;
              },
        };
      }
      for (b in ((x = e.support = {}),
      (T = e.isXML =
        function (t) {
          var e = t && t.namespaceURI,
            i = t && (t.ownerDocument || t).documentElement;
          return !ft.test(e || (i && i.nodeName) || "HTML");
        }),
      (D = e.setDocument =
        function (t) {
          var e,
            i,
            n = t ? t.ownerDocument || t : q;
          return (
            n != A &&
              9 === n.nodeType &&
              n.documentElement &&
              ((L = (A = n).documentElement),
              (z = !T(A)),
              q != A &&
                (i = A.defaultView) &&
                i.top !== i &&
                (i.addEventListener
                  ? i.addEventListener("unload", Tt, !1)
                  : i.attachEvent && i.attachEvent("onunload", Tt)),
              (x.scope = o(function (t) {
                return (
                  L.appendChild(t).appendChild(A.createElement("div")),
                  void 0 !== t.querySelectorAll &&
                    !t.querySelectorAll(":scope fieldset div").length
                );
              })),
              (x.attributes = o(function (t) {
                return (t.className = "i"), !t.getAttribute("className");
              })),
              (x.getElementsByTagName = o(function (t) {
                return (
                  t.appendChild(A.createComment("")),
                  !t.getElementsByTagName("*").length
                );
              })),
              (x.getElementsByClassName = mt.test(A.getElementsByClassName)),
              (x.getById = o(function (t) {
                return (
                  (L.appendChild(t).id = O),
                  !A.getElementsByName || !A.getElementsByName(O).length
                );
              })),
              x.getById
                ? ((S.filter.ID = function (t) {
                    var e = t.replace(bt, xt);
                    return function (t) {
                      return t.getAttribute("id") === e;
                    };
                  }),
                  (S.find.ID = function (t, e) {
                    if (void 0 !== e.getElementById && z) {
                      var i = e.getElementById(t);
                      return i ? [i] : [];
                    }
                  }))
                : ((S.filter.ID = function (t) {
                    var e = t.replace(bt, xt);
                    return function (t) {
                      var i =
                        void 0 !== t.getAttributeNode &&
                        t.getAttributeNode("id");
                      return i && i.value === e;
                    };
                  }),
                  (S.find.ID = function (t, e) {
                    if (void 0 !== e.getElementById && z) {
                      var i,
                        n,
                        o,
                        s = e.getElementById(t);
                      if (s) {
                        if ((i = s.getAttributeNode("id")) && i.value === t)
                          return [s];
                        for (o = e.getElementsByName(t), n = 0; (s = o[n++]); )
                          if ((i = s.getAttributeNode("id")) && i.value === t)
                            return [s];
                      }
                      return [];
                    }
                  })),
              (S.find.TAG = x.getElementsByTagName
                ? function (t, e) {
                    return void 0 !== e.getElementsByTagName
                      ? e.getElementsByTagName(t)
                      : x.qsa
                      ? e.querySelectorAll(t)
                      : void 0;
                  }
                : function (t, e) {
                    var i,
                      n = [],
                      o = 0,
                      s = e.getElementsByTagName(t);
                    if ("*" === t) {
                      for (; (i = s[o++]); ) 1 === i.nodeType && n.push(i);
                      return n;
                    }
                    return s;
                  }),
              (S.find.CLASS =
                x.getElementsByClassName &&
                function (t, e) {
                  if (void 0 !== e.getElementsByClassName && z)
                    return e.getElementsByClassName(t);
                }),
              (M = []),
              (N = []),
              (x.qsa = mt.test(A.querySelectorAll)) &&
                (o(function (t) {
                  var e;
                  (L.appendChild(t).innerHTML =
                    "<a id='" +
                    O +
                    "'></a><select id='" +
                    O +
                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                    t.querySelectorAll("[msallowcapture^='']").length &&
                      N.push("[*^$]=" + et + "*(?:''|\"\")"),
                    t.querySelectorAll("[selected]").length ||
                      N.push("\\[" + et + "*(?:value|" + tt + ")"),
                    t.querySelectorAll("[id~=" + O + "-]").length ||
                      N.push("~="),
                    (e = A.createElement("input")).setAttribute("name", ""),
                    t.appendChild(e),
                    t.querySelectorAll("[name='']").length ||
                      N.push(
                        "\\[" + et + "*name" + et + "*=" + et + "*(?:''|\"\")"
                      ),
                    t.querySelectorAll(":checked").length || N.push(":checked"),
                    t.querySelectorAll("a#" + O + "+*").length ||
                      N.push(".#.+[+~]"),
                    t.querySelectorAll("\\\f"),
                    N.push("[\\r\\n\\f]");
                }),
                o(function (t) {
                  t.innerHTML =
                    "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                  var e = A.createElement("input");
                  e.setAttribute("type", "hidden"),
                    t.appendChild(e).setAttribute("name", "D"),
                    t.querySelectorAll("[name=d]").length &&
                      N.push("name" + et + "*[*^$|!~]?="),
                    2 !== t.querySelectorAll(":enabled").length &&
                      N.push(":enabled", ":disabled"),
                    (L.appendChild(t).disabled = !0),
                    2 !== t.querySelectorAll(":disabled").length &&
                      N.push(":enabled", ":disabled"),
                    t.querySelectorAll("*,:x"),
                    N.push(",.*:");
                })),
              (x.matchesSelector = mt.test(
                (j =
                  L.matches ||
                  L.webkitMatchesSelector ||
                  L.mozMatchesSelector ||
                  L.oMatchesSelector ||
                  L.msMatchesSelector)
              )) &&
                o(function (t) {
                  (x.disconnectedMatch = j.call(t, "*")),
                    j.call(t, "[s!='']:x"),
                    M.push("!=", ot);
                }),
              (N = N.length && new RegExp(N.join("|"))),
              (M = M.length && new RegExp(M.join("|"))),
              (e = mt.test(L.compareDocumentPosition)),
              (W =
                e || mt.test(L.contains)
                  ? function (t, e) {
                      var i = 9 === t.nodeType ? t.documentElement : t,
                        n = e && e.parentNode;
                      return (
                        t === n ||
                        !(
                          !n ||
                          1 !== n.nodeType ||
                          !(i.contains
                            ? i.contains(n)
                            : t.compareDocumentPosition &&
                              16 & t.compareDocumentPosition(n))
                        )
                      );
                    }
                  : function (t, e) {
                      if (e)
                        for (; (e = e.parentNode); ) if (e === t) return !0;
                      return !1;
                    }),
              (V = e
                ? function (t, e) {
                    if (t === e) return (P = !0), 0;
                    var i =
                      !t.compareDocumentPosition - !e.compareDocumentPosition;
                    return (
                      i ||
                      (1 &
                        (i =
                          (t.ownerDocument || t) == (e.ownerDocument || e)
                            ? t.compareDocumentPosition(e)
                            : 1) ||
                      (!x.sortDetached && e.compareDocumentPosition(t) === i)
                        ? t == A || (t.ownerDocument == q && W(q, t))
                          ? -1
                          : e == A || (e.ownerDocument == q && W(q, e))
                          ? 1
                          : I
                          ? Z(I, t) - Z(I, e)
                          : 0
                        : 4 & i
                        ? -1
                        : 1)
                    );
                  }
                : function (t, e) {
                    if (t === e) return (P = !0), 0;
                    var i,
                      n = 0,
                      o = t.parentNode,
                      s = e.parentNode,
                      a = [t],
                      l = [e];
                    if (!o || !s)
                      return t == A
                        ? -1
                        : e == A
                        ? 1
                        : o
                        ? -1
                        : s
                        ? 1
                        : I
                        ? Z(I, t) - Z(I, e)
                        : 0;
                    if (o === s) return r(t, e);
                    for (i = t; (i = i.parentNode); ) a.unshift(i);
                    for (i = e; (i = i.parentNode); ) l.unshift(i);
                    for (; a[n] === l[n]; ) n++;
                    return n
                      ? r(a[n], l[n])
                      : a[n] == q
                      ? -1
                      : l[n] == q
                      ? 1
                      : 0;
                  })),
            A
          );
        }),
      (e.matches = function (t, i) {
        return e(t, null, null, i);
      }),
      (e.matchesSelector = function (t, i) {
        if (
          (D(t),
          x.matchesSelector &&
            z &&
            !U[i + " "] &&
            (!M || !M.test(i)) &&
            (!N || !N.test(i)))
        )
          try {
            var n = j.call(t, i);
            if (
              n ||
              x.disconnectedMatch ||
              (t.document && 11 !== t.document.nodeType)
            )
              return n;
          } catch (t) {
            U(i, !0);
          }
        return 0 < e(i, A, null, [t]).length;
      }),
      (e.contains = function (t, e) {
        return (t.ownerDocument || t) != A && D(t), W(t, e);
      }),
      (e.attr = function (t, e) {
        (t.ownerDocument || t) != A && D(t);
        var i = S.attrHandle[e.toLowerCase()],
          n = i && G.call(S.attrHandle, e.toLowerCase()) ? i(t, e, !z) : void 0;
        return void 0 !== n
          ? n
          : x.attributes || !z
          ? t.getAttribute(e)
          : (n = t.getAttributeNode(e)) && n.specified
          ? n.value
          : null;
      }),
      (e.escape = function (t) {
        return (t + "").replace(St, wt);
      }),
      (e.error = function (t) {
        throw new Error("Syntax error, unrecognized expression: " + t);
      }),
      (e.uniqueSort = function (t) {
        var e,
          i = [],
          n = 0,
          o = 0;
        if (
          ((P = !x.detectDuplicates),
          (I = !x.sortStable && t.slice(0)),
          t.sort(V),
          P)
        ) {
          for (; (e = t[o++]); ) e === t[o] && (n = i.push(o));
          for (; n--; ) t.splice(i[n], 1);
        }
        return (I = null), t;
      }),
      (w = e.getText =
        function (t) {
          var e,
            i = "",
            n = 0,
            o = t.nodeType;
          if (o) {
            if (1 === o || 9 === o || 11 === o) {
              if ("string" == typeof t.textContent) return t.textContent;
              for (t = t.firstChild; t; t = t.nextSibling) i += w(t);
            } else if (3 === o || 4 === o) return t.nodeValue;
          } else for (; (e = t[n++]); ) i += w(e);
          return i;
        }),
      ((S = e.selectors =
        {
          cacheLength: 50,
          createPseudo: n,
          match: dt,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: !0 },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: !0 },
            "~": { dir: "previousSibling" },
          },
          preFilter: {
            ATTR: function (t) {
              return (
                (t[1] = t[1].replace(bt, xt)),
                (t[3] = (t[3] || t[4] || t[5] || "").replace(bt, xt)),
                "~=" === t[2] && (t[3] = " " + t[3] + " "),
                t.slice(0, 4)
              );
            },
            CHILD: function (t) {
              return (
                (t[1] = t[1].toLowerCase()),
                "nth" === t[1].slice(0, 3)
                  ? (t[3] || e.error(t[0]),
                    (t[4] = +(t[4]
                      ? t[5] + (t[6] || 1)
                      : 2 * ("even" === t[3] || "odd" === t[3]))),
                    (t[5] = +(t[7] + t[8] || "odd" === t[3])))
                  : t[3] && e.error(t[0]),
                t
              );
            },
            PSEUDO: function (t) {
              var e,
                i = !t[6] && t[2];
              return dt.CHILD.test(t[0])
                ? null
                : (t[3]
                    ? (t[2] = t[4] || t[5] || "")
                    : i &&
                      ut.test(i) &&
                      (e = C(i, !0)) &&
                      (e = i.indexOf(")", i.length - e) - i.length) &&
                      ((t[0] = t[0].slice(0, e)), (t[2] = i.slice(0, e))),
                  t.slice(0, 3));
            },
          },
          filter: {
            TAG: function (t) {
              var e = t.replace(bt, xt).toLowerCase();
              return "*" === t
                ? function () {
                    return !0;
                  }
                : function (t) {
                    return t.nodeName && t.nodeName.toLowerCase() === e;
                  };
            },
            CLASS: function (t) {
              var e = R[t + " "];
              return (
                e ||
                ((e = new RegExp("(^|" + et + ")" + t + "(" + et + "|$)")) &&
                  R(t, function (t) {
                    return e.test(
                      ("string" == typeof t.className && t.className) ||
                        (void 0 !== t.getAttribute &&
                          t.getAttribute("class")) ||
                        ""
                    );
                  }))
              );
            },
            ATTR: function (t, i, n) {
              return function (o) {
                var s = e.attr(o, t);
                return null == s
                  ? "!=" === i
                  : !i ||
                      ((s += ""),
                      "=" === i
                        ? s === n
                        : "!=" === i
                        ? s !== n
                        : "^=" === i
                        ? n && 0 === s.indexOf(n)
                        : "*=" === i
                        ? n && -1 < s.indexOf(n)
                        : "$=" === i
                        ? n && s.slice(-n.length) === n
                        : "~=" === i
                        ? -1 < (" " + s.replace(st, " ") + " ").indexOf(n)
                        : "|=" === i &&
                          (s === n || s.slice(0, n.length + 1) === n + "-"));
              };
            },
            CHILD: function (t, e, i, n, o) {
              var s = "nth" !== t.slice(0, 3),
                r = "last" !== t.slice(-4),
                a = "of-type" === e;
              return 1 === n && 0 === o
                ? function (t) {
                    return !!t.parentNode;
                  }
                : function (e, i, l) {
                    var c,
                      u,
                      h,
                      d,
                      f,
                      p,
                      g = s !== r ? "nextSibling" : "previousSibling",
                      m = e.parentNode,
                      v = a && e.nodeName.toLowerCase(),
                      y = !l && !a,
                      b = !1;
                    if (m) {
                      if (s) {
                        for (; g; ) {
                          for (d = e; (d = d[g]); )
                            if (
                              a
                                ? d.nodeName.toLowerCase() === v
                                : 1 === d.nodeType
                            )
                              return !1;
                          p = g = "only" === t && !p && "nextSibling";
                        }
                        return !0;
                      }
                      if (((p = [r ? m.firstChild : m.lastChild]), r && y)) {
                        for (
                          b =
                            (f =
                              (c =
                                (u =
                                  (h = (d = m)[O] || (d[O] = {}))[d.uniqueID] ||
                                  (h[d.uniqueID] = {}))[t] || [])[0] === $ &&
                              c[1]) && c[2],
                            d = f && m.childNodes[f];
                          (d = (++f && d && d[g]) || (b = f = 0) || p.pop());

                        )
                          if (1 === d.nodeType && ++b && d === e) {
                            u[t] = [$, f, b];
                            break;
                          }
                      } else if (
                        (y &&
                          (b = f =
                            (c =
                              (u =
                                (h = (d = e)[O] || (d[O] = {}))[d.uniqueID] ||
                                (h[d.uniqueID] = {}))[t] || [])[0] === $ &&
                            c[1]),
                        !1 === b)
                      )
                        for (
                          ;
                          (d = (++f && d && d[g]) || (b = f = 0) || p.pop()) &&
                          ((a
                            ? d.nodeName.toLowerCase() !== v
                            : 1 !== d.nodeType) ||
                            !++b ||
                            (y &&
                              ((u =
                                (h = d[O] || (d[O] = {}))[d.uniqueID] ||
                                (h[d.uniqueID] = {}))[t] = [$, b]),
                            d !== e));

                        );
                      return (b -= o) === n || (b % n == 0 && 0 <= b / n);
                    }
                  };
            },
            PSEUDO: function (t, i) {
              var o,
                s =
                  S.pseudos[t] ||
                  S.setFilters[t.toLowerCase()] ||
                  e.error("unsupported pseudo: " + t);
              return s[O]
                ? s(i)
                : 1 < s.length
                ? ((o = [t, t, "", i]),
                  S.setFilters.hasOwnProperty(t.toLowerCase())
                    ? n(function (t, e) {
                        for (var n, o = s(t, i), r = o.length; r--; )
                          t[(n = Z(t, o[r]))] = !(e[n] = o[r]);
                      })
                    : function (t) {
                        return s(t, 0, o);
                      })
                : s;
            },
          },
          pseudos: {
            not: n(function (t) {
              var e = [],
                i = [],
                o = E(t.replace(rt, "$1"));
              return o[O]
                ? n(function (t, e, i, n) {
                    for (var s, r = o(t, null, n, []), a = t.length; a--; )
                      (s = r[a]) && (t[a] = !(e[a] = s));
                  })
                : function (t, n, s) {
                    return (
                      (e[0] = t), o(e, null, s, i), (e[0] = null), !i.pop()
                    );
                  };
            }),
            has: n(function (t) {
              return function (i) {
                return 0 < e(t, i).length;
              };
            }),
            contains: n(function (t) {
              return (
                (t = t.replace(bt, xt)),
                function (e) {
                  return -1 < (e.textContent || w(e)).indexOf(t);
                }
              );
            }),
            lang: n(function (t) {
              return (
                ht.test(t || "") || e.error("unsupported lang: " + t),
                (t = t.replace(bt, xt).toLowerCase()),
                function (e) {
                  var i;
                  do {
                    if (
                      (i = z
                        ? e.lang
                        : e.getAttribute("xml:lang") || e.getAttribute("lang"))
                    )
                      return (
                        (i = i.toLowerCase()) === t || 0 === i.indexOf(t + "-")
                      );
                  } while ((e = e.parentNode) && 1 === e.nodeType);
                  return !1;
                }
              );
            }),
            target: function (e) {
              var i = t.location && t.location.hash;
              return i && i.slice(1) === e.id;
            },
            root: function (t) {
              return t === L;
            },
            focus: function (t) {
              return (
                t === A.activeElement &&
                (!A.hasFocus || A.hasFocus()) &&
                !!(t.type || t.href || ~t.tabIndex)
              );
            },
            enabled: c(!1),
            disabled: c(!0),
            checked: function (t) {
              var e = t.nodeName.toLowerCase();
              return (
                ("input" === e && !!t.checked) ||
                ("option" === e && !!t.selected)
              );
            },
            selected: function (t) {
              return (
                t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
              );
            },
            empty: function (t) {
              for (t = t.firstChild; t; t = t.nextSibling)
                if (t.nodeType < 6) return !1;
              return !0;
            },
            parent: function (t) {
              return !S.pseudos.empty(t);
            },
            header: function (t) {
              return gt.test(t.nodeName);
            },
            input: function (t) {
              return pt.test(t.nodeName);
            },
            button: function (t) {
              var e = t.nodeName.toLowerCase();
              return ("input" === e && "button" === t.type) || "button" === e;
            },
            text: function (t) {
              var e;
              return (
                "input" === t.nodeName.toLowerCase() &&
                "text" === t.type &&
                (null == (e = t.getAttribute("type")) ||
                  "text" === e.toLowerCase())
              );
            },
            first: u(function () {
              return [0];
            }),
            last: u(function (t, e) {
              return [e - 1];
            }),
            eq: u(function (t, e, i) {
              return [i < 0 ? i + e : i];
            }),
            even: u(function (t, e) {
              for (var i = 0; i < e; i += 2) t.push(i);
              return t;
            }),
            odd: u(function (t, e) {
              for (var i = 1; i < e; i += 2) t.push(i);
              return t;
            }),
            lt: u(function (t, e, i) {
              for (var n = i < 0 ? i + e : e < i ? e : i; 0 <= --n; ) t.push(n);
              return t;
            }),
            gt: u(function (t, e, i) {
              for (var n = i < 0 ? i + e : i; ++n < e; ) t.push(n);
              return t;
            }),
          },
        }).pseudos.nth = S.pseudos.eq),
      { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
        S.pseudos[b] = a(b);
      for (b in { submit: !0, reset: !0 }) S.pseudos[b] = l(b);
      return (
        (d.prototype = S.filters = S.pseudos),
        (S.setFilters = new d()),
        (C = e.tokenize =
          function (t, i) {
            var n,
              o,
              s,
              r,
              a,
              l,
              c,
              u = B[t + " "];
            if (u) return i ? 0 : u.slice(0);
            for (a = t, l = [], c = S.preFilter; a; ) {
              for (r in ((n && !(o = at.exec(a))) ||
                (o && (a = a.slice(o[0].length) || a), l.push((s = []))),
              (n = !1),
              (o = lt.exec(a)) &&
                ((n = o.shift()),
                s.push({ value: n, type: o[0].replace(rt, " ") }),
                (a = a.slice(n.length))),
              S.filter))
                !(o = dt[r].exec(a)) ||
                  (c[r] && !(o = c[r](o))) ||
                  ((n = o.shift()),
                  s.push({ value: n, type: r, matches: o }),
                  (a = a.slice(n.length)));
              if (!n) break;
            }
            return i ? a.length : a ? e.error(t) : B(t, l).slice(0);
          }),
        (E = e.compile =
          function (t, i) {
            var o,
              s,
              r,
              a,
              l,
              c,
              u = [],
              h = [],
              d = F[t + " "];
            if (!d) {
              for (i || (i = C(t)), o = i.length; o--; )
                (d = y(i[o]))[O] ? u.push(d) : h.push(d);
              (d = F(
                t,
                ((s = h),
                (a = 0 < (r = u).length),
                (l = 0 < s.length),
                (c = function (t, i, n, o, c) {
                  var u,
                    h,
                    d,
                    f = 0,
                    p = "0",
                    g = t && [],
                    v = [],
                    y = k,
                    b = t || (l && S.find.TAG("*", c)),
                    x = ($ += null == y ? 1 : Math.random() || 0.1),
                    w = b.length;
                  for (
                    c && (k = i == A || i || c);
                    p !== w && null != (u = b[p]);
                    p++
                  ) {
                    if (l && u) {
                      for (
                        h = 0, i || u.ownerDocument == A || (D(u), (n = !z));
                        (d = s[h++]);

                      )
                        if (d(u, i || A, n)) {
                          o.push(u);
                          break;
                        }
                      c && ($ = x);
                    }
                    a && ((u = !d && u) && f--, t && g.push(u));
                  }
                  if (((f += p), a && p !== f)) {
                    for (h = 0; (d = r[h++]); ) d(g, v, i, n);
                    if (t) {
                      if (0 < f)
                        for (; p--; ) g[p] || v[p] || (v[p] = Y.call(o));
                      v = m(v);
                    }
                    J.apply(o, v),
                      c &&
                        !t &&
                        0 < v.length &&
                        1 < f + r.length &&
                        e.uniqueSort(o);
                  }
                  return c && (($ = x), (k = y)), g;
                }),
                a ? n(c) : c)
              )).selector = t;
            }
            return d;
          }),
        (_ = e.select =
          function (t, e, i, n) {
            var o,
              s,
              r,
              a,
              l,
              c = "function" == typeof t && t,
              u = !n && C((t = c.selector || t));
            if (((i = i || []), 1 === u.length)) {
              if (
                2 < (s = u[0] = u[0].slice(0)).length &&
                "ID" === (r = s[0]).type &&
                9 === e.nodeType &&
                z &&
                S.relative[s[1].type]
              ) {
                if (
                  !(e = (S.find.ID(r.matches[0].replace(bt, xt), e) || [])[0])
                )
                  return i;
                c && (e = e.parentNode), (t = t.slice(s.shift().value.length));
              }
              for (
                o = dt.needsContext.test(t) ? 0 : s.length;
                o-- && ((r = s[o]), !S.relative[(a = r.type)]);

              )
                if (
                  (l = S.find[a]) &&
                  (n = l(
                    r.matches[0].replace(bt, xt),
                    (yt.test(s[0].type) && h(e.parentNode)) || e
                  ))
                ) {
                  if ((s.splice(o, 1), !(t = n.length && f(s))))
                    return J.apply(i, n), i;
                  break;
                }
            }
            return (
              (c || E(t, u))(
                n,
                e,
                !z,
                i,
                !e || (yt.test(t) && h(e.parentNode)) || e
              ),
              i
            );
          }),
        (x.sortStable = O.split("").sort(V).join("") === O),
        (x.detectDuplicates = !!P),
        D(),
        (x.sortDetached = o(function (t) {
          return 1 & t.compareDocumentPosition(A.createElement("fieldset"));
        })),
        o(function (t) {
          return (
            (t.innerHTML = "<a href='#'></a>"),
            "#" === t.firstChild.getAttribute("href")
          );
        }) ||
          s("type|href|height|width", function (t, e, i) {
            if (!i)
              return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2);
          }),
        (x.attributes &&
          o(function (t) {
            return (
              (t.innerHTML = "<input/>"),
              t.firstChild.setAttribute("value", ""),
              "" === t.firstChild.getAttribute("value")
            );
          })) ||
          s("value", function (t, e, i) {
            if (!i && "input" === t.nodeName.toLowerCase())
              return t.defaultValue;
          }),
        o(function (t) {
          return null == t.getAttribute("disabled");
        }) ||
          s(tt, function (t, e, i) {
            var n;
            if (!i)
              return !0 === t[e]
                ? e.toLowerCase()
                : (n = t.getAttributeNode(e)) && n.specified
                ? n.value
                : null;
          }),
        e
      );
    })(t);
    (pt.find = gt),
      (pt.expr = gt.selectors),
      (pt.expr[":"] = pt.expr.pseudos),
      (pt.uniqueSort = pt.unique = gt.uniqueSort),
      (pt.text = gt.getText),
      (pt.isXMLDoc = gt.isXML),
      (pt.contains = gt.contains),
      (pt.escapeSelector = gt.escape);
    var mt = function (t, e, i) {
        for (var n = [], o = void 0 !== i; (t = t[e]) && 9 !== t.nodeType; )
          if (1 === t.nodeType) {
            if (o && pt(t).is(i)) break;
            n.push(t);
          }
        return n;
      },
      vt = function (t, e) {
        for (var i = []; t; t = t.nextSibling)
          1 === t.nodeType && t !== e && i.push(t);
        return i;
      },
      yt = pt.expr.match.needsContext,
      bt = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    (pt.filter = function (t, e, i) {
      var n = e[0];
      return (
        i && (t = ":not(" + t + ")"),
        1 === e.length && 1 === n.nodeType
          ? pt.find.matchesSelector(n, t)
            ? [n]
            : []
          : pt.find.matches(
              t,
              pt.grep(e, function (t) {
                return 1 === t.nodeType;
              })
            )
      );
    }),
      pt.fn.extend({
        find: function (t) {
          var e,
            i,
            n = this.length,
            o = this;
          if ("string" != typeof t)
            return this.pushStack(
              pt(t).filter(function () {
                for (e = 0; e < n; e++) if (pt.contains(o[e], this)) return !0;
              })
            );
          for (i = this.pushStack([]), e = 0; e < n; e++) pt.find(t, o[e], i);
          return 1 < n ? pt.uniqueSort(i) : i;
        },
        filter: function (t) {
          return this.pushStack(r(this, t || [], !1));
        },
        not: function (t) {
          return this.pushStack(r(this, t || [], !0));
        },
        is: function (t) {
          return !!r(
            this,
            "string" == typeof t && yt.test(t) ? pt(t) : t || [],
            !1
          ).length;
        },
      });
    var xt,
      St = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    ((pt.fn.init = function (t, e, i) {
      var n, o;
      if (!t) return this;
      if (((i = i || xt), "string" == typeof t)) {
        if (
          !(n =
            "<" === t[0] && ">" === t[t.length - 1] && 3 <= t.length
              ? [null, t, null]
              : St.exec(t)) ||
          (!n[1] && e)
        )
          return !e || e.jquery
            ? (e || i).find(t)
            : this.constructor(e).find(t);
        if (n[1]) {
          if (
            ((e = e instanceof pt ? e[0] : e),
            pt.merge(
              this,
              pt.parseHTML(
                n[1],
                e && e.nodeType ? e.ownerDocument || e : ht,
                !0
              )
            ),
            bt.test(n[1]) && pt.isPlainObject(e))
          )
            for (n in e) ct(this[n]) ? this[n](e[n]) : this.attr(n, e[n]);
          return this;
        }
        return (
          (o = ht.getElementById(n[2])) && ((this[0] = o), (this.length = 1)),
          this
        );
      }
      return t.nodeType
        ? ((this[0] = t), (this.length = 1), this)
        : ct(t)
        ? void 0 !== i.ready
          ? i.ready(t)
          : t(pt)
        : pt.makeArray(t, this);
    }).prototype = pt.fn),
      (xt = pt(ht));
    var wt = /^(?:parents|prev(?:Until|All))/,
      Tt = { children: !0, contents: !0, next: !0, prev: !0 };
    pt.fn.extend({
      has: function (t) {
        var e = pt(t, this),
          i = e.length;
        return this.filter(function () {
          for (var t = 0; t < i; t++) if (pt.contains(this, e[t])) return !0;
        });
      },
      closest: function (t, e) {
        var i,
          n = 0,
          o = this.length,
          s = [],
          r = "string" != typeof t && pt(t);
        if (!yt.test(t))
          for (; n < o; n++)
            for (i = this[n]; i && i !== e; i = i.parentNode)
              if (
                i.nodeType < 11 &&
                (r
                  ? -1 < r.index(i)
                  : 1 === i.nodeType && pt.find.matchesSelector(i, t))
              ) {
                s.push(i);
                break;
              }
        return this.pushStack(1 < s.length ? pt.uniqueSort(s) : s);
      },
      index: function (t) {
        return t
          ? "string" == typeof t
            ? it.call(pt(t), this[0])
            : it.call(this, t.jquery ? t[0] : t)
          : this[0] && this[0].parentNode
          ? this.first().prevAll().length
          : -1;
      },
      add: function (t, e) {
        return this.pushStack(pt.uniqueSort(pt.merge(this.get(), pt(t, e))));
      },
      addBack: function (t) {
        return this.add(
          null == t ? this.prevObject : this.prevObject.filter(t)
        );
      },
    }),
      pt.each(
        {
          parent: function (t) {
            var e = t.parentNode;
            return e && 11 !== e.nodeType ? e : null;
          },
          parents: function (t) {
            return mt(t, "parentNode");
          },
          parentsUntil: function (t, e, i) {
            return mt(t, "parentNode", i);
          },
          next: function (t) {
            return a(t, "nextSibling");
          },
          prev: function (t) {
            return a(t, "previousSibling");
          },
          nextAll: function (t) {
            return mt(t, "nextSibling");
          },
          prevAll: function (t) {
            return mt(t, "previousSibling");
          },
          nextUntil: function (t, e, i) {
            return mt(t, "nextSibling", i);
          },
          prevUntil: function (t, e, i) {
            return mt(t, "previousSibling", i);
          },
          siblings: function (t) {
            return vt((t.parentNode || {}).firstChild, t);
          },
          children: function (t) {
            return vt(t.firstChild);
          },
          contents: function (t) {
            return null != t.contentDocument && K(t.contentDocument)
              ? t.contentDocument
              : (s(t, "template") && (t = t.content || t),
                pt.merge([], t.childNodes));
          },
        },
        function (t, e) {
          pt.fn[t] = function (i, n) {
            var o = pt.map(this, e, i);
            return (
              "Until" !== t.slice(-5) && (n = i),
              n && "string" == typeof n && (o = pt.filter(n, o)),
              1 < this.length &&
                (Tt[t] || pt.uniqueSort(o), wt.test(t) && o.reverse()),
              this.pushStack(o)
            );
          };
        }
      );
    var Ct = /[^\x20\t\r\n\f]+/g;
    (pt.Callbacks = function (t) {
      var e, i;
      t =
        "string" == typeof t
          ? ((e = t),
            (i = {}),
            pt.each(e.match(Ct) || [], function (t, e) {
              i[e] = !0;
            }),
            i)
          : pt.extend({}, t);
      var o,
        s,
        r,
        a,
        l = [],
        c = [],
        u = -1,
        h = function () {
          for (a = a || t.once, r = o = !0; c.length; u = -1)
            for (s = c.shift(); ++u < l.length; )
              !1 === l[u].apply(s[0], s[1]) &&
                t.stopOnFalse &&
                ((u = l.length), (s = !1));
          t.memory || (s = !1), (o = !1), a && (l = s ? [] : "");
        },
        d = {
          add: function () {
            return (
              l &&
                (s && !o && ((u = l.length - 1), c.push(s)),
                (function e(i) {
                  pt.each(i, function (i, o) {
                    ct(o)
                      ? (t.unique && d.has(o)) || l.push(o)
                      : o && o.length && "string" !== n(o) && e(o);
                  });
                })(arguments),
                s && !o && h()),
              this
            );
          },
          remove: function () {
            return (
              pt.each(arguments, function (t, e) {
                for (var i; -1 < (i = pt.inArray(e, l, i)); )
                  l.splice(i, 1), i <= u && u--;
              }),
              this
            );
          },
          has: function (t) {
            return t ? -1 < pt.inArray(t, l) : 0 < l.length;
          },
          empty: function () {
            return l && (l = []), this;
          },
          disable: function () {
            return (a = c = []), (l = s = ""), this;
          },
          disabled: function () {
            return !l;
          },
          lock: function () {
            return (a = c = []), s || o || (l = s = ""), this;
          },
          locked: function () {
            return !!a;
          },
          fireWith: function (t, e) {
            return (
              a ||
                ((e = [t, (e = e || []).slice ? e.slice() : e]),
                c.push(e),
                o || h()),
              this
            );
          },
          fire: function () {
            return d.fireWith(this, arguments), this;
          },
          fired: function () {
            return !!r;
          },
        };
      return d;
    }),
      pt.extend({
        Deferred: function (e) {
          var i = [
              [
                "notify",
                "progress",
                pt.Callbacks("memory"),
                pt.Callbacks("memory"),
                2,
              ],
              [
                "resolve",
                "done",
                pt.Callbacks("once memory"),
                pt.Callbacks("once memory"),
                0,
                "resolved",
              ],
              [
                "reject",
                "fail",
                pt.Callbacks("once memory"),
                pt.Callbacks("once memory"),
                1,
                "rejected",
              ],
            ],
            n = "pending",
            o = {
              state: function () {
                return n;
              },
              always: function () {
                return s.done(arguments).fail(arguments), this;
              },
              catch: function (t) {
                return o.then(null, t);
              },
              pipe: function () {
                var t = arguments;
                return pt
                  .Deferred(function (e) {
                    pt.each(i, function (i, n) {
                      var o = ct(t[n[4]]) && t[n[4]];
                      s[n[1]](function () {
                        var t = o && o.apply(this, arguments);
                        t && ct(t.promise)
                          ? t
                              .promise()
                              .progress(e.notify)
                              .done(e.resolve)
                              .fail(e.reject)
                          : e[n[0] + "With"](this, o ? [t] : arguments);
                      });
                    }),
                      (t = null);
                  })
                  .promise();
              },
              then: function (e, n, o) {
                function s(e, i, n, o) {
                  return function () {
                    var a = this,
                      u = arguments,
                      h = function () {
                        var t, h;
                        if (!(e < r)) {
                          if ((t = n.apply(a, u)) === i.promise())
                            throw new TypeError("Thenable self-resolution");
                          (h =
                            t &&
                            ("object" == typeof t || "function" == typeof t) &&
                            t.then),
                            ct(h)
                              ? o
                                ? h.call(t, s(r, i, l, o), s(r, i, c, o))
                                : (r++,
                                  h.call(
                                    t,
                                    s(r, i, l, o),
                                    s(r, i, c, o),
                                    s(r, i, l, i.notifyWith)
                                  ))
                              : (n !== l && ((a = void 0), (u = [t])),
                                (o || i.resolveWith)(a, u));
                        }
                      },
                      d = o
                        ? h
                        : function () {
                            try {
                              h();
                            } catch (t) {
                              pt.Deferred.exceptionHook &&
                                pt.Deferred.exceptionHook(t, d.stackTrace),
                                r <= e + 1 &&
                                  (n !== c && ((a = void 0), (u = [t])),
                                  i.rejectWith(a, u));
                            }
                          };
                    e
                      ? d()
                      : (pt.Deferred.getStackHook &&
                          (d.stackTrace = pt.Deferred.getStackHook()),
                        t.setTimeout(d));
                  };
                }
                var r = 0;
                return pt
                  .Deferred(function (t) {
                    i[0][3].add(s(0, t, ct(o) ? o : l, t.notifyWith)),
                      i[1][3].add(s(0, t, ct(e) ? e : l)),
                      i[2][3].add(s(0, t, ct(n) ? n : c));
                  })
                  .promise();
              },
              promise: function (t) {
                return null != t ? pt.extend(t, o) : o;
              },
            },
            s = {};
          return (
            pt.each(i, function (t, e) {
              var r = e[2],
                a = e[5];
              (o[e[1]] = r.add),
                a &&
                  r.add(
                    function () {
                      n = a;
                    },
                    i[3 - t][2].disable,
                    i[3 - t][3].disable,
                    i[0][2].lock,
                    i[0][3].lock
                  ),
                r.add(e[3].fire),
                (s[e[0]] = function () {
                  return (
                    s[e[0] + "With"](this === s ? void 0 : this, arguments),
                    this
                  );
                }),
                (s[e[0] + "With"] = r.fireWith);
            }),
            o.promise(s),
            e && e.call(s, s),
            s
          );
        },
        when: function (t) {
          var e = arguments.length,
            i = e,
            n = Array(i),
            o = Z.call(arguments),
            s = pt.Deferred(),
            r = function (t) {
              return function (i) {
                (n[t] = this),
                  (o[t] = 1 < arguments.length ? Z.call(arguments) : i),
                  --e || s.resolveWith(n, o);
              };
            };
          if (
            e <= 1 &&
            (u(t, s.done(r(i)).resolve, s.reject, !e),
            "pending" === s.state() || ct(o[i] && o[i].then))
          )
            return s.then();
          for (; i--; ) u(o[i], r(i), s.reject);
          return s.promise();
        },
      });
    var Et = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    (pt.Deferred.exceptionHook = function (e, i) {
      t.console &&
        t.console.warn &&
        e &&
        Et.test(e.name) &&
        t.console.warn("jQuery.Deferred exception: " + e.message, e.stack, i);
    }),
      (pt.readyException = function (e) {
        t.setTimeout(function () {
          throw e;
        });
      });
    var _t = pt.Deferred();
    (pt.fn.ready = function (t) {
      return (
        _t.then(t).catch(function (t) {
          pt.readyException(t);
        }),
        this
      );
    }),
      pt.extend({
        isReady: !1,
        readyWait: 1,
        ready: function (t) {
          (!0 === t ? --pt.readyWait : pt.isReady) ||
            ((pt.isReady = !0) !== t && 0 < --pt.readyWait) ||
            _t.resolveWith(ht, [pt]);
        },
      }),
      (pt.ready.then = _t.then),
      "complete" === ht.readyState ||
      ("loading" !== ht.readyState && !ht.documentElement.doScroll)
        ? t.setTimeout(pt.ready)
        : (ht.addEventListener("DOMContentLoaded", h),
          t.addEventListener("load", h));
    var kt = function (t, e, i, o, s, r, a) {
        var l = 0,
          c = t.length,
          u = null == i;
        if ("object" === n(i))
          for (l in ((s = !0), i)) kt(t, e, l, i[l], !0, r, a);
        else if (
          void 0 !== o &&
          ((s = !0),
          ct(o) || (a = !0),
          u &&
            (a
              ? (e.call(t, o), (e = null))
              : ((u = e),
                (e = function (t, e, i) {
                  return u.call(pt(t), i);
                }))),
          e)
        )
          for (; l < c; l++) e(t[l], i, a ? o : o.call(t[l], l, e(t[l], i)));
        return s ? t : u ? e.call(t) : c ? e(t[0], i) : r;
      },
      It = /^-ms-/,
      Pt = /-([a-z])/g,
      Dt = function (t) {
        return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType;
      };
    (p.uid = 1),
      (p.prototype = {
        cache: function (t) {
          var e = t[this.expando];
          return (
            e ||
              ((e = {}),
              Dt(t) &&
                (t.nodeType
                  ? (t[this.expando] = e)
                  : Object.defineProperty(t, this.expando, {
                      value: e,
                      configurable: !0,
                    }))),
            e
          );
        },
        set: function (t, e, i) {
          var n,
            o = this.cache(t);
          if ("string" == typeof e) o[f(e)] = i;
          else for (n in e) o[f(n)] = e[n];
          return o;
        },
        get: function (t, e) {
          return void 0 === e
            ? this.cache(t)
            : t[this.expando] && t[this.expando][f(e)];
        },
        access: function (t, e, i) {
          return void 0 === e || (e && "string" == typeof e && void 0 === i)
            ? this.get(t, e)
            : (this.set(t, e, i), void 0 !== i ? i : e);
        },
        remove: function (t, e) {
          var i,
            n = t[this.expando];
          if (void 0 !== n) {
            if (void 0 !== e) {
              i = (e = Array.isArray(e)
                ? e.map(f)
                : (e = f(e)) in n
                ? [e]
                : e.match(Ct) || []).length;
              for (; i--; ) delete n[e[i]];
            }
            (void 0 === e || pt.isEmptyObject(n)) &&
              (t.nodeType
                ? (t[this.expando] = void 0)
                : delete t[this.expando]);
          }
        },
        hasData: function (t) {
          var e = t[this.expando];
          return void 0 !== e && !pt.isEmptyObject(e);
        },
      });
    var At = new p(),
      Lt = new p(),
      zt = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      Nt = /[A-Z]/g;
    pt.extend({
      hasData: function (t) {
        return Lt.hasData(t) || At.hasData(t);
      },
      data: function (t, e, i) {
        return Lt.access(t, e, i);
      },
      removeData: function (t, e) {
        Lt.remove(t, e);
      },
      _data: function (t, e, i) {
        return At.access(t, e, i);
      },
      _removeData: function (t, e) {
        At.remove(t, e);
      },
    }),
      pt.fn.extend({
        data: function (t, e) {
          var i,
            n,
            o,
            s = this[0],
            r = s && s.attributes;
          if (void 0 === t) {
            if (
              this.length &&
              ((o = Lt.get(s)), 1 === s.nodeType && !At.get(s, "hasDataAttrs"))
            ) {
              for (i = r.length; i--; )
                r[i] &&
                  0 === (n = r[i].name).indexOf("data-") &&
                  ((n = f(n.slice(5))), g(s, n, o[n]));
              At.set(s, "hasDataAttrs", !0);
            }
            return o;
          }
          return "object" == typeof t
            ? this.each(function () {
                Lt.set(this, t);
              })
            : kt(
                this,
                function (e) {
                  var i;
                  if (s && void 0 === e)
                    return void 0 !== (i = Lt.get(s, t))
                      ? i
                      : void 0 !== (i = g(s, t))
                      ? i
                      : void 0;
                  this.each(function () {
                    Lt.set(this, t, e);
                  });
                },
                null,
                e,
                1 < arguments.length,
                null,
                !0
              );
        },
        removeData: function (t) {
          return this.each(function () {
            Lt.remove(this, t);
          });
        },
      }),
      pt.extend({
        queue: function (t, e, i) {
          var n;
          if (t)
            return (
              (e = (e || "fx") + "queue"),
              (n = At.get(t, e)),
              i &&
                (!n || Array.isArray(i)
                  ? (n = At.access(t, e, pt.makeArray(i)))
                  : n.push(i)),
              n || []
            );
        },
        dequeue: function (t, e) {
          e = e || "fx";
          var i = pt.queue(t, e),
            n = i.length,
            o = i.shift(),
            s = pt._queueHooks(t, e);
          "inprogress" === o && ((o = i.shift()), n--),
            o &&
              ("fx" === e && i.unshift("inprogress"),
              delete s.stop,
              o.call(
                t,
                function () {
                  pt.dequeue(t, e);
                },
                s
              )),
            !n && s && s.empty.fire();
        },
        _queueHooks: function (t, e) {
          var i = e + "queueHooks";
          return (
            At.get(t, i) ||
            At.access(t, i, {
              empty: pt.Callbacks("once memory").add(function () {
                At.remove(t, [e + "queue", i]);
              }),
            })
          );
        },
      }),
      pt.fn.extend({
        queue: function (t, e) {
          var i = 2;
          return (
            "string" != typeof t && ((e = t), (t = "fx"), i--),
            arguments.length < i
              ? pt.queue(this[0], t)
              : void 0 === e
              ? this
              : this.each(function () {
                  var i = pt.queue(this, t, e);
                  pt._queueHooks(this, t),
                    "fx" === t && "inprogress" !== i[0] && pt.dequeue(this, t);
                })
          );
        },
        dequeue: function (t) {
          return this.each(function () {
            pt.dequeue(this, t);
          });
        },
        clearQueue: function (t) {
          return this.queue(t || "fx", []);
        },
        promise: function (t, e) {
          var i,
            n = 1,
            o = pt.Deferred(),
            s = this,
            r = this.length,
            a = function () {
              --n || o.resolveWith(s, [s]);
            };
          for (
            "string" != typeof t && ((e = t), (t = void 0)), t = t || "fx";
            r--;

          )
            (i = At.get(s[r], t + "queueHooks")) &&
              i.empty &&
              (n++, i.empty.add(a));
          return a(), o.promise(e);
        },
      });
    var Mt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      jt = new RegExp("^(?:([+-])=|)(" + Mt + ")([a-z%]*)$", "i"),
      Wt = ["Top", "Right", "Bottom", "Left"],
      Ot = ht.documentElement,
      qt = function (t) {
        return pt.contains(t.ownerDocument, t);
      },
      $t = { composed: !0 };
    Ot.getRootNode &&
      (qt = function (t) {
        return (
          pt.contains(t.ownerDocument, t) ||
          t.getRootNode($t) === t.ownerDocument
        );
      });
    var Ht = function (t, e) {
        return (
          "none" === (t = e || t).style.display ||
          ("" === t.style.display && qt(t) && "none" === pt.css(t, "display"))
        );
      },
      Rt = {};
    pt.fn.extend({
      show: function () {
        return v(this, !0);
      },
      hide: function () {
        return v(this);
      },
      toggle: function (t) {
        return "boolean" == typeof t
          ? t
            ? this.show()
            : this.hide()
          : this.each(function () {
              Ht(this) ? pt(this).show() : pt(this).hide();
            });
      },
    });
    var Bt,
      Ft,
      Ut = /^(?:checkbox|radio)$/i,
      Vt = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
      Gt = /^$|^module$|\/(?:java|ecma)script/i;
    (Bt = ht.createDocumentFragment().appendChild(ht.createElement("div"))),
      (Ft = ht.createElement("input")).setAttribute("type", "radio"),
      Ft.setAttribute("checked", "checked"),
      Ft.setAttribute("name", "t"),
      Bt.appendChild(Ft),
      (lt.checkClone = Bt.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (Bt.innerHTML = "<textarea>x</textarea>"),
      (lt.noCloneChecked = !!Bt.cloneNode(!0).lastChild.defaultValue),
      (Bt.innerHTML = "<option></option>"),
      (lt.option = !!Bt.lastChild);
    var Xt = {
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""],
    };
    (Xt.tbody = Xt.tfoot = Xt.colgroup = Xt.caption = Xt.thead),
      (Xt.th = Xt.td),
      lt.option ||
        (Xt.optgroup = Xt.option =
          [1, "<select multiple='multiple'>", "</select>"]);
    var Yt = /<|&#?\w+;/,
      Qt = /^([^.]*)(?:\.(.+)|)/;
    (pt.event = {
      global: {},
      add: function (t, e, i, n, o) {
        var s,
          r,
          a,
          l,
          c,
          u,
          h,
          d,
          f,
          p,
          g,
          m = At.get(t);
        if (Dt(t))
          for (
            i.handler && ((i = (s = i).handler), (o = s.selector)),
              o && pt.find.matchesSelector(Ot, o),
              i.guid || (i.guid = pt.guid++),
              (l = m.events) || (l = m.events = Object.create(null)),
              (r = m.handle) ||
                (r = m.handle =
                  function (e) {
                    return void 0 !== pt && pt.event.triggered !== e.type
                      ? pt.event.dispatch.apply(t, arguments)
                      : void 0;
                  }),
              c = (e = (e || "").match(Ct) || [""]).length;
            c--;

          )
            (f = g = (a = Qt.exec(e[c]) || [])[1]),
              (p = (a[2] || "").split(".").sort()),
              f &&
                ((h = pt.event.special[f] || {}),
                (f = (o ? h.delegateType : h.bindType) || f),
                (h = pt.event.special[f] || {}),
                (u = pt.extend(
                  {
                    type: f,
                    origType: g,
                    data: n,
                    handler: i,
                    guid: i.guid,
                    selector: o,
                    needsContext: o && pt.expr.match.needsContext.test(o),
                    namespace: p.join("."),
                  },
                  s
                )),
                (d = l[f]) ||
                  (((d = l[f] = []).delegateCount = 0),
                  (h.setup && !1 !== h.setup.call(t, n, p, r)) ||
                    (t.addEventListener && t.addEventListener(f, r))),
                h.add &&
                  (h.add.call(t, u),
                  u.handler.guid || (u.handler.guid = i.guid)),
                o ? d.splice(d.delegateCount++, 0, u) : d.push(u),
                (pt.event.global[f] = !0));
      },
      remove: function (t, e, i, n, o) {
        var s,
          r,
          a,
          l,
          c,
          u,
          h,
          d,
          f,
          p,
          g,
          m = At.hasData(t) && At.get(t);
        if (m && (l = m.events)) {
          for (c = (e = (e || "").match(Ct) || [""]).length; c--; )
            if (
              ((f = g = (a = Qt.exec(e[c]) || [])[1]),
              (p = (a[2] || "").split(".").sort()),
              f)
            ) {
              for (
                h = pt.event.special[f] || {},
                  d = l[(f = (n ? h.delegateType : h.bindType) || f)] || [],
                  a =
                    a[2] &&
                    new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                  r = s = d.length;
                s--;

              )
                (u = d[s]),
                  (!o && g !== u.origType) ||
                    (i && i.guid !== u.guid) ||
                    (a && !a.test(u.namespace)) ||
                    (n && n !== u.selector && ("**" !== n || !u.selector)) ||
                    (d.splice(s, 1),
                    u.selector && d.delegateCount--,
                    h.remove && h.remove.call(t, u));
              r &&
                !d.length &&
                ((h.teardown && !1 !== h.teardown.call(t, p, m.handle)) ||
                  pt.removeEvent(t, f, m.handle),
                delete l[f]);
            } else for (f in l) pt.event.remove(t, f + e[c], i, n, !0);
          pt.isEmptyObject(l) && At.remove(t, "handle events");
        }
      },
      dispatch: function (t) {
        var e,
          i,
          n,
          o,
          s,
          r,
          a = new Array(arguments.length),
          l = pt.event.fix(t),
          c = (At.get(this, "events") || Object.create(null))[l.type] || [],
          u = pt.event.special[l.type] || {};
        for (a[0] = l, e = 1; e < arguments.length; e++) a[e] = arguments[e];
        if (
          ((l.delegateTarget = this),
          !u.preDispatch || !1 !== u.preDispatch.call(this, l))
        ) {
          for (
            r = pt.event.handlers.call(this, l, c), e = 0;
            (o = r[e++]) && !l.isPropagationStopped();

          )
            for (
              l.currentTarget = o.elem, i = 0;
              (s = o.handlers[i++]) && !l.isImmediatePropagationStopped();

            )
              (l.rnamespace &&
                !1 !== s.namespace &&
                !l.rnamespace.test(s.namespace)) ||
                ((l.handleObj = s),
                (l.data = s.data),
                void 0 !==
                  (n = (
                    (pt.event.special[s.origType] || {}).handle || s.handler
                  ).apply(o.elem, a)) &&
                  !1 === (l.result = n) &&
                  (l.preventDefault(), l.stopPropagation()));
          return u.postDispatch && u.postDispatch.call(this, l), l.result;
        }
      },
      handlers: function (t, e) {
        var i,
          n,
          o,
          s,
          r,
          a = [],
          l = e.delegateCount,
          c = t.target;
        if (l && c.nodeType && !("click" === t.type && 1 <= t.button))
          for (; c !== this; c = c.parentNode || this)
            if (1 === c.nodeType && ("click" !== t.type || !0 !== c.disabled)) {
              for (s = [], r = {}, i = 0; i < l; i++)
                void 0 === r[(o = (n = e[i]).selector + " ")] &&
                  (r[o] = n.needsContext
                    ? -1 < pt(o, this).index(c)
                    : pt.find(o, this, null, [c]).length),
                  r[o] && s.push(n);
              s.length && a.push({ elem: c, handlers: s });
            }
        return (
          (c = this),
          l < e.length && a.push({ elem: c, handlers: e.slice(l) }),
          a
        );
      },
      addProp: function (t, e) {
        Object.defineProperty(pt.Event.prototype, t, {
          enumerable: !0,
          configurable: !0,
          get: ct(e)
            ? function () {
                if (this.originalEvent) return e(this.originalEvent);
              }
            : function () {
                if (this.originalEvent) return this.originalEvent[t];
              },
          set: function (e) {
            Object.defineProperty(this, t, {
              enumerable: !0,
              configurable: !0,
              writable: !0,
              value: e,
            });
          },
        });
      },
      fix: function (t) {
        return t[pt.expando] ? t : new pt.Event(t);
      },
      special: {
        load: { noBubble: !0 },
        click: {
          setup: function (t) {
            var e = this || t;
            return (
              Ut.test(e.type) && e.click && s(e, "input") && E(e, "click", S),
              !1
            );
          },
          trigger: function (t) {
            var e = this || t;
            return (
              Ut.test(e.type) && e.click && s(e, "input") && E(e, "click"), !0
            );
          },
          _default: function (t) {
            var e = t.target;
            return (
              (Ut.test(e.type) &&
                e.click &&
                s(e, "input") &&
                At.get(e, "click")) ||
              s(e, "a")
            );
          },
        },
        beforeunload: {
          postDispatch: function (t) {
            void 0 !== t.result &&
              t.originalEvent &&
              (t.originalEvent.returnValue = t.result);
          },
        },
      },
    }),
      (pt.removeEvent = function (t, e, i) {
        t.removeEventListener && t.removeEventListener(e, i);
      }),
      (pt.Event = function (t, e) {
        if (!(this instanceof pt.Event)) return new pt.Event(t, e);
        t && t.type
          ? ((this.originalEvent = t),
            (this.type = t.type),
            (this.isDefaultPrevented =
              t.defaultPrevented ||
              (void 0 === t.defaultPrevented && !1 === t.returnValue)
                ? S
                : w),
            (this.target =
              t.target && 3 === t.target.nodeType
                ? t.target.parentNode
                : t.target),
            (this.currentTarget = t.currentTarget),
            (this.relatedTarget = t.relatedTarget))
          : (this.type = t),
          e && pt.extend(this, e),
          (this.timeStamp = (t && t.timeStamp) || Date.now()),
          (this[pt.expando] = !0);
      }),
      (pt.Event.prototype = {
        constructor: pt.Event,
        isDefaultPrevented: w,
        isPropagationStopped: w,
        isImmediatePropagationStopped: w,
        isSimulated: !1,
        preventDefault: function () {
          var t = this.originalEvent;
          (this.isDefaultPrevented = S),
            t && !this.isSimulated && t.preventDefault();
        },
        stopPropagation: function () {
          var t = this.originalEvent;
          (this.isPropagationStopped = S),
            t && !this.isSimulated && t.stopPropagation();
        },
        stopImmediatePropagation: function () {
          var t = this.originalEvent;
          (this.isImmediatePropagationStopped = S),
            t && !this.isSimulated && t.stopImmediatePropagation(),
            this.stopPropagation();
        },
      }),
      pt.each(
        {
          altKey: !0,
          bubbles: !0,
          cancelable: !0,
          changedTouches: !0,
          ctrlKey: !0,
          detail: !0,
          eventPhase: !0,
          metaKey: !0,
          pageX: !0,
          pageY: !0,
          shiftKey: !0,
          view: !0,
          char: !0,
          code: !0,
          charCode: !0,
          key: !0,
          keyCode: !0,
          button: !0,
          buttons: !0,
          clientX: !0,
          clientY: !0,
          offsetX: !0,
          offsetY: !0,
          pointerId: !0,
          pointerType: !0,
          screenX: !0,
          screenY: !0,
          targetTouches: !0,
          toElement: !0,
          touches: !0,
          which: !0,
        },
        pt.event.addProp
      ),
      pt.each({ focus: "focusin", blur: "focusout" }, function (t, e) {
        pt.event.special[t] = {
          setup: function () {
            return E(this, t, T), !1;
          },
          trigger: function () {
            return E(this, t), !0;
          },
          _default: function () {
            return !0;
          },
          delegateType: e,
        };
      }),
      pt.each(
        {
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout",
        },
        function (t, e) {
          pt.event.special[t] = {
            delegateType: e,
            bindType: e,
            handle: function (t) {
              var i,
                n = t.relatedTarget,
                o = t.handleObj;
              return (
                (n && (n === this || pt.contains(this, n))) ||
                  ((t.type = o.origType),
                  (i = o.handler.apply(this, arguments)),
                  (t.type = e)),
                i
              );
            },
          };
        }
      ),
      pt.fn.extend({
        on: function (t, e, i, n) {
          return C(this, t, e, i, n);
        },
        one: function (t, e, i, n) {
          return C(this, t, e, i, n, 1);
        },
        off: function (t, e, i) {
          var n, o;
          if (t && t.preventDefault && t.handleObj)
            return (
              (n = t.handleObj),
              pt(t.delegateTarget).off(
                n.namespace ? n.origType + "." + n.namespace : n.origType,
                n.selector,
                n.handler
              ),
              this
            );
          if ("object" == typeof t) {
            for (o in t) this.off(o, e, t[o]);
            return this;
          }
          return (
            (!1 !== e && "function" != typeof e) || ((i = e), (e = void 0)),
            !1 === i && (i = w),
            this.each(function () {
              pt.event.remove(this, t, i, e);
            })
          );
        },
      });
    var Jt = /<script|<style|<link/i,
      Kt = /checked\s*(?:[^=]|=\s*.checked.)/i,
      Zt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    pt.extend({
      htmlPrefilter: function (t) {
        return t;
      },
      clone: function (t, e, i) {
        var n,
          o,
          s,
          r,
          a,
          l,
          c,
          u = t.cloneNode(!0),
          h = qt(t);
        if (
          !(
            lt.noCloneChecked ||
            (1 !== t.nodeType && 11 !== t.nodeType) ||
            pt.isXMLDoc(t)
          )
        )
          for (r = y(u), n = 0, o = (s = y(t)).length; n < o; n++)
            (a = s[n]),
              (l = r[n]),
              "input" === (c = l.nodeName.toLowerCase()) && Ut.test(a.type)
                ? (l.checked = a.checked)
                : ("input" !== c && "textarea" !== c) ||
                  (l.defaultValue = a.defaultValue);
        if (e)
          if (i)
            for (s = s || y(t), r = r || y(u), n = 0, o = s.length; n < o; n++)
              P(s[n], r[n]);
          else P(t, u);
        return 0 < (r = y(u, "script")).length && b(r, !h && y(t, "script")), u;
      },
      cleanData: function (t) {
        for (
          var e, i, n, o = pt.event.special, s = 0;
          void 0 !== (i = t[s]);
          s++
        )
          if (Dt(i)) {
            if ((e = i[At.expando])) {
              if (e.events)
                for (n in e.events)
                  o[n] ? pt.event.remove(i, n) : pt.removeEvent(i, n, e.handle);
              i[At.expando] = void 0;
            }
            i[Lt.expando] && (i[Lt.expando] = void 0);
          }
      },
    }),
      pt.fn.extend({
        detach: function (t) {
          return A(this, t, !0);
        },
        remove: function (t) {
          return A(this, t);
        },
        text: function (t) {
          return kt(
            this,
            function (t) {
              return void 0 === t
                ? pt.text(this)
                : this.empty().each(function () {
                    (1 !== this.nodeType &&
                      11 !== this.nodeType &&
                      9 !== this.nodeType) ||
                      (this.textContent = t);
                  });
            },
            null,
            t,
            arguments.length
          );
        },
        append: function () {
          return D(this, arguments, function (t) {
            (1 !== this.nodeType &&
              11 !== this.nodeType &&
              9 !== this.nodeType) ||
              _(this, t).appendChild(t);
          });
        },
        prepend: function () {
          return D(this, arguments, function (t) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var e = _(this, t);
              e.insertBefore(t, e.firstChild);
            }
          });
        },
        before: function () {
          return D(this, arguments, function (t) {
            this.parentNode && this.parentNode.insertBefore(t, this);
          });
        },
        after: function () {
          return D(this, arguments, function (t) {
            this.parentNode &&
              this.parentNode.insertBefore(t, this.nextSibling);
          });
        },
        empty: function () {
          for (var t, e = 0; null != (t = this[e]); e++)
            1 === t.nodeType && (pt.cleanData(y(t, !1)), (t.textContent = ""));
          return this;
        },
        clone: function (t, e) {
          return (
            (t = null != t && t),
            (e = null == e ? t : e),
            this.map(function () {
              return pt.clone(this, t, e);
            })
          );
        },
        html: function (t) {
          return kt(
            this,
            function (t) {
              var e = this[0] || {},
                i = 0,
                n = this.length;
              if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
              if (
                "string" == typeof t &&
                !Jt.test(t) &&
                !Xt[(Vt.exec(t) || ["", ""])[1].toLowerCase()]
              ) {
                t = pt.htmlPrefilter(t);
                try {
                  for (; i < n; i++)
                    1 === (e = this[i] || {}).nodeType &&
                      (pt.cleanData(y(e, !1)), (e.innerHTML = t));
                  e = 0;
                } catch (t) {}
              }
              e && this.empty().append(t);
            },
            null,
            t,
            arguments.length
          );
        },
        replaceWith: function () {
          var t = [];
          return D(
            this,
            arguments,
            function (e) {
              var i = this.parentNode;
              pt.inArray(this, t) < 0 &&
                (pt.cleanData(y(this)), i && i.replaceChild(e, this));
            },
            t
          );
        },
      }),
      pt.each(
        {
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith",
        },
        function (t, e) {
          pt.fn[t] = function (t) {
            for (var i, n = [], o = pt(t), s = o.length - 1, r = 0; r <= s; r++)
              (i = r === s ? this : this.clone(!0)),
                pt(o[r])[e](i),
                et.apply(n, i.get());
            return this.pushStack(n);
          };
        }
      );
    var te = new RegExp("^(" + Mt + ")(?!px)[a-z%]+$", "i"),
      ee = function (e) {
        var i = e.ownerDocument.defaultView;
        return (i && i.opener) || (i = t), i.getComputedStyle(e);
      },
      ie = function (t, e, i) {
        var n,
          o,
          s = {};
        for (o in e) (s[o] = t.style[o]), (t.style[o] = e[o]);
        for (o in ((n = i.call(t)), e)) t.style[o] = s[o];
        return n;
      },
      ne = new RegExp(Wt.join("|"), "i");
    !(function () {
      function e() {
        if (u) {
          (c.style.cssText =
            "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
            (u.style.cssText =
              "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
            Ot.appendChild(c).appendChild(u);
          var e = t.getComputedStyle(u);
          (n = "1%" !== e.top),
            (l = 12 === i(e.marginLeft)),
            (u.style.right = "60%"),
            (r = 36 === i(e.right)),
            (o = 36 === i(e.width)),
            (u.style.position = "absolute"),
            (s = 12 === i(u.offsetWidth / 3)),
            Ot.removeChild(c),
            (u = null);
        }
      }
      function i(t) {
        return Math.round(parseFloat(t));
      }
      var n,
        o,
        s,
        r,
        a,
        l,
        c = ht.createElement("div"),
        u = ht.createElement("div");
      u.style &&
        ((u.style.backgroundClip = "content-box"),
        (u.cloneNode(!0).style.backgroundClip = ""),
        (lt.clearCloneStyle = "content-box" === u.style.backgroundClip),
        pt.extend(lt, {
          boxSizingReliable: function () {
            return e(), o;
          },
          pixelBoxStyles: function () {
            return e(), r;
          },
          pixelPosition: function () {
            return e(), n;
          },
          reliableMarginLeft: function () {
            return e(), l;
          },
          scrollboxSize: function () {
            return e(), s;
          },
          reliableTrDimensions: function () {
            var e, i, n, o;
            return (
              null == a &&
                ((e = ht.createElement("table")),
                (i = ht.createElement("tr")),
                (n = ht.createElement("div")),
                (e.style.cssText =
                  "position:absolute;left:-11111px;border-collapse:separate"),
                (i.style.cssText = "border:1px solid"),
                (i.style.height = "1px"),
                (n.style.height = "9px"),
                (n.style.display = "block"),
                Ot.appendChild(e).appendChild(i).appendChild(n),
                (o = t.getComputedStyle(i)),
                (a =
                  parseInt(o.height, 10) +
                    parseInt(o.borderTopWidth, 10) +
                    parseInt(o.borderBottomWidth, 10) ===
                  i.offsetHeight),
                Ot.removeChild(e)),
              a
            );
          },
        }));
    })();
    var oe = ["Webkit", "Moz", "ms"],
      se = ht.createElement("div").style,
      re = {},
      ae = /^(none|table(?!-c[ea]).+)/,
      le = /^--/,
      ce = { position: "absolute", visibility: "hidden", display: "block" },
      ue = { letterSpacing: "0", fontWeight: "400" };
    pt.extend({
      cssHooks: {
        opacity: {
          get: function (t, e) {
            if (e) {
              var i = L(t, "opacity");
              return "" === i ? "1" : i;
            }
          },
        },
      },
      cssNumber: {
        animationIterationCount: !0,
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        gridArea: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnStart: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowStart: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
      },
      cssProps: {},
      style: function (t, e, i, n) {
        if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
          var o,
            s,
            r,
            a = f(e),
            l = le.test(e),
            c = t.style;
          if (
            (l || (e = N(a)),
            (r = pt.cssHooks[e] || pt.cssHooks[a]),
            void 0 === i)
          )
            return r && "get" in r && void 0 !== (o = r.get(t, !1, n))
              ? o
              : c[e];
          "string" == (s = typeof i) &&
            (o = jt.exec(i)) &&
            o[1] &&
            ((i = m(t, e, o)), (s = "number")),
            null != i &&
              i == i &&
              ("number" !== s ||
                l ||
                (i += (o && o[3]) || (pt.cssNumber[a] ? "" : "px")),
              lt.clearCloneStyle ||
                "" !== i ||
                0 !== e.indexOf("background") ||
                (c[e] = "inherit"),
              (r && "set" in r && void 0 === (i = r.set(t, i, n))) ||
                (l ? c.setProperty(e, i) : (c[e] = i)));
        }
      },
      css: function (t, e, i, n) {
        var o,
          s,
          r,
          a = f(e);
        return (
          le.test(e) || (e = N(a)),
          (r = pt.cssHooks[e] || pt.cssHooks[a]) &&
            "get" in r &&
            (o = r.get(t, !0, i)),
          void 0 === o && (o = L(t, e, n)),
          "normal" === o && e in ue && (o = ue[e]),
          "" === i || i
            ? ((s = parseFloat(o)), !0 === i || isFinite(s) ? s || 0 : o)
            : o
        );
      },
    }),
      pt.each(["height", "width"], function (t, e) {
        pt.cssHooks[e] = {
          get: function (t, i, n) {
            if (i)
              return !ae.test(pt.css(t, "display")) ||
                (t.getClientRects().length && t.getBoundingClientRect().width)
                ? W(t, e, n)
                : ie(t, ce, function () {
                    return W(t, e, n);
                  });
          },
          set: function (t, i, n) {
            var o,
              s = ee(t),
              r = !lt.scrollboxSize() && "absolute" === s.position,
              a = (r || n) && "border-box" === pt.css(t, "boxSizing", !1, s),
              l = n ? j(t, e, n, a, s) : 0;
            return (
              a &&
                r &&
                (l -= Math.ceil(
                  t["offset" + e[0].toUpperCase() + e.slice(1)] -
                    parseFloat(s[e]) -
                    j(t, e, "border", !1, s) -
                    0.5
                )),
              l &&
                (o = jt.exec(i)) &&
                "px" !== (o[3] || "px") &&
                ((t.style[e] = i), (i = pt.css(t, e))),
              M(0, i, l)
            );
          },
        };
      }),
      (pt.cssHooks.marginLeft = z(lt.reliableMarginLeft, function (t, e) {
        if (e)
          return (
            (parseFloat(L(t, "marginLeft")) ||
              t.getBoundingClientRect().left -
                ie(t, { marginLeft: 0 }, function () {
                  return t.getBoundingClientRect().left;
                })) + "px"
          );
      })),
      pt.each({ margin: "", padding: "", border: "Width" }, function (t, e) {
        (pt.cssHooks[t + e] = {
          expand: function (i) {
            for (
              var n = 0, o = {}, s = "string" == typeof i ? i.split(" ") : [i];
              n < 4;
              n++
            )
              o[t + Wt[n] + e] = s[n] || s[n - 2] || s[0];
            return o;
          },
        }),
          "margin" !== t && (pt.cssHooks[t + e].set = M);
      }),
      pt.fn.extend({
        css: function (t, e) {
          return kt(
            this,
            function (t, e, i) {
              var n,
                o,
                s = {},
                r = 0;
              if (Array.isArray(e)) {
                for (n = ee(t), o = e.length; r < o; r++)
                  s[e[r]] = pt.css(t, e[r], !1, n);
                return s;
              }
              return void 0 !== i ? pt.style(t, e, i) : pt.css(t, e);
            },
            t,
            e,
            1 < arguments.length
          );
        },
      }),
      (((pt.Tween = O).prototype = {
        constructor: O,
        init: function (t, e, i, n, o, s) {
          (this.elem = t),
            (this.prop = i),
            (this.easing = o || pt.easing._default),
            (this.options = e),
            (this.start = this.now = this.cur()),
            (this.end = n),
            (this.unit = s || (pt.cssNumber[i] ? "" : "px"));
        },
        cur: function () {
          var t = O.propHooks[this.prop];
          return t && t.get ? t.get(this) : O.propHooks._default.get(this);
        },
        run: function (t) {
          var e,
            i = O.propHooks[this.prop];
          return (
            this.options.duration
              ? (this.pos = e =
                  pt.easing[this.easing](
                    t,
                    this.options.duration * t,
                    0,
                    1,
                    this.options.duration
                  ))
              : (this.pos = e = t),
            (this.now = (this.end - this.start) * e + this.start),
            this.options.step &&
              this.options.step.call(this.elem, this.now, this),
            i && i.set ? i.set(this) : O.propHooks._default.set(this),
            this
          );
        },
      }).init.prototype = O.prototype),
      ((O.propHooks = {
        _default: {
          get: function (t) {
            var e;
            return 1 !== t.elem.nodeType ||
              (null != t.elem[t.prop] && null == t.elem.style[t.prop])
              ? t.elem[t.prop]
              : (e = pt.css(t.elem, t.prop, "")) && "auto" !== e
              ? e
              : 0;
          },
          set: function (t) {
            pt.fx.step[t.prop]
              ? pt.fx.step[t.prop](t)
              : 1 !== t.elem.nodeType ||
                (!pt.cssHooks[t.prop] && null == t.elem.style[N(t.prop)])
              ? (t.elem[t.prop] = t.now)
              : pt.style(t.elem, t.prop, t.now + t.unit);
          },
        },
      }).scrollTop = O.propHooks.scrollLeft =
        {
          set: function (t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now);
          },
        }),
      (pt.easing = {
        linear: function (t) {
          return t;
        },
        swing: function (t) {
          return 0.5 - Math.cos(t * Math.PI) / 2;
        },
        _default: "swing",
      }),
      (pt.fx = O.prototype.init),
      (pt.fx.step = {});
    var he,
      de,
      fe,
      pe,
      ge = /^(?:toggle|show|hide)$/,
      me = /queueHooks$/;
    (pt.Animation = pt.extend(B, {
      tweeners: {
        "*": [
          function (t, e) {
            var i = this.createTween(t, e);
            return m(i.elem, t, jt.exec(e), i), i;
          },
        ],
      },
      tweener: function (t, e) {
        ct(t) ? ((e = t), (t = ["*"])) : (t = t.match(Ct));
        for (var i, n = 0, o = t.length; n < o; n++)
          (i = t[n]),
            (B.tweeners[i] = B.tweeners[i] || []),
            B.tweeners[i].unshift(e);
      },
      prefilters: [
        function (t, e, i) {
          var n,
            o,
            s,
            r,
            a,
            l,
            c,
            u,
            h = "width" in e || "height" in e,
            d = this,
            f = {},
            p = t.style,
            g = t.nodeType && Ht(t),
            m = At.get(t, "fxshow");
          for (n in (i.queue ||
            (null == (r = pt._queueHooks(t, "fx")).unqueued &&
              ((r.unqueued = 0),
              (a = r.empty.fire),
              (r.empty.fire = function () {
                r.unqueued || a();
              })),
            r.unqueued++,
            d.always(function () {
              d.always(function () {
                r.unqueued--, pt.queue(t, "fx").length || r.empty.fire();
              });
            })),
          e))
            if (((o = e[n]), ge.test(o))) {
              if (
                (delete e[n],
                (s = s || "toggle" === o),
                o === (g ? "hide" : "show"))
              ) {
                if ("show" !== o || !m || void 0 === m[n]) continue;
                g = !0;
              }
              f[n] = (m && m[n]) || pt.style(t, n);
            }
          if ((l = !pt.isEmptyObject(e)) || !pt.isEmptyObject(f))
            for (n in (h &&
              1 === t.nodeType &&
              ((i.overflow = [p.overflow, p.overflowX, p.overflowY]),
              null == (c = m && m.display) && (c = At.get(t, "display")),
              "none" === (u = pt.css(t, "display")) &&
                (c
                  ? (u = c)
                  : (v([t], !0),
                    (c = t.style.display || c),
                    (u = pt.css(t, "display")),
                    v([t]))),
              ("inline" === u || ("inline-block" === u && null != c)) &&
                "none" === pt.css(t, "float") &&
                (l ||
                  (d.done(function () {
                    p.display = c;
                  }),
                  null == c && ((u = p.display), (c = "none" === u ? "" : u))),
                (p.display = "inline-block"))),
            i.overflow &&
              ((p.overflow = "hidden"),
              d.always(function () {
                (p.overflow = i.overflow[0]),
                  (p.overflowX = i.overflow[1]),
                  (p.overflowY = i.overflow[2]);
              })),
            (l = !1),
            f))
              l ||
                (m
                  ? "hidden" in m && (g = m.hidden)
                  : (m = At.access(t, "fxshow", { display: c })),
                s && (m.hidden = !g),
                g && v([t], !0),
                d.done(function () {
                  for (n in (g || v([t]), At.remove(t, "fxshow"), f))
                    pt.style(t, n, f[n]);
                })),
                (l = R(g ? m[n] : 0, n, d)),
                n in m ||
                  ((m[n] = l.start), g && ((l.end = l.start), (l.start = 0)));
        },
      ],
      prefilter: function (t, e) {
        e ? B.prefilters.unshift(t) : B.prefilters.push(t);
      },
    })),
      (pt.speed = function (t, e, i) {
        var n =
          t && "object" == typeof t
            ? pt.extend({}, t)
            : {
                complete: i || (!i && e) || (ct(t) && t),
                duration: t,
                easing: (i && e) || (e && !ct(e) && e),
              };
        return (
          pt.fx.off
            ? (n.duration = 0)
            : "number" != typeof n.duration &&
              (n.duration in pt.fx.speeds
                ? (n.duration = pt.fx.speeds[n.duration])
                : (n.duration = pt.fx.speeds._default)),
          (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
          (n.old = n.complete),
          (n.complete = function () {
            ct(n.old) && n.old.call(this), n.queue && pt.dequeue(this, n.queue);
          }),
          n
        );
      }),
      pt.fn.extend({
        fadeTo: function (t, e, i, n) {
          return this.filter(Ht)
            .css("opacity", 0)
            .show()
            .end()
            .animate({ opacity: e }, t, i, n);
        },
        animate: function (t, e, i, n) {
          var o = pt.isEmptyObject(t),
            s = pt.speed(e, i, n),
            r = function () {
              var e = B(this, pt.extend({}, t), s);
              (o || At.get(this, "finish")) && e.stop(!0);
            };
          return (
            (r.finish = r),
            o || !1 === s.queue ? this.each(r) : this.queue(s.queue, r)
          );
        },
        stop: function (t, e, i) {
          var n = function (t) {
            var e = t.stop;
            delete t.stop, e(i);
          };
          return (
            "string" != typeof t && ((i = e), (e = t), (t = void 0)),
            e && this.queue(t || "fx", []),
            this.each(function () {
              var e = !0,
                o = null != t && t + "queueHooks",
                s = pt.timers,
                r = At.get(this);
              if (o) r[o] && r[o].stop && n(r[o]);
              else for (o in r) r[o] && r[o].stop && me.test(o) && n(r[o]);
              for (o = s.length; o--; )
                s[o].elem !== this ||
                  (null != t && s[o].queue !== t) ||
                  (s[o].anim.stop(i), (e = !1), s.splice(o, 1));
              (!e && i) || pt.dequeue(this, t);
            })
          );
        },
        finish: function (t) {
          return (
            !1 !== t && (t = t || "fx"),
            this.each(function () {
              var e,
                i = At.get(this),
                n = i[t + "queue"],
                o = i[t + "queueHooks"],
                s = pt.timers,
                r = n ? n.length : 0;
              for (
                i.finish = !0,
                  pt.queue(this, t, []),
                  o && o.stop && o.stop.call(this, !0),
                  e = s.length;
                e--;

              )
                s[e].elem === this &&
                  s[e].queue === t &&
                  (s[e].anim.stop(!0), s.splice(e, 1));
              for (e = 0; e < r; e++)
                n[e] && n[e].finish && n[e].finish.call(this);
              delete i.finish;
            })
          );
        },
      }),
      pt.each(["toggle", "show", "hide"], function (t, e) {
        var i = pt.fn[e];
        pt.fn[e] = function (t, n, o) {
          return null == t || "boolean" == typeof t
            ? i.apply(this, arguments)
            : this.animate(H(e, !0), t, n, o);
        };
      }),
      pt.each(
        {
          slideDown: H("show"),
          slideUp: H("hide"),
          slideToggle: H("toggle"),
          fadeIn: { opacity: "show" },
          fadeOut: { opacity: "hide" },
          fadeToggle: { opacity: "toggle" },
        },
        function (t, e) {
          pt.fn[t] = function (t, i, n) {
            return this.animate(e, t, i, n);
          };
        }
      ),
      (pt.timers = []),
      (pt.fx.tick = function () {
        var t,
          e = 0,
          i = pt.timers;
        for (he = Date.now(); e < i.length; e++)
          (t = i[e])() || i[e] !== t || i.splice(e--, 1);
        i.length || pt.fx.stop(), (he = void 0);
      }),
      (pt.fx.timer = function (t) {
        pt.timers.push(t), pt.fx.start();
      }),
      (pt.fx.interval = 13),
      (pt.fx.start = function () {
        de || ((de = !0), q());
      }),
      (pt.fx.stop = function () {
        de = null;
      }),
      (pt.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
      (pt.fn.delay = function (e, i) {
        return (
          (e = (pt.fx && pt.fx.speeds[e]) || e),
          (i = i || "fx"),
          this.queue(i, function (i, n) {
            var o = t.setTimeout(i, e);
            n.stop = function () {
              t.clearTimeout(o);
            };
          })
        );
      }),
      (fe = ht.createElement("input")),
      (pe = ht.createElement("select").appendChild(ht.createElement("option"))),
      (fe.type = "checkbox"),
      (lt.checkOn = "" !== fe.value),
      (lt.optSelected = pe.selected),
      ((fe = ht.createElement("input")).value = "t"),
      (fe.type = "radio"),
      (lt.radioValue = "t" === fe.value);
    var ve,
      ye = pt.expr.attrHandle;
    pt.fn.extend({
      attr: function (t, e) {
        return kt(this, pt.attr, t, e, 1 < arguments.length);
      },
      removeAttr: function (t) {
        return this.each(function () {
          pt.removeAttr(this, t);
        });
      },
    }),
      pt.extend({
        attr: function (t, e, i) {
          var n,
            o,
            s = t.nodeType;
          if (3 !== s && 8 !== s && 2 !== s)
            return void 0 === t.getAttribute
              ? pt.prop(t, e, i)
              : ((1 === s && pt.isXMLDoc(t)) ||
                  (o =
                    pt.attrHooks[e.toLowerCase()] ||
                    (pt.expr.match.bool.test(e) ? ve : void 0)),
                void 0 !== i
                  ? null === i
                    ? void pt.removeAttr(t, e)
                    : o && "set" in o && void 0 !== (n = o.set(t, i, e))
                    ? n
                    : (t.setAttribute(e, i + ""), i)
                  : o && "get" in o && null !== (n = o.get(t, e))
                  ? n
                  : null == (n = pt.find.attr(t, e))
                  ? void 0
                  : n);
        },
        attrHooks: {
          type: {
            set: function (t, e) {
              if (!lt.radioValue && "radio" === e && s(t, "input")) {
                var i = t.value;
                return t.setAttribute("type", e), i && (t.value = i), e;
              }
            },
          },
        },
        removeAttr: function (t, e) {
          var i,
            n = 0,
            o = e && e.match(Ct);
          if (o && 1 === t.nodeType)
            for (; (i = o[n++]); ) t.removeAttribute(i);
        },
      }),
      (ve = {
        set: function (t, e, i) {
          return !1 === e ? pt.removeAttr(t, i) : t.setAttribute(i, i), i;
        },
      }),
      pt.each(pt.expr.match.bool.source.match(/\w+/g), function (t, e) {
        var i = ye[e] || pt.find.attr;
        ye[e] = function (t, e, n) {
          var o,
            s,
            r = e.toLowerCase();
          return (
            n ||
              ((s = ye[r]),
              (ye[r] = o),
              (o = null != i(t, e, n) ? r : null),
              (ye[r] = s)),
            o
          );
        };
      });
    var be = /^(?:input|select|textarea|button)$/i,
      xe = /^(?:a|area)$/i;
    pt.fn.extend({
      prop: function (t, e) {
        return kt(this, pt.prop, t, e, 1 < arguments.length);
      },
      removeProp: function (t) {
        return this.each(function () {
          delete this[pt.propFix[t] || t];
        });
      },
    }),
      pt.extend({
        prop: function (t, e, i) {
          var n,
            o,
            s = t.nodeType;
          if (3 !== s && 8 !== s && 2 !== s)
            return (
              (1 === s && pt.isXMLDoc(t)) ||
                ((e = pt.propFix[e] || e), (o = pt.propHooks[e])),
              void 0 !== i
                ? o && "set" in o && void 0 !== (n = o.set(t, i, e))
                  ? n
                  : (t[e] = i)
                : o && "get" in o && null !== (n = o.get(t, e))
                ? n
                : t[e]
            );
        },
        propHooks: {
          tabIndex: {
            get: function (t) {
              var e = pt.find.attr(t, "tabindex");
              return e
                ? parseInt(e, 10)
                : be.test(t.nodeName) || (xe.test(t.nodeName) && t.href)
                ? 0
                : -1;
            },
          },
        },
        propFix: { for: "htmlFor", class: "className" },
      }),
      lt.optSelected ||
        (pt.propHooks.selected = {
          get: function (t) {
            var e = t.parentNode;
            return e && e.parentNode && e.parentNode.selectedIndex, null;
          },
          set: function (t) {
            var e = t.parentNode;
            e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex);
          },
        }),
      pt.each(
        [
          "tabIndex",
          "readOnly",
          "maxLength",
          "cellSpacing",
          "cellPadding",
          "rowSpan",
          "colSpan",
          "useMap",
          "frameBorder",
          "contentEditable",
        ],
        function () {
          pt.propFix[this.toLowerCase()] = this;
        }
      ),
      pt.fn.extend({
        addClass: function (t) {
          var e,
            i,
            n,
            o,
            s,
            r,
            a,
            l = 0;
          if (ct(t))
            return this.each(function (e) {
              pt(this).addClass(t.call(this, e, U(this)));
            });
          if ((e = V(t)).length)
            for (; (i = this[l++]); )
              if (((o = U(i)), (n = 1 === i.nodeType && " " + F(o) + " "))) {
                for (r = 0; (s = e[r++]); )
                  n.indexOf(" " + s + " ") < 0 && (n += s + " ");
                o !== (a = F(n)) && i.setAttribute("class", a);
              }
          return this;
        },
        removeClass: function (t) {
          var e,
            i,
            n,
            o,
            s,
            r,
            a,
            l = 0;
          if (ct(t))
            return this.each(function (e) {
              pt(this).removeClass(t.call(this, e, U(this)));
            });
          if (!arguments.length) return this.attr("class", "");
          if ((e = V(t)).length)
            for (; (i = this[l++]); )
              if (((o = U(i)), (n = 1 === i.nodeType && " " + F(o) + " "))) {
                for (r = 0; (s = e[r++]); )
                  for (; -1 < n.indexOf(" " + s + " "); )
                    n = n.replace(" " + s + " ", " ");
                o !== (a = F(n)) && i.setAttribute("class", a);
              }
          return this;
        },
        toggleClass: function (t, e) {
          var i = typeof t,
            n = "string" === i || Array.isArray(t);
          return "boolean" == typeof e && n
            ? e
              ? this.addClass(t)
              : this.removeClass(t)
            : ct(t)
            ? this.each(function (i) {
                pt(this).toggleClass(t.call(this, i, U(this), e), e);
              })
            : this.each(function () {
                var e, o, s, r;
                if (n)
                  for (o = 0, s = pt(this), r = V(t); (e = r[o++]); )
                    s.hasClass(e) ? s.removeClass(e) : s.addClass(e);
                else
                  (void 0 !== t && "boolean" !== i) ||
                    ((e = U(this)) && At.set(this, "__className__", e),
                    this.setAttribute &&
                      this.setAttribute(
                        "class",
                        e || !1 === t ? "" : At.get(this, "__className__") || ""
                      ));
              });
        },
        hasClass: function (t) {
          var e,
            i,
            n = 0;
          for (e = " " + t + " "; (i = this[n++]); )
            if (1 === i.nodeType && -1 < (" " + F(U(i)) + " ").indexOf(e))
              return !0;
          return !1;
        },
      });
    var Se = /\r/g;
    pt.fn.extend({
      val: function (t) {
        var e,
          i,
          n,
          o = this[0];
        return arguments.length
          ? ((n = ct(t)),
            this.each(function (i) {
              var o;
              1 === this.nodeType &&
                (null == (o = n ? t.call(this, i, pt(this).val()) : t)
                  ? (o = "")
                  : "number" == typeof o
                  ? (o += "")
                  : Array.isArray(o) &&
                    (o = pt.map(o, function (t) {
                      return null == t ? "" : t + "";
                    })),
                ((e =
                  pt.valHooks[this.type] ||
                  pt.valHooks[this.nodeName.toLowerCase()]) &&
                  "set" in e &&
                  void 0 !== e.set(this, o, "value")) ||
                  (this.value = o));
            }))
          : o
          ? (e =
              pt.valHooks[o.type] || pt.valHooks[o.nodeName.toLowerCase()]) &&
            "get" in e &&
            void 0 !== (i = e.get(o, "value"))
            ? i
            : "string" == typeof (i = o.value)
            ? i.replace(Se, "")
            : null == i
            ? ""
            : i
          : void 0;
      },
    }),
      pt.extend({
        valHooks: {
          option: {
            get: function (t) {
              var e = pt.find.attr(t, "value");
              return null != e ? e : F(pt.text(t));
            },
          },
          select: {
            get: function (t) {
              var e,
                i,
                n,
                o = t.options,
                r = t.selectedIndex,
                a = "select-one" === t.type,
                l = a ? null : [],
                c = a ? r + 1 : o.length;
              for (n = r < 0 ? c : a ? r : 0; n < c; n++)
                if (
                  ((i = o[n]).selected || n === r) &&
                  !i.disabled &&
                  (!i.parentNode.disabled || !s(i.parentNode, "optgroup"))
                ) {
                  if (((e = pt(i).val()), a)) return e;
                  l.push(e);
                }
              return l;
            },
            set: function (t, e) {
              for (
                var i, n, o = t.options, s = pt.makeArray(e), r = o.length;
                r--;

              )
                ((n = o[r]).selected =
                  -1 < pt.inArray(pt.valHooks.option.get(n), s)) && (i = !0);
              return i || (t.selectedIndex = -1), s;
            },
          },
        },
      }),
      pt.each(["radio", "checkbox"], function () {
        (pt.valHooks[this] = {
          set: function (t, e) {
            if (Array.isArray(e))
              return (t.checked = -1 < pt.inArray(pt(t).val(), e));
          },
        }),
          lt.checkOn ||
            (pt.valHooks[this].get = function (t) {
              return null === t.getAttribute("value") ? "on" : t.value;
            });
      }),
      (lt.focusin = "onfocusin" in t);
    var we = /^(?:focusinfocus|focusoutblur)$/,
      Te = function (t) {
        t.stopPropagation();
      };
    pt.extend(pt.event, {
      trigger: function (e, i, n, o) {
        var s,
          r,
          a,
          l,
          c,
          u,
          h,
          d,
          f = [n || ht],
          p = st.call(e, "type") ? e.type : e,
          g = st.call(e, "namespace") ? e.namespace.split(".") : [];
        if (
          ((r = d = a = n = n || ht),
          3 !== n.nodeType &&
            8 !== n.nodeType &&
            !we.test(p + pt.event.triggered) &&
            (-1 < p.indexOf(".") &&
              ((p = (g = p.split(".")).shift()), g.sort()),
            (c = p.indexOf(":") < 0 && "on" + p),
            ((e = e[pt.expando]
              ? e
              : new pt.Event(p, "object" == typeof e && e)).isTrigger = o
              ? 2
              : 3),
            (e.namespace = g.join(".")),
            (e.rnamespace = e.namespace
              ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)")
              : null),
            (e.result = void 0),
            e.target || (e.target = n),
            (i = null == i ? [e] : pt.makeArray(i, [e])),
            (h = pt.event.special[p] || {}),
            o || !h.trigger || !1 !== h.trigger.apply(n, i)))
        ) {
          if (!o && !h.noBubble && !ut(n)) {
            for (
              l = h.delegateType || p, we.test(l + p) || (r = r.parentNode);
              r;
              r = r.parentNode
            )
              f.push(r), (a = r);
            a === (n.ownerDocument || ht) &&
              f.push(a.defaultView || a.parentWindow || t);
          }
          for (s = 0; (r = f[s++]) && !e.isPropagationStopped(); )
            (d = r),
              (e.type = 1 < s ? l : h.bindType || p),
              (u =
                (At.get(r, "events") || Object.create(null))[e.type] &&
                At.get(r, "handle")) && u.apply(r, i),
              (u = c && r[c]) &&
                u.apply &&
                Dt(r) &&
                ((e.result = u.apply(r, i)),
                !1 === e.result && e.preventDefault());
          return (
            (e.type = p),
            o ||
              e.isDefaultPrevented() ||
              (h._default && !1 !== h._default.apply(f.pop(), i)) ||
              !Dt(n) ||
              (c &&
                ct(n[p]) &&
                !ut(n) &&
                ((a = n[c]) && (n[c] = null),
                (pt.event.triggered = p),
                e.isPropagationStopped() && d.addEventListener(p, Te),
                n[p](),
                e.isPropagationStopped() && d.removeEventListener(p, Te),
                (pt.event.triggered = void 0),
                a && (n[c] = a))),
            e.result
          );
        }
      },
      simulate: function (t, e, i) {
        var n = pt.extend(new pt.Event(), i, { type: t, isSimulated: !0 });
        pt.event.trigger(n, null, e);
      },
    }),
      pt.fn.extend({
        trigger: function (t, e) {
          return this.each(function () {
            pt.event.trigger(t, e, this);
          });
        },
        triggerHandler: function (t, e) {
          var i = this[0];
          if (i) return pt.event.trigger(t, e, i, !0);
        },
      }),
      lt.focusin ||
        pt.each({ focus: "focusin", blur: "focusout" }, function (t, e) {
          var i = function (t) {
            pt.event.simulate(e, t.target, pt.event.fix(t));
          };
          pt.event.special[e] = {
            setup: function () {
              var n = this.ownerDocument || this.document || this,
                o = At.access(n, e);
              o || n.addEventListener(t, i, !0), At.access(n, e, (o || 0) + 1);
            },
            teardown: function () {
              var n = this.ownerDocument || this.document || this,
                o = At.access(n, e) - 1;
              o
                ? At.access(n, e, o)
                : (n.removeEventListener(t, i, !0), At.remove(n, e));
            },
          };
        });
    var Ce = t.location,
      Ee = { guid: Date.now() },
      _e = /\?/;
    pt.parseXML = function (e) {
      var i, n;
      if (!e || "string" != typeof e) return null;
      try {
        i = new t.DOMParser().parseFromString(e, "text/xml");
      } catch (e) {}
      return (
        (n = i && i.getElementsByTagName("parsererror")[0]),
        (i && !n) ||
          pt.error(
            "Invalid XML: " +
              (n
                ? pt
                    .map(n.childNodes, function (t) {
                      return t.textContent;
                    })
                    .join("\n")
                : e)
          ),
        i
      );
    };
    var ke = /\[\]$/,
      Ie = /\r?\n/g,
      Pe = /^(?:submit|button|image|reset|file)$/i,
      De = /^(?:input|select|textarea|keygen)/i;
    (pt.param = function (t, e) {
      var i,
        n = [],
        o = function (t, e) {
          var i = ct(e) ? e() : e;
          n[n.length] =
            encodeURIComponent(t) +
            "=" +
            encodeURIComponent(null == i ? "" : i);
        };
      if (null == t) return "";
      if (Array.isArray(t) || (t.jquery && !pt.isPlainObject(t)))
        pt.each(t, function () {
          o(this.name, this.value);
        });
      else for (i in t) G(i, t[i], e, o);
      return n.join("&");
    }),
      pt.fn.extend({
        serialize: function () {
          return pt.param(this.serializeArray());
        },
        serializeArray: function () {
          return this.map(function () {
            var t = pt.prop(this, "elements");
            return t ? pt.makeArray(t) : this;
          })
            .filter(function () {
              var t = this.type;
              return (
                this.name &&
                !pt(this).is(":disabled") &&
                De.test(this.nodeName) &&
                !Pe.test(t) &&
                (this.checked || !Ut.test(t))
              );
            })
            .map(function (t, e) {
              var i = pt(this).val();
              return null == i
                ? null
                : Array.isArray(i)
                ? pt.map(i, function (t) {
                    return { name: e.name, value: t.replace(Ie, "\r\n") };
                  })
                : { name: e.name, value: i.replace(Ie, "\r\n") };
            })
            .get();
        },
      });
    var Ae = /%20/g,
      Le = /#.*$/,
      ze = /([?&])_=[^&]*/,
      Ne = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      Me = /^(?:GET|HEAD)$/,
      je = /^\/\//,
      We = {},
      Oe = {},
      qe = "*/".concat("*"),
      $e = ht.createElement("a");
    ($e.href = Ce.href),
      pt.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
          url: Ce.href,
          type: "GET",
          isLocal:
            /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
              Ce.protocol
            ),
          global: !0,
          processData: !0,
          async: !0,
          contentType: "application/x-www-form-urlencoded; charset=UTF-8",
          accepts: {
            "*": qe,
            text: "text/plain",
            html: "text/html",
            xml: "application/xml, text/xml",
            json: "application/json, text/javascript",
          },
          contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
          responseFields: {
            xml: "responseXML",
            text: "responseText",
            json: "responseJSON",
          },
          converters: {
            "* text": String,
            "text html": !0,
            "text json": JSON.parse,
            "text xml": pt.parseXML,
          },
          flatOptions: { url: !0, context: !0 },
        },
        ajaxSetup: function (t, e) {
          return e ? Q(Q(t, pt.ajaxSettings), e) : Q(pt.ajaxSettings, t);
        },
        ajaxPrefilter: X(We),
        ajaxTransport: X(Oe),
        ajax: function (e, i) {
          function n(e, i, n, a) {
            var c,
              d,
              f,
              x,
              S,
              w = i;
            u ||
              ((u = !0),
              l && t.clearTimeout(l),
              (o = void 0),
              (r = a || ""),
              (T.readyState = 0 < e ? 4 : 0),
              (c = (200 <= e && e < 300) || 304 === e),
              n &&
                (x = (function (t, e, i) {
                  for (
                    var n, o, s, r, a = t.contents, l = t.dataTypes;
                    "*" === l[0];

                  )
                    l.shift(),
                      void 0 === n &&
                        (n = t.mimeType || e.getResponseHeader("Content-Type"));
                  if (n)
                    for (o in a)
                      if (a[o] && a[o].test(n)) {
                        l.unshift(o);
                        break;
                      }
                  if (l[0] in i) s = l[0];
                  else {
                    for (o in i) {
                      if (!l[0] || t.converters[o + " " + l[0]]) {
                        s = o;
                        break;
                      }
                      r || (r = o);
                    }
                    s = s || r;
                  }
                  if (s) return s !== l[0] && l.unshift(s), i[s];
                })(p, T, n)),
              !c &&
                -1 < pt.inArray("script", p.dataTypes) &&
                pt.inArray("json", p.dataTypes) < 0 &&
                (p.converters["text script"] = function () {}),
              (x = (function (t, e, i, n) {
                var o,
                  s,
                  r,
                  a,
                  l,
                  c = {},
                  u = t.dataTypes.slice();
                if (u[1])
                  for (r in t.converters) c[r.toLowerCase()] = t.converters[r];
                for (s = u.shift(); s; )
                  if (
                    (t.responseFields[s] && (i[t.responseFields[s]] = e),
                    !l &&
                      n &&
                      t.dataFilter &&
                      (e = t.dataFilter(e, t.dataType)),
                    (l = s),
                    (s = u.shift()))
                  )
                    if ("*" === s) s = l;
                    else if ("*" !== l && l !== s) {
                      if (!(r = c[l + " " + s] || c["* " + s]))
                        for (o in c)
                          if (
                            (a = o.split(" "))[1] === s &&
                            (r = c[l + " " + a[0]] || c["* " + a[0]])
                          ) {
                            !0 === r
                              ? (r = c[o])
                              : !0 !== c[o] && ((s = a[0]), u.unshift(a[1]));
                            break;
                          }
                      if (!0 !== r)
                        if (r && t.throws) e = r(e);
                        else
                          try {
                            e = r(e);
                          } catch (t) {
                            return {
                              state: "parsererror",
                              error: r
                                ? t
                                : "No conversion from " + l + " to " + s,
                            };
                          }
                    }
                return { state: "success", data: e };
              })(p, x, T, c)),
              c
                ? (p.ifModified &&
                    ((S = T.getResponseHeader("Last-Modified")) &&
                      (pt.lastModified[s] = S),
                    (S = T.getResponseHeader("etag")) && (pt.etag[s] = S)),
                  204 === e || "HEAD" === p.type
                    ? (w = "nocontent")
                    : 304 === e
                    ? (w = "notmodified")
                    : ((w = x.state), (d = x.data), (c = !(f = x.error))))
                : ((f = w), (!e && w) || ((w = "error"), e < 0 && (e = 0))),
              (T.status = e),
              (T.statusText = (i || w) + ""),
              c ? v.resolveWith(g, [d, w, T]) : v.rejectWith(g, [T, w, f]),
              T.statusCode(b),
              (b = void 0),
              h &&
                m.trigger(c ? "ajaxSuccess" : "ajaxError", [T, p, c ? d : f]),
              y.fireWith(g, [T, w]),
              h &&
                (m.trigger("ajaxComplete", [T, p]),
                --pt.active || pt.event.trigger("ajaxStop")));
          }
          "object" == typeof e && ((i = e), (e = void 0)), (i = i || {});
          var o,
            s,
            r,
            a,
            l,
            c,
            u,
            h,
            d,
            f,
            p = pt.ajaxSetup({}, i),
            g = p.context || p,
            m = p.context && (g.nodeType || g.jquery) ? pt(g) : pt.event,
            v = pt.Deferred(),
            y = pt.Callbacks("once memory"),
            b = p.statusCode || {},
            x = {},
            S = {},
            w = "canceled",
            T = {
              readyState: 0,
              getResponseHeader: function (t) {
                var e;
                if (u) {
                  if (!a)
                    for (a = {}; (e = Ne.exec(r)); )
                      a[e[1].toLowerCase() + " "] = (
                        a[e[1].toLowerCase() + " "] || []
                      ).concat(e[2]);
                  e = a[t.toLowerCase() + " "];
                }
                return null == e ? null : e.join(", ");
              },
              getAllResponseHeaders: function () {
                return u ? r : null;
              },
              setRequestHeader: function (t, e) {
                return (
                  null == u &&
                    ((t = S[t.toLowerCase()] = S[t.toLowerCase()] || t),
                    (x[t] = e)),
                  this
                );
              },
              overrideMimeType: function (t) {
                return null == u && (p.mimeType = t), this;
              },
              statusCode: function (t) {
                var e;
                if (t)
                  if (u) T.always(t[T.status]);
                  else for (e in t) b[e] = [b[e], t[e]];
                return this;
              },
              abort: function (t) {
                var e = t || w;
                return o && o.abort(e), n(0, e), this;
              },
            };
          if (
            (v.promise(T),
            (p.url = ((e || p.url || Ce.href) + "").replace(
              je,
              Ce.protocol + "//"
            )),
            (p.type = i.method || i.type || p.method || p.type),
            (p.dataTypes = (p.dataType || "*").toLowerCase().match(Ct) || [""]),
            null == p.crossDomain)
          ) {
            c = ht.createElement("a");
            try {
              (c.href = p.url),
                (c.href = c.href),
                (p.crossDomain =
                  $e.protocol + "//" + $e.host != c.protocol + "//" + c.host);
            } catch (e) {
              p.crossDomain = !0;
            }
          }
          if (
            (p.data &&
              p.processData &&
              "string" != typeof p.data &&
              (p.data = pt.param(p.data, p.traditional)),
            Y(We, p, i, T),
            u)
          )
            return T;
          for (d in ((h = pt.event && p.global) &&
            0 == pt.active++ &&
            pt.event.trigger("ajaxStart"),
          (p.type = p.type.toUpperCase()),
          (p.hasContent = !Me.test(p.type)),
          (s = p.url.replace(Le, "")),
          p.hasContent
            ? p.data &&
              p.processData &&
              0 ===
                (p.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              (p.data = p.data.replace(Ae, "+"))
            : ((f = p.url.slice(s.length)),
              p.data &&
                (p.processData || "string" == typeof p.data) &&
                ((s += (_e.test(s) ? "&" : "?") + p.data), delete p.data),
              !1 === p.cache &&
                ((s = s.replace(ze, "$1")),
                (f = (_e.test(s) ? "&" : "?") + "_=" + Ee.guid++ + f)),
              (p.url = s + f)),
          p.ifModified &&
            (pt.lastModified[s] &&
              T.setRequestHeader("If-Modified-Since", pt.lastModified[s]),
            pt.etag[s] && T.setRequestHeader("If-None-Match", pt.etag[s])),
          ((p.data && p.hasContent && !1 !== p.contentType) || i.contentType) &&
            T.setRequestHeader("Content-Type", p.contentType),
          T.setRequestHeader(
            "Accept",
            p.dataTypes[0] && p.accepts[p.dataTypes[0]]
              ? p.accepts[p.dataTypes[0]] +
                  ("*" !== p.dataTypes[0] ? ", " + qe + "; q=0.01" : "")
              : p.accepts["*"]
          ),
          p.headers))
            T.setRequestHeader(d, p.headers[d]);
          if (p.beforeSend && (!1 === p.beforeSend.call(g, T, p) || u))
            return T.abort();
          if (
            ((w = "abort"),
            y.add(p.complete),
            T.done(p.success),
            T.fail(p.error),
            (o = Y(Oe, p, i, T)))
          ) {
            if (((T.readyState = 1), h && m.trigger("ajaxSend", [T, p]), u))
              return T;
            p.async &&
              0 < p.timeout &&
              (l = t.setTimeout(function () {
                T.abort("timeout");
              }, p.timeout));
            try {
              (u = !1), o.send(x, n);
            } catch (e) {
              if (u) throw e;
              n(-1, e);
            }
          } else n(-1, "No Transport");
          return T;
        },
        getJSON: function (t, e, i) {
          return pt.get(t, e, i, "json");
        },
        getScript: function (t, e) {
          return pt.get(t, void 0, e, "script");
        },
      }),
      pt.each(["get", "post"], function (t, e) {
        pt[e] = function (t, i, n, o) {
          return (
            ct(i) && ((o = o || n), (n = i), (i = void 0)),
            pt.ajax(
              pt.extend(
                { url: t, type: e, dataType: o, data: i, success: n },
                pt.isPlainObject(t) && t
              )
            )
          );
        };
      }),
      pt.ajaxPrefilter(function (t) {
        var e;
        for (e in t.headers)
          "content-type" === e.toLowerCase() &&
            (t.contentType = t.headers[e] || "");
      }),
      (pt._evalUrl = function (t, e, i) {
        return pt.ajax({
          url: t,
          type: "GET",
          dataType: "script",
          cache: !0,
          async: !1,
          global: !1,
          converters: { "text script": function () {} },
          dataFilter: function (t) {
            pt.globalEval(t, e, i);
          },
        });
      }),
      pt.fn.extend({
        wrapAll: function (t) {
          var e;
          return (
            this[0] &&
              (ct(t) && (t = t.call(this[0])),
              (e = pt(t, this[0].ownerDocument).eq(0).clone(!0)),
              this[0].parentNode && e.insertBefore(this[0]),
              e
                .map(function () {
                  for (var t = this; t.firstElementChild; )
                    t = t.firstElementChild;
                  return t;
                })
                .append(this)),
            this
          );
        },
        wrapInner: function (t) {
          return ct(t)
            ? this.each(function (e) {
                pt(this).wrapInner(t.call(this, e));
              })
            : this.each(function () {
                var e = pt(this),
                  i = e.contents();
                i.length ? i.wrapAll(t) : e.append(t);
              });
        },
        wrap: function (t) {
          var e = ct(t);
          return this.each(function (i) {
            pt(this).wrapAll(e ? t.call(this, i) : t);
          });
        },
        unwrap: function (t) {
          return (
            this.parent(t)
              .not("body")
              .each(function () {
                pt(this).replaceWith(this.childNodes);
              }),
            this
          );
        },
      }),
      (pt.expr.pseudos.hidden = function (t) {
        return !pt.expr.pseudos.visible(t);
      }),
      (pt.expr.pseudos.visible = function (t) {
        return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
      }),
      (pt.ajaxSettings.xhr = function () {
        try {
          return new t.XMLHttpRequest();
        } catch (t) {}
      });
    var He = { 0: 200, 1223: 204 },
      Re = pt.ajaxSettings.xhr();
    (lt.cors = !!Re && "withCredentials" in Re),
      (lt.ajax = Re = !!Re),
      pt.ajaxTransport(function (e) {
        var i, n;
        if (lt.cors || (Re && !e.crossDomain))
          return {
            send: function (o, s) {
              var r,
                a = e.xhr();
              if (
                (a.open(e.type, e.url, e.async, e.username, e.password),
                e.xhrFields)
              )
                for (r in e.xhrFields) a[r] = e.xhrFields[r];
              for (r in (e.mimeType &&
                a.overrideMimeType &&
                a.overrideMimeType(e.mimeType),
              e.crossDomain ||
                o["X-Requested-With"] ||
                (o["X-Requested-With"] = "XMLHttpRequest"),
              o))
                a.setRequestHeader(r, o[r]);
              (i = function (t) {
                return function () {
                  i &&
                    ((i =
                      n =
                      a.onload =
                      a.onerror =
                      a.onabort =
                      a.ontimeout =
                      a.onreadystatechange =
                        null),
                    "abort" === t
                      ? a.abort()
                      : "error" === t
                      ? "number" != typeof a.status
                        ? s(0, "error")
                        : s(a.status, a.statusText)
                      : s(
                          He[a.status] || a.status,
                          a.statusText,
                          "text" !== (a.responseType || "text") ||
                            "string" != typeof a.responseText
                            ? { binary: a.response }
                            : { text: a.responseText },
                          a.getAllResponseHeaders()
                        ));
                };
              }),
                (a.onload = i()),
                (n = a.onerror = a.ontimeout = i("error")),
                void 0 !== a.onabort
                  ? (a.onabort = n)
                  : (a.onreadystatechange = function () {
                      4 === a.readyState &&
                        t.setTimeout(function () {
                          i && n();
                        });
                    }),
                (i = i("abort"));
              try {
                a.send((e.hasContent && e.data) || null);
              } catch (o) {
                if (i) throw o;
              }
            },
            abort: function () {
              i && i();
            },
          };
      }),
      pt.ajaxPrefilter(function (t) {
        t.crossDomain && (t.contents.script = !1);
      }),
      pt.ajaxSetup({
        accepts: {
          script:
            "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
        },
        contents: { script: /\b(?:java|ecma)script\b/ },
        converters: {
          "text script": function (t) {
            return pt.globalEval(t), t;
          },
        },
      }),
      pt.ajaxPrefilter("script", function (t) {
        void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET");
      }),
      pt.ajaxTransport("script", function (t) {
        var e, i;
        if (t.crossDomain || t.scriptAttrs)
          return {
            send: function (n, o) {
              (e = pt("<script>")
                .attr(t.scriptAttrs || {})
                .prop({ charset: t.scriptCharset, src: t.url })
                .on(
                  "load error",
                  (i = function (t) {
                    e.remove(),
                      (i = null),
                      t && o("error" === t.type ? 404 : 200, t.type);
                  })
                )),
                ht.head.appendChild(e[0]);
            },
            abort: function () {
              i && i();
            },
          };
      });
    var Be,
      Fe = [],
      Ue = /(=)\?(?=&|$)|\?\?/;
    pt.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        var t = Fe.pop() || pt.expando + "_" + Ee.guid++;
        return (this[t] = !0), t;
      },
    }),
      pt.ajaxPrefilter("json jsonp", function (e, i, n) {
        var o,
          s,
          r,
          a =
            !1 !== e.jsonp &&
            (Ue.test(e.url)
              ? "url"
              : "string" == typeof e.data &&
                0 ===
                  (e.contentType || "").indexOf(
                    "application/x-www-form-urlencoded"
                  ) &&
                Ue.test(e.data) &&
                "data");
        if (a || "jsonp" === e.dataTypes[0])
          return (
            (o = e.jsonpCallback =
              ct(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
            a
              ? (e[a] = e[a].replace(Ue, "$1" + o))
              : !1 !== e.jsonp &&
                (e.url += (_e.test(e.url) ? "&" : "?") + e.jsonp + "=" + o),
            (e.converters["script json"] = function () {
              return r || pt.error(o + " was not called"), r[0];
            }),
            (e.dataTypes[0] = "json"),
            (s = t[o]),
            (t[o] = function () {
              r = arguments;
            }),
            n.always(function () {
              void 0 === s ? pt(t).removeProp(o) : (t[o] = s),
                e[o] && ((e.jsonpCallback = i.jsonpCallback), Fe.push(o)),
                r && ct(s) && s(r[0]),
                (r = s = void 0);
            }),
            "script"
          );
      }),
      (lt.createHTMLDocument =
        (((Be = ht.implementation.createHTMLDocument("").body).innerHTML =
          "<form></form><form></form>"),
        2 === Be.childNodes.length)),
      (pt.parseHTML = function (t, e, i) {
        return "string" != typeof t
          ? []
          : ("boolean" == typeof e && ((i = e), (e = !1)),
            e ||
              (lt.createHTMLDocument
                ? (((n = (e =
                    ht.implementation.createHTMLDocument("")).createElement(
                    "base"
                  )).href = ht.location.href),
                  e.head.appendChild(n))
                : (e = ht)),
            (s = !i && []),
            (o = bt.exec(t))
              ? [e.createElement(o[1])]
              : ((o = x([t], e, s)),
                s && s.length && pt(s).remove(),
                pt.merge([], o.childNodes)));
        var n, o, s;
      }),
      (pt.fn.load = function (t, e, i) {
        var n,
          o,
          s,
          r = this,
          a = t.indexOf(" ");
        return (
          -1 < a && ((n = F(t.slice(a))), (t = t.slice(0, a))),
          ct(e)
            ? ((i = e), (e = void 0))
            : e && "object" == typeof e && (o = "POST"),
          0 < r.length &&
            pt
              .ajax({ url: t, type: o || "GET", dataType: "html", data: e })
              .done(function (t) {
                (s = arguments),
                  r.html(n ? pt("<div>").append(pt.parseHTML(t)).find(n) : t);
              })
              .always(
                i &&
                  function (t, e) {
                    r.each(function () {
                      i.apply(this, s || [t.responseText, e, t]);
                    });
                  }
              ),
          this
        );
      }),
      (pt.expr.pseudos.animated = function (t) {
        return pt.grep(pt.timers, function (e) {
          return t === e.elem;
        }).length;
      }),
      (pt.offset = {
        setOffset: function (t, e, i) {
          var n,
            o,
            s,
            r,
            a,
            l,
            c = pt.css(t, "position"),
            u = pt(t),
            h = {};
          "static" === c && (t.style.position = "relative"),
            (a = u.offset()),
            (s = pt.css(t, "top")),
            (l = pt.css(t, "left")),
            ("absolute" === c || "fixed" === c) && -1 < (s + l).indexOf("auto")
              ? ((r = (n = u.position()).top), (o = n.left))
              : ((r = parseFloat(s) || 0), (o = parseFloat(l) || 0)),
            ct(e) && (e = e.call(t, i, pt.extend({}, a))),
            null != e.top && (h.top = e.top - a.top + r),
            null != e.left && (h.left = e.left - a.left + o),
            "using" in e ? e.using.call(t, h) : u.css(h);
        },
      }),
      pt.fn.extend({
        offset: function (t) {
          if (arguments.length)
            return void 0 === t
              ? this
              : this.each(function (e) {
                  pt.offset.setOffset(this, t, e);
                });
          var e,
            i,
            n = this[0];
          return n
            ? n.getClientRects().length
              ? ((e = n.getBoundingClientRect()),
                (i = n.ownerDocument.defaultView),
                { top: e.top + i.pageYOffset, left: e.left + i.pageXOffset })
              : { top: 0, left: 0 }
            : void 0;
        },
        position: function () {
          if (this[0]) {
            var t,
              e,
              i,
              n = this[0],
              o = { top: 0, left: 0 };
            if ("fixed" === pt.css(n, "position"))
              e = n.getBoundingClientRect();
            else {
              for (
                e = this.offset(),
                  i = n.ownerDocument,
                  t = n.offsetParent || i.documentElement;
                t &&
                (t === i.body || t === i.documentElement) &&
                "static" === pt.css(t, "position");

              )
                t = t.parentNode;
              t &&
                t !== n &&
                1 === t.nodeType &&
                (((o = pt(t).offset()).top += pt.css(t, "borderTopWidth", !0)),
                (o.left += pt.css(t, "borderLeftWidth", !0)));
            }
            return {
              top: e.top - o.top - pt.css(n, "marginTop", !0),
              left: e.left - o.left - pt.css(n, "marginLeft", !0),
            };
          }
        },
        offsetParent: function () {
          return this.map(function () {
            for (
              var t = this.offsetParent;
              t && "static" === pt.css(t, "position");

            )
              t = t.offsetParent;
            return t || Ot;
          });
        },
      }),
      pt.each(
        { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
        function (t, e) {
          var i = "pageYOffset" === e;
          pt.fn[t] = function (n) {
            return kt(
              this,
              function (t, n, o) {
                var s;
                if (
                  (ut(t) ? (s = t) : 9 === t.nodeType && (s = t.defaultView),
                  void 0 === o)
                )
                  return s ? s[e] : t[n];
                s
                  ? s.scrollTo(i ? s.pageXOffset : o, i ? o : s.pageYOffset)
                  : (t[n] = o);
              },
              t,
              n,
              arguments.length
            );
          };
        }
      ),
      pt.each(["top", "left"], function (t, e) {
        pt.cssHooks[e] = z(lt.pixelPosition, function (t, i) {
          if (i)
            return (i = L(t, e)), te.test(i) ? pt(t).position()[e] + "px" : i;
        });
      }),
      pt.each({ Height: "height", Width: "width" }, function (t, e) {
        pt.each(
          { padding: "inner" + t, content: e, "": "outer" + t },
          function (i, n) {
            pt.fn[n] = function (o, s) {
              var r = arguments.length && (i || "boolean" != typeof o),
                a = i || (!0 === o || !0 === s ? "margin" : "border");
              return kt(
                this,
                function (e, i, o) {
                  var s;
                  return ut(e)
                    ? 0 === n.indexOf("outer")
                      ? e["inner" + t]
                      : e.document.documentElement["client" + t]
                    : 9 === e.nodeType
                    ? ((s = e.documentElement),
                      Math.max(
                        e.body["scroll" + t],
                        s["scroll" + t],
                        e.body["offset" + t],
                        s["offset" + t],
                        s["client" + t]
                      ))
                    : void 0 === o
                    ? pt.css(e, i, a)
                    : pt.style(e, i, o, a);
                },
                e,
                r ? o : void 0,
                r
              );
            };
          }
        );
      }),
      pt.each(
        [
          "ajaxStart",
          "ajaxStop",
          "ajaxComplete",
          "ajaxError",
          "ajaxSuccess",
          "ajaxSend",
        ],
        function (t, e) {
          pt.fn[e] = function (t) {
            return this.on(e, t);
          };
        }
      ),
      pt.fn.extend({
        bind: function (t, e, i) {
          return this.on(t, null, e, i);
        },
        unbind: function (t, e) {
          return this.off(t, null, e);
        },
        delegate: function (t, e, i, n) {
          return this.on(e, t, i, n);
        },
        undelegate: function (t, e, i) {
          return 1 === arguments.length
            ? this.off(t, "**")
            : this.off(e, t || "**", i);
        },
        hover: function (t, e) {
          return this.mouseenter(t).mouseleave(e || t);
        },
      }),
      pt.each(
        "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
          " "
        ),
        function (t, e) {
          pt.fn[e] = function (t, i) {
            return 0 < arguments.length
              ? this.on(e, null, t, i)
              : this.trigger(e);
          };
        }
      );
    var Ve = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    (pt.proxy = function (t, e) {
      var i, n, o;
      if (("string" == typeof e && ((i = t[e]), (e = t), (t = i)), ct(t)))
        return (
          (n = Z.call(arguments, 2)),
          ((o = function () {
            return t.apply(e || this, n.concat(Z.call(arguments)));
          }).guid = t.guid =
            t.guid || pt.guid++),
          o
        );
    }),
      (pt.holdReady = function (t) {
        t ? pt.readyWait++ : pt.ready(!0);
      }),
      (pt.isArray = Array.isArray),
      (pt.parseJSON = JSON.parse),
      (pt.nodeName = s),
      (pt.isFunction = ct),
      (pt.isWindow = ut),
      (pt.camelCase = f),
      (pt.type = n),
      (pt.now = Date.now),
      (pt.isNumeric = function (t) {
        var e = pt.type(t);
        return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t));
      }),
      (pt.trim = function (t) {
        return null == t ? "" : (t + "").replace(Ve, "");
      }),
      "function" == typeof define &&
        define.amd &&
        define("jquery", [], function () {
          return pt;
        });
    var Ge = t.jQuery,
      Xe = t.$;
    return (
      (pt.noConflict = function (e) {
        return (
          t.$ === pt && (t.$ = Xe), e && t.jQuery === pt && (t.jQuery = Ge), pt
        );
      }),
      void 0 === e && (t.jQuery = t.$ = pt),
      pt
    );
  });
var jQuery_T4NT = jQuery;
!(function (t) {
  var e = "";
  screen.width &&
    ((width = screen.width ? screen.width : ""),
    (height = screen.height ? screen.height : ""),
    (e += width + " x " + height));
  var i,
    n,
    o,
    s = navigator.appVersion,
    r = navigator.userAgent,
    a = navigator.appName,
    l = "" + parseFloat(navigator.appVersion),
    c = parseInt(navigator.appVersion, 10);
  -1 != (n = r.indexOf("Opera")) &&
    ((a = "Opera"),
    (l = r.substring(n + 6)),
    -1 != (n = r.indexOf("Version")) && (l = r.substring(n + 8))),
    -1 != (n = r.indexOf("OPR"))
      ? ((a = "Opera"), (l = r.substring(n + 4)))
      : -1 != (n = r.indexOf("Edge"))
      ? ((a = "Edge"), (l = r.substring(n + 5)))
      : -1 != (n = r.indexOf("MSIE"))
      ? ((a = "Internet"), (l = r.substring(n + 5)))
      : -1 != (n = r.indexOf("Chrome"))
      ? ((a = "Chrome"), (l = r.substring(n + 7)))
      : -1 != (n = r.indexOf("Safari"))
      ? ((a = "Safari"),
        (l = r.substring(n + 7)),
        -1 != (n = r.indexOf("Version")) && (l = r.substring(n + 8)))
      : -1 != (n = r.indexOf("Firefox"))
      ? ((a = "Firefox"), (l = r.substring(n + 8)))
      : -1 != r.indexOf("Trident/")
      ? ((a = "Internet"), (l = r.substring(r.indexOf("rv:") + 3)))
      : (i = r.lastIndexOf(" ") + 1) < (n = r.lastIndexOf("/")) &&
        ((a = r.substring(i, n)),
        (l = r.substring(n + 1)),
        a.toLowerCase() == a.toUpperCase() && (a = navigator.appName)),
    -1 != (o = l.indexOf(";")) && (l = l.substring(0, o)),
    -1 != (o = l.indexOf(" ")) && (l = l.substring(0, o)),
    -1 != (o = l.indexOf(")")) && (l = l.substring(0, o)),
    (c = parseInt("" + l, 10)),
    isNaN(c) &&
      ((l = "" + parseFloat(navigator.appVersion)),
      (c = parseInt(navigator.appVersion, 10)));
  var u = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(s),
    h = "-",
    d = [
      { s: "Windows 10", r: /(Windows 10.0|Windows NT 10.0)/ },
      { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
      { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
      { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
      { s: "Windows Vista", r: /Windows NT 6.0/ },
      { s: "Windows Server 2003", r: /Windows NT 5.2/ },
      { s: "Windows XP", r: /(Windows NT 5.1|Windows XP)/ },
      { s: "Windows 2000", r: /(Windows NT 5.0|Windows 2000)/ },
      { s: "Windows ME", r: /(Win 9x 4.90|Windows ME)/ },
      { s: "Windows 98", r: /(Windows 98|Win98)/ },
      { s: "Windows 95", r: /(Windows 95|Win95|Windows_95)/ },
      { s: "Windows NT 4.0", r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
      { s: "Windows CE", r: /Windows CE/ },
      { s: "Windows 3.11", r: /Win16/ },
      { s: "Android", r: /Android/ },
      { s: "Open BSD", r: /OpenBSD/ },
      { s: "Sun OS", r: /SunOS/ },
      { s: "Linux", r: /(Linux|X11)/ },
      { s: "iOS", r: /(iPhone|iPad|iPod)/ },
      { s: "Mac OS X", r: /Mac OS X/ },
      { s: "Mac OS", r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
      { s: "QNX", r: /QNX/ },
      { s: "UNIX", r: /UNIX/ },
      { s: "BeOS", r: /BeOS/ },
      { s: "OS/2", r: /OS\/2/ },
      {
        s: "Search Bot",
        r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/,
      },
    ];
  for (var f in d) {
    var p = d[f];
    if (p.r.test(r)) {
      h = p.s;
      break;
    }
  }
  /Windows/.test(h) && (h = "Windows");
  var g = "no check";
  if ("undefined" != typeof swfobject) {
    var m = swfobject.getFlashPlayerVersion();
    g = m.major > 0 ? m.major + "." + m.minor + " r" + m.release : "-";
  }
  t.jscd = {
    screen: e,
    browser: a,
    browserVersion: l,
    browserMajorVersion: c,
    mobile: u,
    os: h,
    osVersion: "-",
    flashVersion: g,
  };
})(this),
  jQuery_T4NT("html").addClass(
    "t4s-browser-" + jscd.browser + " t4s-platform-" + jscd.os
  );
var jsBdT4s = document.getElementsByTagName("HTML")[0],
  RtlT4s = jsBdT4s.classList.contains("rtl_true"),
  LtrT4s = !RtlT4s;
!(function (t, e) {
  "function" == typeof define && define.amd
    ? define(
        "jQuery_T4NT-bridget/jQuery_T4NT-bridget",
        ["jQuery_T4NT"],
        function (i) {
          return e(t, i);
        }
      )
    : "object" == typeof module && module.exports
    ? (module.exports = e(t, require("jQuery_T4NT")))
    : (t.jQuery_T4NTBridget = e(t, t.jQuery_T4NT));
})(window, function (t, e) {
  "use strict";
  function i(i, s, a) {
    (a = a || e || t.jQuery_T4NT) &&
      (s.prototype.option ||
        (s.prototype.option = function (t) {
          a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t));
        }),
      (a.fn[i] = function (t) {
        return "string" == typeof t
          ? (function (t, e, n) {
              var o,
                s = "$()." + i + '("' + e + '")';
              return (
                t.each(function (t, l) {
                  var c = a.data(l, i);
                  if (c) {
                    var u = c[e];
                    if (u && "_" != e.charAt(0)) {
                      var h = u.apply(c, n);
                      o = void 0 === o ? h : o;
                    } else r(s + " is not a valid method");
                  } else r(i + " not initialized. Cannot call methods, i.e. " + s);
                }),
                void 0 !== o ? o : t
              );
            })(this, t, o.call(arguments, 1))
          : ((function (t, e) {
              t.each(function (t, n) {
                var o = a.data(n, i);
                o
                  ? (o.option(e), o._init())
                  : ((o = new s(n, e)), a.data(n, i, o));
              });
            })(this, t),
            this);
      }),
      n(a));
  }
  function n(t) {
    !t || (t && t.bridget) || (t.bridget = i);
  }
  var o = Array.prototype.slice,
    s = t.console,
    r =
      void 0 === s
        ? function () {}
        : function (t) {
            s.error(t);
          };
  return n(e || t.jQuery_T4NT), i;
}),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("ev-emitter/ev-emitter", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.EvEmitter = e());
  })("undefined" != typeof window ? window : this, function () {
    function t() {}
    var e = t.prototype;
    return (
      (e.on = function (t, e) {
        if (t && e) {
          var i = (this._events = this._events || {}),
            n = (i[t] = i[t] || []);
          return -1 == n.indexOf(e) && n.push(e), this;
        }
      }),
      (e.once = function (t, e) {
        if (t && e) {
          this.on(t, e);
          var i = (this._onceEvents = this._onceEvents || {});
          return ((i[t] = i[t] || {})[e] = !0), this;
        }
      }),
      (e.off = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          var n = i.indexOf(e);
          return -1 != n && i.splice(n, 1), this;
        }
      }),
      (e.emitEvent = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          (i = i.slice(0)), (e = e || []);
          for (
            var n = this._onceEvents && this._onceEvents[t], o = 0;
            o < i.length;
            o++
          ) {
            var s = i[o];
            n && n[s] && (this.off(t, s), delete n[s]), s.apply(this, e);
          }
          return this;
        }
      }),
      (e.allOff = function () {
        delete this._events, delete this._onceEvents;
      }),
      t
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("get-size/get-size", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.getSize = e());
  })(window, function () {
    "use strict";
    function t(t) {
      var e = parseFloat(t);
      return -1 == t.indexOf("%") && !isNaN(e) && e;
    }
    function e(t) {
      var e = getComputedStyle(t);
      return (
        e ||
          s(
            "Style returned " +
              e +
              ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
          ),
        e
      );
    }
    function i() {
      if (!l) {
        l = !0;
        var i = document.createElement("div");
        (i.style.width = "200px"),
          (i.style.padding = "1px 2px 3px 4px"),
          (i.style.borderStyle = "solid"),
          (i.style.borderWidth = "1px 2px 3px 4px"),
          (i.style.boxSizing = "border-box");
        var s = document.body || document.documentElement;
        s.appendChild(i);
        var r = e(i);
        (o = 200 == Math.round(t(r.width))),
          (n.isBoxSizeOuter = o),
          s.removeChild(i);
      }
    }
    function n(n) {
      if (
        (i(),
        "string" == typeof n && (n = document.querySelector(n)),
        n && "object" == typeof n && n.nodeType)
      ) {
        var s = e(n);
        if ("none" == s.display)
          return (function () {
            for (
              var t = {
                  width: 0,
                  height: 0,
                  innerWidth: 0,
                  innerHeight: 0,
                  outerWidth: 0,
                  outerHeight: 0,
                },
                e = 0;
              e < a;
              e++
            )
              t[r[e]] = 0;
            return t;
          })();
        var l = {};
        (l.width = n.offsetWidth), (l.height = n.offsetHeight);
        for (
          var c = (l.isBorderBox = "border-box" == s.boxSizing), u = 0;
          u < a;
          u++
        ) {
          var h = r[u],
            d = s[h],
            f = parseFloat(d);
          l[h] = isNaN(f) ? 0 : f;
        }
        var p = l.paddingLeft + l.paddingRight,
          g = l.paddingTop + l.paddingBottom,
          m = l.marginLeft + l.marginRight,
          v = l.marginTop + l.marginBottom,
          y = l.borderLeftWidth + l.borderRightWidth,
          b = l.borderTopWidth + l.borderBottomWidth,
          x = c && o,
          S = t(s.width);
        !1 !== S && (l.width = S + (x ? 0 : p + y));
        var w = t(s.height);
        return (
          !1 !== w && (l.height = w + (x ? 0 : g + b)),
          (l.innerWidth = l.width - (p + y)),
          (l.innerHeight = l.height - (g + b)),
          (l.outerWidth = l.width + m),
          (l.outerHeight = l.height + v),
          l
        );
      }
    }
    var o,
      s =
        "undefined" == typeof console
          ? function () {}
          : function (t) {
              console.error(t);
            },
      r = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth",
      ],
      a = r.length,
      l = !1;
    return n;
  }),
  (function (t, e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define("desandro-matches-selector/matches-selector", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.matchesSelector = e());
  })(window, function () {
    "use strict";
    var t = (function () {
      var t = window.Element.prototype;
      if (t.matches) return "matches";
      if (t.matchesSelector) return "matchesSelector";
      for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
        var n = e[i] + "MatchesSelector";
        if (t[n]) return n;
      }
    })();
    return function (e, i) {
      return e[t](i);
    };
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "fizzy-ui-utils/utils",
          ["desandro-matches-selector/matches-selector"],
          function (i) {
            return e(t, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("desandro-matches-selector")))
      : (t.fizzyUIUtils = e(t, t.matchesSelector));
  })(window, function (t, e) {
    var i = {
        extend: function (t, e) {
          for (var i in e) t[i] = e[i];
          return t;
        },
        modulo: function (t, e) {
          return ((t % e) + e) % e;
        },
      },
      n = Array.prototype.slice;
    (i.makeArray = function (t) {
      return Array.isArray(t)
        ? t
        : null == t
        ? []
        : "object" == typeof t && "number" == typeof t.length
        ? n.call(t)
        : [t];
    }),
      (i.removeFrom = function (t, e) {
        var i = t.indexOf(e);
        -1 != i && t.splice(i, 1);
      }),
      (i.getParent = function (t, i) {
        for (; t.parentNode && t != document.body; )
          if (((t = t.parentNode), e(t, i))) return t;
      }),
      (i.getQueryElement = function (t) {
        return "string" == typeof t ? document.querySelector(t) : t;
      }),
      (i.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (i.filterFindElements = function (t, n) {
        var o = [];
        return (
          (t = i.makeArray(t)).forEach(function (t) {
            if (t instanceof HTMLElement) {
              if (!n) return void o.push(t);
              e(t, n) && o.push(t);
              for (var i = t.querySelectorAll(n), s = 0; s < i.length; s++)
                o.push(i[s]);
            }
          }),
          o
        );
      }),
      (i.debounceMethod = function (t, e, i) {
        i = i || 100;
        var n = t.prototype[e],
          o = e + "Timeout";
        t.prototype[e] = function () {
          var t = this[o];
          clearTimeout(t);
          var e = arguments,
            s = this;
          this[o] = setTimeout(function () {
            n.apply(s, e), delete s[o];
          }, i);
        };
      }),
      (i.docReady = function (t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e
          ? setTimeout(t)
          : document.addEventListener("DOMContentLoaded", t);
      }),
      (i.toDashed = function (t) {
        return t
          .replace(/(.)([A-Z])/g, function (t, e, i) {
            return e + "-" + i;
          })
          .toLowerCase();
      });
    var o = t.console;
    return (
      (i.htmlInit = function (e, n) {
        i.docReady(function () {
          var s = i.toDashed(n),
            r = "data-" + s,
            a = document.querySelectorAll("[" + r + "]"),
            l = document.querySelectorAll(".js-" + s),
            c = i.makeArray(a).concat(i.makeArray(l)),
            u = r + "-options",
            h = t.jQuery_T4NT;
          c.forEach(function (t) {
            var i,
              s = t.getAttribute(r) || t.getAttribute(u);
            try {
              i = s && JSON.parse(s);
            } catch (e) {
              return void (
                o &&
                o.error("Error parsing " + r + " on " + t.className + ": " + e)
              );
            }
            var a = new e(t, i);
            h && h.data(t, n, a);
          });
        });
      }),
      i
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "outlayer/item",
          ["ev-emitter/ev-emitter", "get-size/get-size"],
          e
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("ev-emitter"), require("get-size")))
      : ((t.Outlayer = {}), (t.Outlayer.Item = e(t.EvEmitter, t.getSize)));
  })(window, function (t, e) {
    "use strict";
    function i(t, e) {
      t &&
        ((this.element = t),
        (this.layout = e),
        (this.position = { x: 0, y: 0 }),
        this._create());
    }
    var n = document.documentElement.style,
      o = "string" == typeof n.transition ? "transition" : "WebkitTransition",
      s = "string" == typeof n.transform ? "transform" : "WebkitTransform",
      r = {
        WebkitTransition: "webkitTransitionEnd",
        transition: "transitionend",
      }[o],
      a = {
        transform: s,
        transition: o,
        transitionDuration: o + "Duration",
        transitionProperty: o + "Property",
        transitionDelay: o + "Delay",
      },
      l = (i.prototype = Object.create(t.prototype));
    (l.constructor = i),
      (l._create = function () {
        (this._transn = { ingProperties: {}, clean: {}, onEnd: {} }),
          this.css({ position: "absolute" });
      }),
      (l.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (l.getSize = function () {
        this.size = e(this.element);
      }),
      (l.css = function (t) {
        var e = this.element.style;
        for (var i in t) e[a[i] || i] = t[i];
      }),
      (l.getPosition = function () {
        var t = getComputedStyle(this.element),
          e = LtrT4s,
          i = this.layout._getOption("originTop"),
          n = t[e ? "left" : "right"],
          o = t[i ? "top" : "bottom"],
          s = parseFloat(n),
          r = parseFloat(o),
          a = this.layout.size;
        -1 != n.indexOf("%") && (s = (s / 100) * a.width),
          -1 != o.indexOf("%") && (r = (r / 100) * a.height),
          (s = isNaN(s) ? 0 : s),
          (r = isNaN(r) ? 0 : r),
          (s -= e ? a.paddingLeft : a.paddingRight),
          (r -= i ? a.paddingTop : a.paddingBottom),
          (this.position.x = s),
          (this.position.y = r);
      }),
      (l.layoutPosition = function () {
        var t = this.layout.size,
          e = {},
          i = LtrT4s,
          n = this.layout._getOption("originTop"),
          o = i ? "paddingLeft" : "paddingRight",
          s = i ? "left" : "right",
          r = i ? "right" : "left",
          a = this.position.x + t[o];
        (e[s] = this.getXValue(a)), (e[r] = "");
        var l = n ? "paddingTop" : "paddingBottom",
          c = n ? "top" : "bottom",
          u = n ? "bottom" : "top",
          h = this.position.y + t[l];
        (e[c] = this.getYValue(h)),
          (e[u] = ""),
          this.css(e),
          this.emitEvent("layout", [this]);
      }),
      (l.getXValue = function (t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !e
          ? (t / this.layout.size.width) * 100 + "%"
          : t + "px";
      }),
      (l.getYValue = function (t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && e
          ? (t / this.layout.size.height) * 100 + "%"
          : t + "px";
      }),
      (l._transitionTo = function (t, e) {
        this.getPosition();
        var i = this.position.x,
          n = this.position.y,
          o = t == this.position.x && e == this.position.y;
        if ((this.setPosition(t, e), !o || this.isTransitioning)) {
          var s = t - i,
            r = e - n,
            a = {};
          (a.transform = this.getTranslate(s, r)),
            this.transition({
              to: a,
              onTransitionEnd: { transform: this.layoutPosition },
              isCleaning: !0,
            });
        } else this.layoutPosition();
      }),
      (l.getTranslate = function (t, e) {
        return (
          "translate3d(" +
          (t = LtrT4s ? t : -t) +
          "px, " +
          (e = this.layout._getOption("originTop") ? e : -e) +
          "px, 0)"
        );
      }),
      (l.goTo = function (t, e) {
        this.setPosition(t, e), this.layoutPosition();
      }),
      (l.moveTo = l._transitionTo),
      (l.setPosition = function (t, e) {
        (this.position.x = parseFloat(t)), (this.position.y = parseFloat(e));
      }),
      (l._nonTransition = function (t) {
        for (var e in (this.css(t.to),
        t.isCleaning && this._removeStyles(t.to),
        t.onTransitionEnd))
          t.onTransitionEnd[e].call(this);
      }),
      (l.transition = function (t) {
        if (parseFloat(this.layout.options.transitionDuration)) {
          var e = this._transn;
          for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
          for (i in t.to)
            (e.ingProperties[i] = !0), t.isCleaning && (e.clean[i] = !0);
          t.from && (this.css(t.from), this.element.offsetHeight),
            this.enableTransition(t.to),
            this.css(t.to),
            (this.isTransitioning = !0);
        } else this._nonTransition(t);
      });
    var c =
      "opacity," +
      s.replace(/([A-Z])/g, function (t) {
        return "-" + t.toLowerCase();
      });
    (l.enableTransition = function () {
      if (!this.isTransitioning) {
        var t = this.layout.options.transitionDuration;
        (t = "number" == typeof t ? t + "ms" : t),
          this.css({
            transitionProperty: c,
            transitionDuration: t,
            transitionDelay: this.staggerDelay || 0,
          }),
          this.element.addEventListener(r, this, !1);
      }
    }),
      (l.onwebkitTransitionEnd = function (t) {
        this.ontransitionend(t);
      }),
      (l.onotransitionend = function (t) {
        this.ontransitionend(t);
      });
    var u = { "-webkit-transform": "transform" };
    (l.ontransitionend = function (t) {
      if (t.target === this.element) {
        var e = this._transn,
          i = u[t.propertyName] || t.propertyName;
        delete e.ingProperties[i],
          (function (t) {
            for (var e in t) return !1;
            return !0;
          })(e.ingProperties) && this.disableTransition(),
          i in e.clean &&
            ((this.element.style[t.propertyName] = ""), delete e.clean[i]),
          i in e.onEnd && (e.onEnd[i].call(this), delete e.onEnd[i]),
          this.emitEvent("transitionEnd", [this]);
      }
    }),
      (l.disableTransition = function () {
        this.removeTransitionStyles(),
          this.element.removeEventListener(r, this, !1),
          (this.isTransitioning = !1);
      }),
      (l._removeStyles = function (t) {
        var e = {};
        for (var i in t) e[i] = "";
        this.css(e);
      });
    var h = {
      transitionProperty: "",
      transitionDuration: "",
      transitionDelay: "",
    };
    return (
      (l.removeTransitionStyles = function () {
        this.css(h);
      }),
      (l.stagger = function (t) {
        (t = isNaN(t) ? 0 : t), (this.staggerDelay = t + "ms");
      }),
      (l.removeElem = function () {
        this.element.parentNode.removeChild(this.element),
          this.css({ display: "" }),
          this.emitEvent("remove", [this]);
      }),
      (l.remove = function () {
        return o && parseFloat(this.layout.options.transitionDuration)
          ? (this.once("transitionEnd", function () {
              this.removeElem();
            }),
            void this.hide())
          : void this.removeElem();
      }),
      (l.reveal = function () {
        delete this.isHidden, this.css({ display: "" });
        var t = this.layout.options,
          e = {};
        (e[this.getHideRevealTransitionEndProperty("visibleStyle")] =
          this.onRevealTransitionEnd),
          this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e,
          });
      }),
      (l.onRevealTransitionEnd = function () {
        this.isHidden || this.emitEvent("reveal");
      }),
      (l.getHideRevealTransitionEndProperty = function (t) {
        var e = this.layout.options[t];
        if (e.opacity) return "opacity";
        for (var i in e) return i;
      }),
      (l.hide = function () {
        (this.isHidden = !0), this.css({ display: "" });
        var t = this.layout.options,
          e = {};
        (e[this.getHideRevealTransitionEndProperty("hiddenStyle")] =
          this.onHideTransitionEnd),
          this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e,
          });
      }),
      (l.onHideTransitionEnd = function () {
        this.isHidden &&
          (this.css({ display: "none" }), this.emitEvent("hide"));
      }),
      (l.destroy = function () {
        this.css({
          position: "",
          left: "",
          right: "",
          top: "",
          bottom: "",
          transition: "",
          transform: "",
        });
      }),
      i
    );
  }),
  (function (t, e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(
          "outlayer/outlayer",
          [
            "ev-emitter/ev-emitter",
            "get-size/get-size",
            "fizzy-ui-utils/utils",
            "./item",
          ],
          function (i, n, o, s) {
            return e(t, i, n, o, s);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(
          t,
          require("ev-emitter"),
          require("get-size"),
          require("fizzy-ui-utils"),
          require("./item")
        ))
      : (t.Outlayer = e(
          t,
          t.EvEmitter,
          t.getSize,
          t.fizzyUIUtils,
          t.Outlayer.Item
        ));
  })(window, function (t, e, i, n, o) {
    "use strict";
    function s(t, e) {
      var i = n.getQueryElement(t);
      if (i) {
        (this.element = i),
          l && (this.$element = l(this.element)),
          (this.options = n.extend({}, this.constructor.defaults)),
          this.option(e);
        var o = ++u;
        (this.element.outlayerGUID = o),
          (h[o] = this),
          this._create(),
          this._getOption("initLayout") && this.layout();
      } else a && a.error("Bad element for " + this.constructor.namespace + ": " + (i || t));
    }
    function r(t) {
      function e() {
        t.apply(this, arguments);
      }
      return (
        (e.prototype = Object.create(t.prototype)),
        (e.prototype.constructor = e),
        e
      );
    }
    var a = t.console,
      l = t.jQuery_T4NT,
      c = function () {},
      u = 0,
      h = {};
    (s.namespace = "outlayer"),
      (s.Item = o),
      (s.defaults = {
        containerStyle: { position: "relative" },
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: { opacity: 0, transform: "scale(0.001)" },
        visibleStyle: { opacity: 1, transform: "scale(1)" },
      });
    var d = s.prototype;
    n.extend(d, e.prototype),
      (d.option = function (t) {
        n.extend(this.options, t);
      }),
      (d._getOption = function (t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e]
          ? this.options[e]
          : this.options[t];
      }),
      (s.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer",
      }),
      (d._create = function () {
        this.reloadItems(),
          (this.stamps = []),
          this.stamp(this.options.stamp),
          n.extend(this.element.style, this.options.containerStyle),
          this._getOption("resize") && this.bindResize();
      }),
      (d.reloadItems = function () {
        this.items = this._itemize(this.element.children);
      }),
      (d._itemize = function (t) {
        for (
          var e = this._filterFindItemElements(t),
            i = this.constructor.Item,
            n = [],
            o = 0;
          o < e.length;
          o++
        ) {
          var s = new i(e[o], this);
          n.push(s);
        }
        return n;
      }),
      (d._filterFindItemElements = function (t) {
        return n.filterFindElements(t, this.options.itemSelector);
      }),
      (d.getItemElements = function () {
        return this.items.map(function (t) {
          return t.element;
        });
      }),
      (d.layout = function () {
        this._resetLayout(), this._manageStamps();
        var t = this._getOption("layoutInstant"),
          e = void 0 !== t ? t : !this._isLayoutInited;
        this.layoutItems(this.items, e), (this._isLayoutInited = !0);
      }),
      (d._init = d.layout),
      (d._resetLayout = function () {
        this.getSize();
      }),
      (d.getSize = function () {
        this.size = i(this.element);
      }),
      (d._getMeasurement = function (t, e) {
        var n,
          o = this.options[t];
        o
          ? ("string" == typeof o
              ? (n = this.element.querySelector(o))
              : o instanceof HTMLElement && (n = o),
            (this[t] = n ? i(n)[e] : o))
          : (this[t] = 0);
      }),
      (d.layoutItems = function (t, e) {
        (t = this._getItemsForLayout(t)),
          this._layoutItems(t, e),
          this._postLayout();
      }),
      (d._getItemsForLayout = function (t) {
        return t.filter(function (t) {
          return !t.isIgnored;
        });
      }),
      (d._layoutItems = function (t, e) {
        if ((this._emitCompleteOnItems("layout", t), t && t.length)) {
          var i = [];
          t.forEach(function (t) {
            var n = this._getItemLayoutPosition(t);
            (n.item = t), (n.isInstant = e || t.isLayoutInstant), i.push(n);
          }, this),
            this._processLayoutQueue(i);
        }
      }),
      (d._getItemLayoutPosition = function () {
        return { x: 0, y: 0 };
      }),
      (d._processLayoutQueue = function (t) {
        this.updateStagger(),
          t.forEach(function (t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e);
          }, this);
      }),
      (d.updateStagger = function () {
        var t = this.options.stagger;
        return null == t
          ? void (this.stagger = 0)
          : ((this.stagger = (function (t) {
              if ("number" == typeof t) return t;
              var e = t.match(/(^\d*\.?\d*)(\w*)/),
                i = e && e[1],
                n = e && e[2];
              return i.length ? (i = parseFloat(i)) * (f[n] || 1) : 0;
            })(t)),
            this.stagger);
      }),
      (d._positionItem = function (t, e, i, n, o) {
        n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i));
      }),
      (d._postLayout = function () {
        this.resizeContainer();
      }),
      (d.resizeContainer = function () {
        if (this._getOption("resizeContainer")) {
          var t = this._getContainerSize();
          t &&
            (this._setContainerMeasure(t.width, !0),
            this._setContainerMeasure(t.height, !1));
        }
      }),
      (d._getContainerSize = c),
      (d._setContainerMeasure = function (t, e) {
        if (void 0 !== t) {
          var i = this.size;
          i.isBorderBox &&
            (t += e
              ? i.paddingLeft +
                i.paddingRight +
                i.borderLeftWidth +
                i.borderRightWidth
              : i.paddingBottom +
                i.paddingTop +
                i.borderTopWidth +
                i.borderBottomWidth),
            (t = Math.max(t, 0)),
            (this.element.style[e ? "width" : "height"] = t + "px");
        }
      }),
      (d._emitCompleteOnItems = function (t, e) {
        function i() {
          o.dispatchEvent(t + "Complete", null, [e]);
        }
        function n() {
          ++r == s && i();
        }
        var o = this,
          s = e.length;
        if (e && s) {
          var r = 0;
          e.forEach(function (e) {
            e.once(t, n);
          });
        } else i();
      }),
      (d.dispatchEvent = function (t, e, i) {
        var n = e ? [e].concat(i) : i;
        if ((this.emitEvent(t, n), l))
          if (((this.$element = this.$element || l(this.element)), e)) {
            var o = l.Event(e);
            (o.type = t), this.$element.trigger(o, i);
          } else this.$element.trigger(t, i);
      }),
      (d.ignore = function (t) {
        var e = this.getItem(t);
        e && (e.isIgnored = !0);
      }),
      (d.unignore = function (t) {
        var e = this.getItem(t);
        e && delete e.isIgnored;
      }),
      (d.stamp = function (t) {
        (t = this._find(t)) &&
          ((this.stamps = this.stamps.concat(t)), t.forEach(this.ignore, this));
      }),
      (d.unstamp = function (t) {
        (t = this._find(t)) &&
          t.forEach(function (t) {
            n.removeFrom(this.stamps, t), this.unignore(t);
          }, this);
      }),
      (d._find = function (t) {
        if (t)
          return (
            "string" == typeof t && (t = this.element.querySelectorAll(t)),
            n.makeArray(t)
          );
      }),
      (d._manageStamps = function () {
        this.stamps &&
          this.stamps.length &&
          (this._getBoundingRect(),
          this.stamps.forEach(this._manageStamp, this));
      }),
      (d._getBoundingRect = function () {
        var t = this.element.getBoundingClientRect(),
          e = this.size;
        this._boundingRect = {
          left: t.left + e.paddingLeft + e.borderLeftWidth,
          top: t.top + e.paddingTop + e.borderTopWidth,
          right: t.right - (e.paddingRight + e.borderRightWidth),
          bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth),
        };
      }),
      (d._manageStamp = c),
      (d._getElementOffset = function (t) {
        var e = t.getBoundingClientRect(),
          n = this._boundingRect,
          o = i(t);
        return {
          left: e.left - n.left - o.marginLeft,
          top: e.top - n.top - o.marginTop,
          right: n.right - e.right - o.marginRight,
          bottom: n.bottom - e.bottom - o.marginBottom,
        };
      }),
      (d.handleEvent = n.handleEvent),
      (d.bindResize = function () {
        t.addEventListener("resize", this), (this.isResizeBound = !0);
      }),
      (d.unbindResize = function () {
        t.removeEventListener("resize", this), (this.isResizeBound = !1);
      }),
      (d.onresize = function () {
        this.resize();
      }),
      n.debounceMethod(s, "onresize", 100),
      (d.resize = function () {
        this.isResizeBound && this.needsResizeLayout() && this.layout();
      }),
      (d.needsResizeLayout = function () {
        var t = i(this.element);
        return this.size && t && t.innerWidth !== this.size.innerWidth;
      }),
      (d.addItems = function (t) {
        var e = this._itemize(t);
        return e.length && (this.items = this.items.concat(e)), e;
      }),
      (d.appended = function (t) {
        var e = this.addItems(t);
        e.length && (this.layoutItems(e, !0), this.reveal(e));
      }),
      (d.prepended = function (t) {
        var e = this._itemize(t);
        if (e.length) {
          var i = this.items.slice(0);
          (this.items = e.concat(i)),
            this._resetLayout(),
            this._manageStamps(),
            this.layoutItems(e, !0),
            this.reveal(e),
            this.layoutItems(i);
        }
      }),
      (d.reveal = function (t) {
        if ((this._emitCompleteOnItems("reveal", t), t && t.length)) {
          var e = this.updateStagger();
          t.forEach(function (t, i) {
            t.stagger(i * e), t.reveal();
          });
        }
      }),
      (d.hide = function (t) {
        if ((this._emitCompleteOnItems("hide", t), t && t.length)) {
          var e = this.updateStagger();
          t.forEach(function (t, i) {
            t.stagger(i * e), t.hide();
          });
        }
      }),
      (d.revealItemElements = function (t) {
        var e = this.getItems(t);
        this.reveal(e);
      }),
      (d.hideItemElements = function (t) {
        var e = this.getItems(t);
        this.hide(e);
      }),
      (d.getItem = function (t) {
        for (var e = 0; e < this.items.length; e++) {
          var i = this.items[e];
          if (i.element == t) return i;
        }
      }),
      (d.getItems = function (t) {
        var e = [];
        return (
          (t = n.makeArray(t)).forEach(function (t) {
            var i = this.getItem(t);
            i && e.push(i);
          }, this),
          e
        );
      }),
      (d.remove = function (t) {
        var e = this.getItems(t);
        this._emitCompleteOnItems("remove", e),
          e &&
            e.length &&
            e.forEach(function (t) {
              t.remove(), n.removeFrom(this.items, t);
            }, this);
      }),
      (d.destroy = function () {
        var t = this.element.style;
        (t.height = ""),
          (t.position = ""),
          (t.width = ""),
          this.items.forEach(function (t) {
            t.destroy();
          }),
          this.unbindResize();
        var e = this.element.outlayerGUID;
        delete h[e],
          delete this.element.outlayerGUID,
          l && l.removeData(this.element, this.constructor.namespace);
      }),
      (s.data = function (t) {
        var e = (t = n.getQueryElement(t)) && t.outlayerGUID;
        return e && h[e];
      }),
      (s.create = function (t, e) {
        var i = r(s);
        return (
          (i.defaults = n.extend({}, s.defaults)),
          n.extend(i.defaults, e),
          (i.compatOptions = n.extend({}, s.compatOptions)),
          (i.namespace = t),
          (i.data = s.data),
          (i.Item = r(o)),
          n.htmlInit(i, t),
          l && l.bridget && l.bridget(t, i),
          i
        );
      });
    var f = { ms: 1, s: 1e3 };
    return (s.Item = o), s;
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("isotopet4s-layout/js/item", ["outlayer/outlayer"], e)
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("outlayer")))
      : ((t.isotopet4s = t.isotopet4s || {}),
        (t.isotopet4s.Item = e(t.Outlayer)));
  })(window, function (t) {
    "use strict";
    function e() {
      t.Item.apply(this, arguments);
    }
    var i = (e.prototype = Object.create(t.Item.prototype)),
      n = i._create;
    (i._create = function () {
      (this.id = this.layout.itemGUID++), n.call(this), (this.sortData = {});
    }),
      (i.updateSortData = function () {
        if (!this.isIgnored) {
          (this.sortData.id = this.id),
            (this.sortData["original-order"] = this.id),
            (this.sortData.random = Math.random());
          var t = this.layout.options.getSortData,
            e = this.layout._sorters;
          for (var i in t) {
            var n = e[i];
            this.sortData[i] = n(this.element, this);
          }
        }
      });
    var o = i.destroy;
    return (
      (i.destroy = function () {
        o.apply(this, arguments), this.css({ display: "" });
      }),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "isotopet4s-layout/js/layout-mode",
          ["get-size/get-size", "outlayer/outlayer"],
          e
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("get-size"), require("outlayer")))
      : ((t.isotopet4s = t.isotopet4s || {}),
        (t.isotopet4s.LayoutMode = e(t.getSize, t.Outlayer)));
  })(window, function (t, e) {
    "use strict";
    function i(t) {
      (this.isotopet4s = t),
        t &&
          ((this.options = t.options[this.namespace]),
          (this.element = t.element),
          (this.items = t.filteredItems),
          (this.size = t.size));
    }
    var n = i.prototype;
    return (
      [
        "_resetLayout",
        "_getItemLayoutPosition",
        "_manageStamp",
        "_getContainerSize",
        "_getElementOffset",
        "needsResizeLayout",
        "_getOption",
      ].forEach(function (t) {
        n[t] = function () {
          return e.prototype[t].apply(this.isotopet4s, arguments);
        };
      }),
      (n.needsVerticalResizeLayout = function () {
        var e = t(this.isotopet4s.element);
        return (
          this.isotopet4s.size &&
          e &&
          e.innerHeight != this.isotopet4s.size.innerHeight
        );
      }),
      (n._getMeasurement = function () {
        this.isotopet4s._getMeasurement.apply(this, arguments);
      }),
      (n.getColumnWidth = function () {
        this.getSegmentSize("column", "Width");
      }),
      (n.getRowHeight = function () {
        this.getSegmentSize("row", "Height");
      }),
      (n.getSegmentSize = function (t, e) {
        var i = t + e,
          n = "outer" + e;
        if ((this._getMeasurement(i, n), !this[i])) {
          var o = this.getFirstItemSize();
          this[i] = (o && o[n]) || this.isotopet4s.size["inner" + e];
        }
      }),
      (n.getFirstItemSize = function () {
        var e = this.isotopet4s.filteredItems[0];
        return e && e.element && t(e.element);
      }),
      (n.layout = function () {
        this.isotopet4s.layout.apply(this.isotopet4s, arguments);
      }),
      (n.getSize = function () {
        this.isotopet4s.getSize(), (this.size = this.isotopet4s.size);
      }),
      (i.modes = {}),
      (i.create = function (t, e) {
        function o() {
          i.apply(this, arguments);
        }
        return (
          (o.prototype = Object.create(n)),
          (o.prototype.constructor = o),
          e && (o.options = e),
          (o.prototype.namespace = t),
          (i.modes[t] = o),
          o
        );
      }),
      i
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "masonry-layout/masonry",
          ["outlayer/outlayer", "get-size/get-size"],
          e
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("outlayer"), require("get-size")))
      : (t.Masonry = e(t.Outlayer, t.getSize));
  })(window, function (t, e) {
    var i = t.create("masonry");
    i.compatOptions.fitWidth = "isFitWidth";
    var n = i.prototype;
    return (
      (n._resetLayout = function () {
        this.getSize(),
          this._getMeasurement("columnWidth", "outerWidth"),
          this._getMeasurement("gutter", "outerWidth"),
          this.measureColumns(),
          (this.colYs = []);
        for (var t = 0; t < this.cols; t++) this.colYs.push(0);
        (this.maxY = 0), (this.horizontalColIndex = 0);
      }),
      (n.measureColumns = function () {
        if ((this.getContainerWidth(), !this.columnWidth)) {
          var t = this.items[0],
            i = t && t.element;
          this.columnWidth = (i && e(i).outerWidth) || this.containerWidth;
        }
        var n = (this.columnWidth += this.gutter),
          o = this.containerWidth + this.gutter,
          s = o / n,
          r = n - (o % n);
        (s = Math[r && r < 1 ? "round" : "floor"](s)),
          (this.cols = Math.max(s, 1));
      }),
      (n.getContainerWidth = function () {
        var t = this._getOption("fitWidth")
            ? this.element.parentNode
            : this.element,
          i = e(t);
        this.containerWidth = i && i.innerWidth;
      }),
      (n._getItemLayoutPosition = function (t) {
        t.getSize();
        var e = t.size.outerWidth % this.columnWidth,
          i = Math[e && e < 1 ? "round" : "ceil"](
            t.size.outerWidth / this.columnWidth
          );
        i = Math.min(i, this.cols);
        for (
          var n = this[
              this.options.horizontalOrder
                ? "_getHorizontalColPosition"
                : "_getTopColPosition"
            ](i, t),
            o = { x: this.columnWidth * n.col, y: n.y },
            s = n.y + t.size.outerHeight,
            r = i + n.col,
            a = n.col;
          a < r;
          a++
        )
          this.colYs[a] = s;
        return o;
      }),
      (n._getTopColPosition = function (t) {
        var e = this._getTopColGroup(t),
          i = Math.min.apply(Math, e);
        return { col: e.indexOf(i), y: i };
      }),
      (n._getTopColGroup = function (t) {
        if (t < 2) return this.colYs;
        for (var e = [], i = this.cols + 1 - t, n = 0; n < i; n++)
          e[n] = this._getColGroupY(n, t);
        return e;
      }),
      (n._getColGroupY = function (t, e) {
        if (e < 2) return this.colYs[t];
        var i = this.colYs.slice(t, t + e);
        return Math.max.apply(Math, i);
      }),
      (n._getHorizontalColPosition = function (t, e) {
        var i = this.horizontalColIndex % this.cols;
        i = t > 1 && i + t > this.cols ? 0 : i;
        var n = e.size.outerWidth && e.size.outerHeight;
        return (
          (this.horizontalColIndex = n ? i + t : this.horizontalColIndex),
          { col: i, y: this._getColGroupY(i, t) }
        );
      }),
      (n._manageStamp = function (t) {
        var i = e(t),
          n = this._getElementOffset(t),
          o = this._getOption("originLeft") ? n.left : n.right,
          s = o + i.outerWidth,
          r = Math.floor(o / this.columnWidth);
        r = Math.max(0, r);
        var a = Math.floor(s / this.columnWidth);
        (a -= s % this.columnWidth ? 0 : 1), (a = Math.min(this.cols - 1, a));
        for (
          var l =
              (this._getOption("originTop") ? n.top : n.bottom) + i.outerHeight,
            c = r;
          c <= a;
          c++
        )
          this.colYs[c] = Math.max(l, this.colYs[c]);
      }),
      (n._getContainerSize = function () {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = { height: this.maxY };
        return (
          this._getOption("fitWidth") &&
            (t.width = this._getContainerFitWidth()),
          t
        );
      }),
      (n._getContainerFitWidth = function () {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e]; ) t++;
        return (this.cols - t) * this.columnWidth - this.gutter;
      }),
      (n.needsResizeLayout = function () {
        var t = this.containerWidth;
        return this.getContainerWidth(), t != this.containerWidth;
      }),
      i
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "isotopet4s-layout/js/layout-modes/masonry",
          ["../layout-mode", "masonry-layout/masonry"],
          e
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(
          require("../layout-mode"),
          require("masonry-layout")
        ))
      : e(t.isotopet4s.LayoutMode, t.Masonry);
  })(window, function (t, e) {
    "use strict";
    var i = t.create("masonry"),
      n = i.prototype,
      o = { _getElementOffset: !0, layout: !0, _getMeasurement: !0 };
    for (var s in e.prototype) o[s] || (n[s] = e.prototype[s]);
    var r = n.measureColumns;
    n.measureColumns = function () {
      (this.items = this.isotopet4s.filteredItems), r.call(this);
    };
    var a = n._getOption;
    return (
      (n._getOption = function (t) {
        return "fitWidth" == t
          ? void 0 !== this.options.isFitWidth
            ? this.options.isFitWidth
            : this.options.fitWidth
          : a.apply(this.isotopet4s, arguments);
      }),
      i
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "isotopet4s-layout/js/layout-modes/fit-rows",
          ["../layout-mode"],
          e
        )
      : "object" == typeof exports
      ? (module.exports = e(require("../layout-mode")))
      : e(t.isotopet4s.LayoutMode);
  })(window, function (t) {
    "use strict";
    var e = t.create("fitRows"),
      i = e.prototype;
    return (
      (i._resetLayout = function () {
        (this.x = 0),
          (this.y = 0),
          (this.maxY = 0),
          this._getMeasurement("gutter", "outerWidth");
      }),
      (i._getItemLayoutPosition = function (t) {
        t.getSize();
        var e = t.size.outerWidth + this.gutter,
          i = this.isotopet4s.size.innerWidth + this.gutter;
        0 !== this.x && e + this.x > i && ((this.x = 0), (this.y = this.maxY));
        var n = { x: this.x, y: this.y };
        return (
          (this.maxY = Math.max(this.maxY, this.y + t.size.outerHeight)),
          (this.x += e),
          n
        );
      }),
      (i._getContainerSize = function () {
        return { height: this.maxY };
      }),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "isotopet4s-layout/js/layout-modes/vertical",
          ["../layout-mode"],
          e
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("../layout-mode")))
      : e(t.isotopet4s.LayoutMode);
  })(window, function (t) {
    "use strict";
    var e = t.create("vertical", { horizontalAlignment: 0 }),
      i = e.prototype;
    return (
      (i._resetLayout = function () {
        this.y = 0;
      }),
      (i._getItemLayoutPosition = function (t) {
        t.getSize();
        var e =
            (this.isotopet4s.size.innerWidth - t.size.outerWidth) *
            this.options.horizontalAlignment,
          i = this.y;
        return (this.y += t.size.outerHeight), { x: e, y: i };
      }),
      (i._getContainerSize = function () {
        return { height: this.y };
      }),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          [
            "outlayer/outlayer",
            "get-size/get-size",
            "desandro-matches-selector/matches-selector",
            "fizzy-ui-utils/utils",
            "isotopet4s-layout/js/item",
            "isotopet4s-layout/js/layout-mode",
            "isotopet4s-layout/js/layout-modes/masonry",
            "isotopet4s-layout/js/layout-modes/fit-rows",
            "isotopet4s-layout/js/layout-modes/vertical",
          ],
          function (i, n, o, s, r, a) {
            return e(t, i, n, o, s, r, a);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(
          t,
          require("outlayer"),
          require("get-size"),
          require("desandro-matches-selector"),
          require("fizzy-ui-utils"),
          require("isotopet4s-layout/js/item"),
          require("isotopet4s-layout/js/layout-mode"),
          require("isotopet4s-layout/js/layout-modes/masonry"),
          require("isotopet4s-layout/js/layout-modes/fit-rows"),
          require("isotopet4s-layout/js/layout-modes/vertical")
        ))
      : (t.isotopet4s = e(
          t,
          t.Outlayer,
          t.getSize,
          t.matchesSelector,
          t.fizzyUIUtils,
          t.isotopet4s.Item,
          t.isotopet4s.LayoutMode
        ));
  })(window, function (t, e, i, n, o, s, r) {
    var a = t.jQuery_T4NT,
      l = String.prototype.trim
        ? function (t) {
            return t.trim();
          }
        : function (t) {
            return t.replace(/^\s+|\s+$/g, "");
          },
      c = e.create("isotopet4s", {
        layoutMode: "masonry",
        isjQuery_T4NTFiltering: !0,
        sortAscending: !0,
      });
    (c.Item = s), (c.LayoutMode = r);
    var u = c.prototype;
    (u._create = function () {
      for (var t in ((this.itemGUID = 0),
      (this._sorters = {}),
      this._getSorters(),
      e.prototype._create.call(this),
      (this.modes = {}),
      (this.filteredItems = this.items),
      (this.sortHistory = ["original-order"]),
      r.modes))
        this._initLayoutMode(t);
    }),
      (u.reloadItems = function () {
        (this.itemGUID = 0), e.prototype.reloadItems.call(this);
      }),
      (u._itemize = function () {
        for (
          var t = e.prototype._itemize.apply(this, arguments), i = 0;
          i < t.length;
          i++
        )
          t[i].id = this.itemGUID++;
        return this._updateItemsSortData(t), t;
      }),
      (u._initLayoutMode = function (t) {
        var e = r.modes[t],
          i = this.options[t] || {};
        (this.options[t] = e.options ? o.extend(e.options, i) : i),
          (this.modes[t] = new e(this));
      }),
      (u.layout = function () {
        return !this._isLayoutInited && this._getOption("initLayout")
          ? void this.arrange()
          : void this._layout();
      }),
      (u._layout = function () {
        var t = this._getIsInstant();
        this._resetLayout(),
          this._manageStamps(),
          this.layoutItems(this.filteredItems, t),
          (this._isLayoutInited = !0);
      }),
      (u.arrange = function (t) {
        this.option(t), this._getIsInstant();
        var e = this._filter(this.items);
        (this.filteredItems = e.matches),
          this._bindArrangeComplete(),
          this._isInstant
            ? this._noTransition(this._hideReveal, [e])
            : this._hideReveal(e),
          this._sort(),
          this._layout();
      }),
      (u._init = u.arrange),
      (u._hideReveal = function (t) {
        this.reveal(t.needReveal), this.hide(t.needHide);
      }),
      (u._getIsInstant = function () {
        var t = this._getOption("layoutInstant"),
          e = void 0 !== t ? t : !this._isLayoutInited;
        return (this._isInstant = e), e;
      }),
      (u._bindArrangeComplete = function () {
        function t() {
          e &&
            i &&
            n &&
            o.dispatchEvent("arrangeComplete", null, [o.filteredItems]);
        }
        var e,
          i,
          n,
          o = this;
        this.once("layoutComplete", function () {
          (e = !0), t();
        }),
          this.once("hideComplete", function () {
            (i = !0), t();
          }),
          this.once("revealComplete", function () {
            (n = !0), t();
          });
      }),
      (u._filter = function (t) {
        var e = this.options.filter;
        e = e || "*";
        for (
          var i = [], n = [], o = [], s = this._getFilterTest(e), r = 0;
          r < t.length;
          r++
        ) {
          var a = t[r];
          if (!a.isIgnored) {
            var l = s(a);
            l && i.push(a),
              l && a.isHidden ? n.push(a) : l || a.isHidden || o.push(a);
          }
        }
        return { matches: i, needReveal: n, needHide: o };
      }),
      (u._getFilterTest = function (t) {
        return a && this.options.isjQuery_T4NTFiltering
          ? function (e) {
              return a(e.element).is(t);
            }
          : "function" == typeof t
          ? function (e) {
              return t(e.element);
            }
          : function (e) {
              return n(e.element, t);
            };
      }),
      (u.updateSortData = function (t) {
        var e;
        t ? ((t = o.makeArray(t)), (e = this.getItems(t))) : (e = this.items),
          this._getSorters(),
          this._updateItemsSortData(e);
      }),
      (u._getSorters = function () {
        var t = this.options.getSortData;
        for (var e in t) {
          var i = t[e];
          this._sorters[e] = h(i);
        }
      }),
      (u._updateItemsSortData = function (t) {
        for (var e = t && t.length, i = 0; e && i < e; i++)
          t[i].updateSortData();
      });
    var h = function (t) {
      if ("string" != typeof t) return t;
      var e = l(t).split(" "),
        i = e[0],
        n = i.match(/^\[(.+)\]$/),
        o = (function (t, e) {
          return t
            ? function (e) {
                return e.getAttribute(t);
              }
            : function (t) {
                var i = t.querySelector(e);
                return i && i.textContent;
              };
        })(n && n[1], i),
        s = c.sortDataParsers[e[1]];
      return s
        ? function (t) {
            return t && s(o(t));
          }
        : function (t) {
            return t && o(t);
          };
    };
    (c.sortDataParsers = {
      parseInt: function (t) {
        return parseInt(t, 10);
      },
      parseFloat: function (t) {
        return parseFloat(t);
      },
    }),
      (u._sort = function () {
        if (this.options.sortBy) {
          var t = o.makeArray(this.options.sortBy);
          this._getIsSameSortBy(t) ||
            (this.sortHistory = t.concat(this.sortHistory));
          var e = (function (t, e) {
            return function (i, n) {
              for (var o = 0; o < t.length; o++) {
                var s = t[o],
                  r = i.sortData[s],
                  a = n.sortData[s];
                if (r > a || r < a)
                  return (
                    (r > a ? 1 : -1) * ((void 0 !== e[s] ? e[s] : e) ? 1 : -1)
                  );
              }
              return 0;
            };
          })(this.sortHistory, this.options.sortAscending);
          this.filteredItems.sort(e);
        }
      }),
      (u._getIsSameSortBy = function (t) {
        for (var e = 0; e < t.length; e++)
          if (t[e] != this.sortHistory[e]) return !1;
        return !0;
      }),
      (u._mode = function () {
        var t = this.options.layoutMode,
          e = this.modes[t];
        if (!e) throw new Error("No layout mode: " + t);
        return (e.options = this.options[t]), e;
      }),
      (u._resetLayout = function () {
        e.prototype._resetLayout.call(this), this._mode()._resetLayout();
      }),
      (u._getItemLayoutPosition = function (t) {
        return this._mode()._getItemLayoutPosition(t);
      }),
      (u._manageStamp = function (t) {
        this._mode()._manageStamp(t);
      }),
      (u._getContainerSize = function () {
        return this._mode()._getContainerSize();
      }),
      (u.needsResizeLayout = function () {
        return this._mode().needsResizeLayout();
      }),
      (u.appended = function (t) {
        var e = this.addItems(t);
        if (e.length) {
          var i = this._filterRevealAdded(e);
          this.filteredItems = this.filteredItems.concat(i);
        }
      }),
      (u.prepended = function (t) {
        var e = this._itemize(t);
        if (e.length) {
          this._resetLayout(), this._manageStamps();
          var i = this._filterRevealAdded(e);
          this.layoutItems(this.filteredItems),
            (this.filteredItems = i.concat(this.filteredItems)),
            (this.items = e.concat(this.items));
        }
      }),
      (u._filterRevealAdded = function (t) {
        var e = this._filter(t);
        return (
          this.hide(e.needHide),
          this.reveal(e.matches),
          this.layoutItems(e.matches, !0),
          e.matches
        );
      }),
      (u.insert = function (t) {
        var e = this.addItems(t);
        if (e.length) {
          var i,
            n,
            o = e.length;
          for (i = 0; i < o; i++)
            (n = e[i]), this.element.appendChild(n.element);
          var s = this._filter(e).matches;
          for (i = 0; i < o; i++) e[i].isLayoutInstant = !0;
          for (this.arrange(), i = 0; i < o; i++) delete e[i].isLayoutInstant;
          this.reveal(s);
        }
      });
    var d = u.remove;
    return (
      (u.remove = function (t) {
        t = o.makeArray(t);
        var e = this.getItems(t);
        d.call(this, t);
        for (var i = e && e.length, n = 0; i && n < i; n++) {
          var s = e[n];
          o.removeFrom(this.filteredItems, s);
        }
      }),
      (u.shuffle = function () {
        for (var t = 0; t < this.items.length; t++)
          this.items[t].sortData.random = Math.random();
        (this.options.sortBy = "random"), this._sort(), this._layout();
      }),
      (u._noTransition = function (t, e) {
        var i = this.options.transitionDuration;
        this.options.transitionDuration = 0;
        var n = t.apply(this, e);
        return (this.options.transitionDuration = i), n;
      }),
      (u.getFilteredItemElements = function () {
        return this.filteredItems.map(function (t) {
          return t.element;
        });
      }),
      c
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("packery/js/rect", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : ((t.Packery = t.Packery || {}), (t.Packery.Rect = e()));
  })(window, function () {
    function t(e) {
      for (var i in t.defaults) this[i] = t.defaults[i];
      for (i in e) this[i] = e[i];
    }
    t.defaults = { x: 0, y: 0, width: 0, height: 0 };
    var e = t.prototype;
    return (
      (e.contains = function (t) {
        var e = t.width || 0,
          i = t.height || 0;
        return (
          this.x <= t.x &&
          this.y <= t.y &&
          this.x + this.width >= t.x + e &&
          this.y + this.height >= t.y + i
        );
      }),
      (e.overlaps = function (t) {
        var e = this.x + this.width,
          i = this.y + this.height,
          n = t.x + t.width,
          o = t.y + t.height;
        return this.x < n && e > t.x && this.y < o && i > t.y;
      }),
      (e.getMaximalFreeRects = function (e) {
        if (!this.overlaps(e)) return !1;
        var i,
          n = [],
          o = this.x + this.width,
          s = this.y + this.height,
          r = e.x + e.width,
          a = e.y + e.height;
        return (
          this.y < e.y &&
            ((i = new t({
              x: this.x,
              y: this.y,
              width: this.width,
              height: e.y - this.y,
            })),
            n.push(i)),
          o > r &&
            ((i = new t({
              x: r,
              y: this.y,
              width: o - r,
              height: this.height,
            })),
            n.push(i)),
          s > a &&
            ((i = new t({ x: this.x, y: a, width: this.width, height: s - a })),
            n.push(i)),
          this.x < e.x &&
            ((i = new t({
              x: this.x,
              y: this.y,
              width: e.x - this.x,
              height: this.height,
            })),
            n.push(i)),
          n
        );
      }),
      (e.canFit = function (t) {
        return this.width >= t.width && this.height >= t.height;
      }),
      t
    );
  }),
  (function (t, e) {
    if ("function" == typeof define && define.amd)
      define("packery/js/packer", ["./rect"], e);
    else if ("object" == typeof module && module.exports)
      module.exports = e(require("./rect"));
    else {
      var i = (t.Packery = t.Packery || {});
      i.Packer = e(i.Rect);
    }
  })(window, function (t) {
    function e(t, e, i) {
      (this.width = t || 0),
        (this.height = e || 0),
        (this.sortDirection = i || "downwardLeftToRight"),
        this.reset();
    }
    var i = e.prototype;
    (i.reset = function () {
      this.spaces = [];
      var e = new t({ x: 0, y: 0, width: this.width, height: this.height });
      this.spaces.push(e),
        (this.sorter = n[this.sortDirection] || n.downwardLeftToRight);
    }),
      (i.pack = function (t) {
        for (var e = 0; e < this.spaces.length; e++) {
          var i = this.spaces[e];
          if (i.canFit(t)) {
            this.placeInSpace(t, i);
            break;
          }
        }
      }),
      (i.columnPack = function (t) {
        for (var e = 0; e < this.spaces.length; e++) {
          var i = this.spaces[e];
          if (
            i.x <= t.x &&
            i.x + i.width >= t.x + t.width &&
            i.height >= t.height - 0.01
          ) {
            (t.y = i.y), this.placed(t);
            break;
          }
        }
      }),
      (i.rowPack = function (t) {
        for (var e = 0; e < this.spaces.length; e++) {
          var i = this.spaces[e];
          if (
            i.y <= t.y &&
            i.y + i.height >= t.y + t.height &&
            i.width >= t.width - 0.01
          ) {
            (t.x = i.x), this.placed(t);
            break;
          }
        }
      }),
      (i.placeInSpace = function (t, e) {
        (t.x = e.x), (t.y = e.y), this.placed(t);
      }),
      (i.placed = function (t) {
        for (var e = [], i = 0; i < this.spaces.length; i++) {
          var n = this.spaces[i],
            o = n.getMaximalFreeRects(t);
          o ? e.push.apply(e, o) : e.push(n);
        }
        (this.spaces = e), this.mergeSortSpaces();
      }),
      (i.mergeSortSpaces = function () {
        e.mergeRects(this.spaces), this.spaces.sort(this.sorter);
      }),
      (i.addSpace = function (t) {
        this.spaces.push(t), this.mergeSortSpaces();
      }),
      (e.mergeRects = function (t) {
        var e = 0,
          i = t[e];
        t: for (; i; ) {
          for (var n = 0, o = t[e + n]; o; ) {
            if (o == i) n++;
            else {
              if (o.contains(i)) {
                t.splice(e, 1), (i = t[e]);
                continue t;
              }
              i.contains(o) ? t.splice(e + n, 1) : n++;
            }
            o = t[e + n];
          }
          i = t[++e];
        }
        return t;
      });
    var n = {
      downwardLeftToRight: function (t, e) {
        return t.y - e.y || t.x - e.x;
      },
      rightwardTopToBottom: function (t, e) {
        return t.x - e.x || t.y - e.y;
      },
    };
    return e;
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("packery/js/item", ["outlayer/outlayer", "./rect"], e)
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("outlayer"), require("./rect")))
      : (t.Packery.Item = e(t.Outlayer, t.Packery.Rect));
  })(window, function (t, e) {
    var i =
        "string" == typeof document.documentElement.style.transform
          ? "transform"
          : "WebkitTransform",
      n = function () {
        t.Item.apply(this, arguments);
      },
      o = (n.prototype = Object.create(t.Item.prototype)),
      s = o._create;
    o._create = function () {
      s.call(this), (this.rect = new e());
    };
    var r = o.moveTo;
    return (
      (o.moveTo = function (t, e) {
        var i = Math.abs(this.position.x - t),
          n = Math.abs(this.position.y - e);
        return this.layout.dragItemCount &&
          !this.isPlacing &&
          !this.isTransitioning &&
          1 > i &&
          1 > n
          ? void this.goTo(t, e)
          : void r.apply(this, arguments);
      }),
      (o.enablePlacing = function () {
        this.removeTransitionStyles(),
          this.isTransitioning && i && (this.element.style[i] = "none"),
          (this.isTransitioning = !1),
          this.getSize(),
          this.layout._setRectSize(this.element, this.rect),
          (this.isPlacing = !0);
      }),
      (o.disablePlacing = function () {
        this.isPlacing = !1;
      }),
      (o.removeElem = function () {
        this.element.parentNode.removeChild(this.element),
          this.layout.packer.addSpace(this.rect),
          this.emitEvent("remove", [this]);
      }),
      (o.showDropPlaceholder = function () {
        var t = this.dropPlaceholder;
        t ||
          (((t = this.dropPlaceholder =
            document.createElement("div")).className =
            "packery-drop-placeholder"),
          (t.style.position = "absolute")),
          (t.style.width = this.size.width + "px"),
          (t.style.height = this.size.height + "px"),
          this.positionDropPlaceholder(),
          this.layout.element.appendChild(t);
      }),
      (o.positionDropPlaceholder = function () {
        this.dropPlaceholder.style[i] =
          "translate(" + this.rect.x + "px, " + this.rect.y + "px)";
      }),
      (o.hideDropPlaceholder = function () {
        this.layout.element.removeChild(this.dropPlaceholder);
      }),
      n
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "packery/js/packery",
          [
            "get-size/get-size",
            "outlayer/outlayer",
            "./rect",
            "./packer",
            "./item",
          ],
          e
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(
          require("get-size"),
          require("outlayer"),
          require("./rect"),
          require("./packer"),
          require("./item")
        ))
      : (t.Packery = e(
          t.getSize,
          t.Outlayer,
          t.Packery.Rect,
          t.Packery.Packer,
          t.Packery.Item
        ));
  })(window, function (t, e, i, n, o) {
    i.prototype.canFit = function (t) {
      return this.width >= t.width - 1 && this.height >= t.height - 1;
    };
    var s = e.create("packery");
    s.Item = o;
    var r = s.prototype;
    (r._create = function () {
      e.prototype._create.call(this),
        (this.packer = new n()),
        (this.shiftPacker = new n()),
        (this.isEnabled = !0),
        (this.dragItemCount = 0);
      var t = this;
      (this.handleDraggabilly = {
        dragStart: function () {
          t.itemDragStart(this.element);
        },
        dragMove: function () {
          t.itemDragMove(this.element, this.position.x, this.position.y);
        },
        dragEnd: function () {
          t.itemDragEnd(this.element);
        },
      }),
        (this.handleUIDraggable = {
          start: function (e, i) {
            i && t.itemDragStart(e.currentTarget);
          },
          drag: function (e, i) {
            i &&
              t.itemDragMove(e.currentTarget, i.position.left, i.position.top);
          },
          stop: function (e, i) {
            i && t.itemDragEnd(e.currentTarget);
          },
        });
    }),
      (r._resetLayout = function () {
        var t, e, i;
        this.getSize(),
          this._getMeasurements(),
          this._getOption("horizontal")
            ? ((t = 1 / 0),
              (e = this.size.innerHeight + this.gutter),
              (i = "rightwardTopToBottom"))
            : ((t = this.size.innerWidth + this.gutter),
              (e = 1 / 0),
              (i = "downwardLeftToRight")),
          (this.packer.width = this.shiftPacker.width = t),
          (this.packer.height = this.shiftPacker.height = e),
          (this.packer.sortDirection = this.shiftPacker.sortDirection = i),
          this.packer.reset(),
          (this.maxY = 0),
          (this.maxX = 0);
      }),
      (r._getMeasurements = function () {
        this._getMeasurement("columnWidth", "width"),
          this._getMeasurement("rowHeight", "height"),
          this._getMeasurement("gutter", "width");
      }),
      (r._getItemLayoutPosition = function (t) {
        if (
          (this._setRectSize(t.element, t.rect),
          this.isShifting || this.dragItemCount > 0)
        ) {
          var e = this._getPackMethod();
          this.packer[e](t.rect);
        } else this.packer.pack(t.rect);
        return this._setMaxXY(t.rect), t.rect;
      }),
      (r.shiftLayout = function () {
        (this.isShifting = !0), this.layout(), delete this.isShifting;
      }),
      (r._getPackMethod = function () {
        return this._getOption("horizontal") ? "rowPack" : "columnPack";
      }),
      (r._setMaxXY = function (t) {
        (this.maxX = Math.max(t.x + t.width, this.maxX)),
          (this.maxY = Math.max(t.y + t.height, this.maxY));
      }),
      (r._setRectSize = function (e, i) {
        var n = t(e),
          o = n.outerWidth,
          s = n.outerHeight;
        (o || s) &&
          ((o = this._applyGridGutter(o, this.columnWidth)),
          (s = this._applyGridGutter(s, this.rowHeight))),
          (i.width = Math.min(o, this.packer.width)),
          (i.height = Math.min(s, this.packer.height));
      }),
      (r._applyGridGutter = function (t, e) {
        if (!e) return t + this.gutter;
        var i = t % (e += this.gutter);
        return Math[i && 1 > i ? "round" : "ceil"](t / e) * e;
      }),
      (r._getContainerSize = function () {
        return this._getOption("horizontal")
          ? { width: this.maxX - this.gutter }
          : { height: this.maxY - this.gutter };
      }),
      (r._manageStamp = function (t) {
        var e,
          n = this.getItem(t);
        if (n && n.isPlacing) e = n.rect;
        else {
          var o = this._getElementOffset(t);
          e = new i({
            x: this._getOption("originLeft") ? o.left : o.right,
            y: this._getOption("originTop") ? o.top : o.bottom,
          });
        }
        this._setRectSize(t, e), this.packer.placed(e), this._setMaxXY(e);
      }),
      (r.sortItemsByPosition = function () {
        var t = this._getOption("horizontal")
          ? function (t, e) {
              return t.position.x - e.position.x || t.position.y - e.position.y;
            }
          : function (t, e) {
              return t.position.y - e.position.y || t.position.x - e.position.x;
            };
        this.items.sort(t);
      }),
      (r.fit = function (t, e, i) {
        var n = this.getItem(t);
        n &&
          (this.stamp(n.element),
          n.enablePlacing(),
          this.updateShiftTargets(n),
          (e = void 0 === e ? n.rect.x : e),
          (i = void 0 === i ? n.rect.y : i),
          this.shift(n, e, i),
          this._bindFitEvents(n),
          n.moveTo(n.rect.x, n.rect.y),
          this.shiftLayout(),
          this.unstamp(n.element),
          this.sortItemsByPosition(),
          n.disablePlacing());
      }),
      (r._bindFitEvents = function (t) {
        function e() {
          2 == ++n && i.dispatchEvent("fitComplete", null, [t]);
        }
        var i = this,
          n = 0;
        t.once("layout", e), this.once("layoutComplete", e);
      }),
      (r.resize = function () {
        this.isResizeBound &&
          this.needsResizeLayout() &&
          (this.options.shiftPercentResize
            ? this.resizeShiftPercentLayout()
            : this.layout());
      }),
      (r.needsResizeLayout = function () {
        var e = t(this.element),
          i = this._getOption("horizontal") ? "innerHeight" : "innerWidth";
        return e[i] != this.size[i];
      }),
      (r.resizeShiftPercentLayout = function () {
        var e = this._getItemsForLayout(this.items),
          i = this._getOption("horizontal"),
          n = i ? "y" : "x",
          o = i ? "height" : "width",
          s = i ? "rowHeight" : "columnWidth",
          r = i ? "innerHeight" : "innerWidth",
          a = this[s];
        if ((a = a && a + this.gutter)) {
          this._getMeasurements();
          var l = this[s] + this.gutter;
          e.forEach(function (t) {
            var e = Math.round(t.rect[n] / a);
            t.rect[n] = e * l;
          });
        } else {
          var c = t(this.element)[r] + this.gutter,
            u = this.packer[o];
          e.forEach(function (t) {
            t.rect[n] = (t.rect[n] / u) * c;
          });
        }
        this.shiftLayout();
      }),
      (r.itemDragStart = function (t) {
        if (this.isEnabled) {
          this.stamp(t);
          var e = this.getItem(t);
          e &&
            (e.enablePlacing(),
            e.showDropPlaceholder(),
            this.dragItemCount++,
            this.updateShiftTargets(e));
        }
      }),
      (r.updateShiftTargets = function (t) {
        this.shiftPacker.reset(), this._getBoundingRect();
        var e = this._getOption("originLeft"),
          n = this._getOption("originTop");
        this.stamps.forEach(function (t) {
          var o = this.getItem(t);
          if (!o || !o.isPlacing) {
            var s = this._getElementOffset(t),
              r = new i({ x: e ? s.left : s.right, y: n ? s.top : s.bottom });
            this._setRectSize(t, r), this.shiftPacker.placed(r);
          }
        }, this);
        var o = this._getOption("horizontal"),
          s = o ? "rowHeight" : "columnWidth",
          r = o ? "height" : "width";
        (this.shiftTargetKeys = []), (this.shiftTargets = []);
        var a,
          l = this[s];
        if ((l = l && l + this.gutter)) {
          var c = Math.ceil(t.rect[r] / l),
            u = Math.floor((this.shiftPacker[r] + this.gutter) / l);
          a = (u - c) * l;
          for (var h = 0; u > h; h++) this._addShiftTarget(h * l, 0, a);
        } else
          (a = this.shiftPacker[r] + this.gutter - t.rect[r]),
            this._addShiftTarget(0, 0, a);
        var d = this._getItemsForLayout(this.items),
          f = this._getPackMethod();
        d.forEach(function (t) {
          var e = t.rect;
          this._setRectSize(t.element, e),
            this.shiftPacker[f](e),
            this._addShiftTarget(e.x, e.y, a);
          var i = o ? e.x + e.width : e.x,
            n = o ? e.y : e.y + e.height;
          if ((this._addShiftTarget(i, n, a), l))
            for (var s = Math.round(e[r] / l), c = 1; s > c; c++) {
              var u = o ? i : e.x + l * c,
                h = o ? e.y + l * c : n;
              this._addShiftTarget(u, h, a);
            }
        }, this);
      }),
      (r._addShiftTarget = function (t, e, i) {
        var n = this._getOption("horizontal") ? e : t;
        if (!(0 !== n && n > i)) {
          var o = t + "," + e;
          -1 != this.shiftTargetKeys.indexOf(o) ||
            (this.shiftTargetKeys.push(o),
            this.shiftTargets.push({ x: t, y: e }));
        }
      }),
      (r.shift = function (t, e, i) {
        var n,
          o = 1 / 0,
          s = { x: e, y: i };
        this.shiftTargets.forEach(function (t) {
          var e = (function (t, e) {
            var i = e.x - t.x,
              n = e.y - t.y;
            return Math.sqrt(i * i + n * n);
          })(t, s);
          o > e && ((n = t), (o = e));
        }),
          (t.rect.x = n.x),
          (t.rect.y = n.y);
      }),
      (r.itemDragMove = function (t, e, i) {
        function n() {
          s.shift(o, e, i), o.positionDropPlaceholder(), s.layout();
        }
        var o = this.isEnabled && this.getItem(t);
        if (o) {
          (e -= this.size.paddingLeft), (i -= this.size.paddingTop);
          var s = this,
            r = new Date();
          this._itemDragTime && r - this._itemDragTime < 120
            ? (clearTimeout(this.dragTimeout),
              (this.dragTimeout = setTimeout(n, 120)))
            : (n(), (this._itemDragTime = r));
        }
      }),
      (r.itemDragEnd = function (t) {
        function e() {
          2 == ++n &&
            (i.element.classList.remove("is-positioning-post-drag"),
            i.hideDropPlaceholder(),
            o.dispatchEvent("dragItemPositioned", null, [i]));
        }
        var i = this.isEnabled && this.getItem(t);
        if (i) {
          clearTimeout(this.dragTimeout),
            i.element.classList.add("is-positioning-post-drag");
          var n = 0,
            o = this;
          i.once("layout", e),
            this.once("layoutComplete", e),
            i.moveTo(i.rect.x, i.rect.y),
            this.layout(),
            (this.dragItemCount = Math.max(0, this.dragItemCount - 1)),
            this.sortItemsByPosition(),
            i.disablePlacing(),
            this.unstamp(i.element);
        }
      }),
      (r.bindDraggabillyEvents = function (t) {
        this._bindDraggabillyEvents(t, "on");
      }),
      (r.unbindDraggabillyEvents = function (t) {
        this._bindDraggabillyEvents(t, "off");
      }),
      (r._bindDraggabillyEvents = function (t, e) {
        var i = this.handleDraggabilly;
        t[e]("dragStart", i.dragStart),
          t[e]("dragMove", i.dragMove),
          t[e]("dragEnd", i.dragEnd);
      }),
      (r.bindUIDraggableEvents = function (t) {
        this._bindUIDraggableEvents(t, "on");
      }),
      (r.unbindUIDraggableEvents = function (t) {
        this._bindUIDraggableEvents(t, "off");
      }),
      (r._bindUIDraggableEvents = function (t, e) {
        var i = this.handleUIDraggable;
        t[e]("dragstart", i.start)[e]("drag", i.drag)[e]("dragstop", i.stop);
      });
    var a = r.destroy;
    return (
      (r.destroy = function () {
        a.apply(this, arguments), (this.isEnabled = !1);
      }),
      (s.Rect = i),
      (s.Packer = n),
      s
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(["isotopet4s-layout/js/layout-mode", "packery/js/packery"], e)
      : "object" == typeof module && module.exports
      ? (module.exports = e(
          require("isotopet4s-layout/js/layout-mode"),
          require("packery")
        ))
      : e(t.isotopet4s.LayoutMode, t.Packery);
  })(window, function (t, e) {
    var i = t.create("packery"),
      n = i.prototype,
      o = { _getElementOffset: !0, _getMeasurement: !0 };
    for (var s in e.prototype) o[s] || (n[s] = e.prototype[s]);
    var r = n._resetLayout;
    n._resetLayout = function () {
      (this.packer = this.packer || new e.Packer()),
        (this.shiftPacker = this.shiftPacker || new e.Packer()),
        r.apply(this, arguments);
    };
    var a = n._getItemLayoutPosition;
    n._getItemLayoutPosition = function (t) {
      return (t.rect = t.rect || new e.Rect()), a.call(this, t);
    };
    var l = n.needsResizeLayout;
    n.needsResizeLayout = function () {
      return this._getOption("horizontal")
        ? this.needsVerticalResizeLayout()
        : l.call(this);
    };
    var c = n._getOption;
    return (
      (n._getOption = function (t) {
        return "horizontal" == t
          ? void 0 !== this.options.isHorizontal
            ? this.options.isHorizontal
            : this.options.horizontal
          : c.apply(this.isotopet4s, arguments);
      }),
      i
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) {
          return e(t, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("jquery")))
      : (t.jQuery_T4NTBridget = e(t, t.jQuery_T4NT));
  })(window, function (t, e) {
    "use strict";
    function i(i, s, a) {
      (a = a || e || t.jQuery_T4NT) &&
        (s.prototype.option ||
          (s.prototype.option = function (t) {
            a.isPlainObject(t) &&
              (this.options = a.extend(!0, this.options, t));
          }),
        (a.fn[i] = function (t) {
          var e;
          return "string" == typeof t
            ? (function (t, e, n) {
                var o,
                  s = "$()." + i + '("' + e + '")';
                return (
                  t.each(function (t, l) {
                    var c = a.data(l, i);
                    if (c) {
                      var u = c[e];
                      if (u && "_" != e.charAt(0)) {
                        var h = u.apply(c, n);
                        o = void 0 === o ? h : o;
                      } else r(s + " is not a valid method");
                    } else r(i + " not initialized. Cannot call methods, i.e. " + s);
                  }),
                  void 0 !== o ? o : t
                );
              })(this, t, o.call(arguments, 1))
            : ((e = t),
              this.each(function (t, n) {
                var o = a.data(n, i);
                o
                  ? (o.option(e), o._init())
                  : ((o = new s(n, e)), a.data(n, i, o));
              }),
              this);
        }),
        n(a));
    }
    function n(t) {
      !t || (t && t.bridget) || (t.bridget = i);
    }
    var o = Array.prototype.slice,
      s = t.console,
      r =
        void 0 === s
          ? function () {}
          : function (t) {
              s.error(t);
            };
    return n(e || t.jQuery_T4NT), i;
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("ev-emitter/ev-emitter", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.EvEmitter = e());
  })("undefined" != typeof window ? window : this, function () {
    function t() {}
    var e = t.prototype;
    return (
      (e.on = function (t, e) {
        if (t && e) {
          var i = (this._events = this._events || {}),
            n = (i[t] = i[t] || []);
          return -1 == n.indexOf(e) && n.push(e), this;
        }
      }),
      (e.once = function (t, e) {
        if (t && e) {
          this.on(t, e);
          var i = (this._onceEvents = this._onceEvents || {});
          return ((i[t] = i[t] || {})[e] = !0), this;
        }
      }),
      (e.off = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          var n = i.indexOf(e);
          return -1 != n && i.splice(n, 1), this;
        }
      }),
      (e.emitEvent = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          (i = i.slice(0)), (e = e || []);
          for (
            var n = this._onceEvents && this._onceEvents[t], o = 0;
            o < i.length;
            o++
          ) {
            var s = i[o];
            n && n[s] && (this.off(t, s), delete n[s]), s.apply(this, e);
          }
          return this;
        }
      }),
      (e.allOff = function () {
        delete this._events, delete this._onceEvents;
      }),
      t
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("get-size/get-size", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.getSize = e());
  })(window, function () {
    "use strict";
    function t(t) {
      var e = parseFloat(t);
      return -1 == t.indexOf("%") && !isNaN(e) && e;
    }
    function e(t) {
      var e = getComputedStyle(t);
      return (
        e ||
          n(
            "Style returned " +
              e +
              ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
          ),
        e
      );
    }
    var i,
      n =
        "undefined" == typeof console
          ? function () {}
          : function (t) {
              console.error(t);
            },
      o = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth",
      ],
      s = o.length,
      r = !1;
    return function n(a) {
      if (
        ((function () {
          if (!r) {
            r = !0;
            var o = document.createElement("div");
            (o.style.width = "200px"),
              (o.style.padding = "1px 2px 3px 4px"),
              (o.style.borderStyle = "solid"),
              (o.style.borderWidth = "1px 2px 3px 4px"),
              (o.style.boxSizing = "border-box");
            var s = document.body || document.documentElement;
            s.appendChild(o);
            var a = e(o);
            (i = 200 == Math.round(t(a.width))),
              (n.isBoxSizeOuter = i),
              s.removeChild(o);
          }
        })(),
        "string" == typeof a && (a = document.querySelector(a)),
        a && "object" == typeof a && a.nodeType)
      ) {
        var l = e(a);
        if ("none" == l.display)
          return (function () {
            for (
              var t = {
                  width: 0,
                  height: 0,
                  innerWidth: 0,
                  innerHeight: 0,
                  outerWidth: 0,
                  outerHeight: 0,
                },
                e = 0;
              e < s;
              e++
            )
              t[o[e]] = 0;
            return t;
          })();
        var c = {};
        (c.width = a.offsetWidth), (c.height = a.offsetHeight);
        for (
          var u = (c.isBorderBox = "border-box" == l.boxSizing), h = 0;
          h < s;
          h++
        ) {
          var d = o[h],
            f = l[d],
            p = parseFloat(f);
          c[d] = isNaN(p) ? 0 : p;
        }
        var g = c.paddingLeft + c.paddingRight,
          m = c.paddingTop + c.paddingBottom,
          v = c.marginLeft + c.marginRight,
          y = c.marginTop + c.marginBottom,
          b = c.borderLeftWidth + c.borderRightWidth,
          x = c.borderTopWidth + c.borderBottomWidth,
          S = u && i,
          w = t(l.width);
        !1 !== w && (c.width = w + (S ? 0 : g + b));
        var T = t(l.height);
        return (
          !1 !== T && (c.height = T + (S ? 0 : m + x)),
          (c.innerWidth = c.width - (g + b)),
          (c.innerHeight = c.height - (m + x)),
          (c.outerWidth = c.width + v),
          (c.outerHeight = c.height + y),
          c
        );
      }
    };
  }),
  (function (t, e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define("desandro-matches-selector/matches-selector", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.matchesSelector = e());
  })(window, function () {
    "use strict";
    var t = (function () {
      var t = window.Element.prototype;
      if (t.matches) return "matches";
      if (t.matchesSelector) return "matchesSelector";
      for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
        var n = e[i] + "MatchesSelector";
        if (t[n]) return n;
      }
    })();
    return function (e, i) {
      return e[t](i);
    };
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "fizzy-ui-utils/utils",
          ["desandro-matches-selector/matches-selector"],
          function (i) {
            return e(t, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("desandro-matches-selector")))
      : (t.fizzyUIUtils = e(t, t.matchesSelector));
  })(window, function (t, e) {
    var i = {
        extend: function (t, e) {
          for (var i in e) t[i] = e[i];
          return t;
        },
        modulo: function (t, e) {
          return ((t % e) + e) % e;
        },
      },
      n = Array.prototype.slice;
    (i.makeArray = function (t) {
      return Array.isArray(t)
        ? t
        : null == t
        ? []
        : "object" == typeof t && "number" == typeof t.length
        ? n.call(t)
        : [t];
    }),
      (i.removeFrom = function (t, e) {
        var i = t.indexOf(e);
        -1 != i && t.splice(i, 1);
      }),
      (i.getParent = function (t, i) {
        for (; t.parentNode && t != document.body; )
          if (((t = t.parentNode), e(t, i))) return t;
      }),
      (i.getQueryElement = function (t) {
        return "string" == typeof t ? document.querySelector(t) : t;
      }),
      (i.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (i.filterFindElements = function (t, n) {
        var o = [];
        return (
          (t = i.makeArray(t)).forEach(function (t) {
            if (t instanceof HTMLElement)
              if (n) {
                e(t, n) && o.push(t);
                for (var i = t.querySelectorAll(n), s = 0; s < i.length; s++)
                  o.push(i[s]);
              } else o.push(t);
          }),
          o
        );
      }),
      (i.debounceMethod = function (t, e, i) {
        i = i || 100;
        var n = t.prototype[e],
          o = e + "Timeout";
        t.prototype[e] = function () {
          var t = this[o];
          clearTimeout(t);
          var e = arguments,
            s = this;
          this[o] = setTimeout(function () {
            n.apply(s, e), delete s[o];
          }, i);
        };
      }),
      (i.docReady = function (t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e
          ? setTimeout(t)
          : document.addEventListener("DOMContentLoaded", t);
      }),
      (i.toDashed = function (t) {
        return t
          .replace(/(.)([A-Z])/g, function (t, e, i) {
            return e + "-" + i;
          })
          .toLowerCase();
      });
    var o = t.console;
    return (
      (i.htmlInit = function (e, n) {
        i.docReady(function () {
          var s = i.toDashed(n),
            r = "data-" + s,
            a = document.querySelectorAll("[" + r + "]"),
            l = document.querySelectorAll(".js-" + s),
            c = i.makeArray(a).concat(i.makeArray(l)),
            u = r + "-options",
            h = t.jQuery_T4NT;
          c.forEach(function (t) {
            var i,
              s = t.getAttribute(r) || t.getAttribute(u);
            try {
              i = s && JSON.parse(s);
            } catch (e) {
              return void (
                o &&
                o.error("Error parsing " + r + " on " + t.className + ": " + e)
              );
            }
            var a = new e(t, i);
            h && h.data(t, n, a);
          });
        });
      }),
      i
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("flickityt4s/js/cell", ["get-size/get-size"], function (i) {
          return e(t, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("get-size")))
      : ((t.Flickityt4s = t.Flickityt4s || {}),
        (t.Flickityt4s.Cell = e(t, t.getSize)));
  })(window, function (t, e) {
    function i(t, e) {
      (this.element = t), (this.parent = e), this.create();
    }
    var n = i.prototype;
    return (
      (n.create = function () {
        (this.element.style.position = "absolute"),
          this.element.setAttribute("aria-hidden", "true"),
          (this.x = 0),
          (this.shift = 0),
          (this.element.style[this.parent.originSide] = 0);
      }),
      (n.destroy = function () {
        this.unselect(), (this.element.style.position = "");
        var t = this.parent.originSide;
        (this.element.style[t] = ""),
          (this.element.style.transform = ""),
          this.element.removeAttribute("aria-hidden");
      }),
      (n.getSize = function () {
        this.size = e(this.element);
      }),
      (n.setPosition = function (t) {
        (this.x = t), this.updateTarget(), this.renderPosition(t);
      }),
      (n.updateTarget = n.setDefaultTarget =
        function () {
          var t =
            "left" == this.parent.originSide ? "marginLeft" : "marginRight";
          this.target =
            this.x + this.size[t] + this.size.width * this.parent.cellAlign;
        }),
      (n.renderPosition = function (t) {
        var e = "left" === this.parent.originSide ? 1 : -1,
          i = this.parent.options.percentPosition
            ? t * e * (this.parent.size.innerWidth / this.size.width)
            : t * e;
        this.element.style.transform =
          "translateX(" + this.parent.getPositionValue(i) + ")";
      }),
      (n.select = function () {
        this.element.classList.add("is-selected"),
          this.element.removeAttribute("aria-hidden");
      }),
      (n.unselect = function () {
        this.element.classList.remove("is-selected"),
          this.element.setAttribute("aria-hidden", "true");
      }),
      (n.wrapShift = function (t) {
        (this.shift = t),
          this.renderPosition(this.x + this.parent.slideableWidth * t);
      }),
      (n.remove = function () {
        this.element.parentNode.removeChild(this.element);
      }),
      i
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("flickityt4s/js/slide", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : ((t.Flickityt4s = t.Flickityt4s || {}), (t.Flickityt4s.Slide = e()));
  })(window, function () {
    "use strict";
    function t(t) {
      (this.parent = t),
        (this.isOriginLeft = "left" == t.originSide),
        (this.cells = []),
        (this.outerWidth = 0),
        (this.height = 0);
    }
    var e = t.prototype;
    return (
      (e.addCell = function (t) {
        if (
          (this.cells.push(t),
          (this.outerWidth += t.size.outerWidth),
          (this.height = Math.max(t.size.outerHeight, this.height)),
          1 == this.cells.length)
        ) {
          this.x = t.x;
          var e = this.isOriginLeft ? "marginLeft" : "marginRight";
          this.firstMargin = t.size[e];
        }
      }),
      (e.updateTarget = function () {
        var t = this.isOriginLeft ? "marginRight" : "marginLeft",
          e = this.getLastCell(),
          i = e ? e.size[t] : 0,
          n = this.outerWidth - (this.firstMargin + i);
        this.target = this.x + this.firstMargin + n * this.parent.cellAlign;
      }),
      (e.getLastCell = function () {
        return this.cells[this.cells.length - 1];
      }),
      (e.select = function () {
        this.cells.forEach(function (t) {
          t.select();
        });
      }),
      (e.unselect = function () {
        this.cells.forEach(function (t) {
          t.unselect();
        });
      }),
      (e.getCellElements = function () {
        return this.cells.map(function (t) {
          return t.element;
        });
      }),
      t
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickityt4s/js/animate",
          ["fizzy-ui-utils/utils"],
          function (i) {
            return e(t, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("fizzy-ui-utils")))
      : ((t.Flickityt4s = t.Flickityt4s || {}),
        (t.Flickityt4s.animatePrototype = e(t, t.fizzyUIUtils)));
  })(window, function (t, e) {
    return {
      startAnimation: function () {
        this.isAnimating ||
          ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
      },
      animate: function () {
        this.applyDragForce(), this.applySelectedAttraction();
        var t = this.x;
        if (
          (this.integratePhysics(),
          this.positionSlider(),
          this.settle(t),
          this.isAnimating)
        ) {
          var e = this;
          requestAnimationFrame(function () {
            e.animate();
          });
        }
      },
      positionSlider: function () {
        var t = this.x;
        this.options.wrapAround &&
          this.cells.length > 1 &&
          ((t = e.modulo(t, this.slideableWidth)),
          (t -= this.slideableWidth),
          this.shiftWrapCells(t)),
          this.setTranslateX(t, this.isAnimating),
          this.dispatchScrollEvent();
      },
      setTranslateX: function (t, e) {
        (t += this.cursorPosition), (t = RtlT4s ? -t : t);
        var i = this.getPositionValue(t);
        this.slider.style.transform = e
          ? "translate3d(" + i + ",0,0)"
          : "translateX(" + i + ")";
      },
      dispatchScrollEvent: function () {
        var t = this.slides[0];
        if (t) {
          var e = -this.x - t.target,
            i = e / this.slidesWidth;
          this.dispatchEvent("scroll", null, [i, e]);
        }
      },
      positionSliderAtSelected: function () {
        this.cells.length &&
          ((this.x = -this.selectedSlide.target),
          (this.velocity = 0),
          this.positionSlider());
      },
      getPositionValue: function (t) {
        return this.options.percentPosition
          ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + "%"
          : Math.round(t) + "px";
      },
      settle: function (t) {
        !this.isPointerDown &&
          Math.round(100 * this.x) == Math.round(100 * t) &&
          this.restingFrames++,
          this.restingFrames > 2 &&
            ((this.isAnimating = !1),
            delete this.isFreeScrolling,
            this.positionSlider(),
            this.dispatchEvent("settle", null, [this.selectedIndex]));
      },
      shiftWrapCells: function (t) {
        var e = this.cursorPosition + t;
        this._shiftCells(this.beforeShiftCells, e, -1);
        var i =
          this.size.innerWidth -
          (t + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, i, 1);
      },
      _shiftCells: function (t, e, i) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n],
            s = e > 0 ? i : 0;
          o.wrapShift(s), (e -= o.size.outerWidth);
        }
        this._checkVisibility();
      },
      _unshiftCells: function (t) {
        if (t && t.length) for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
      },
      integratePhysics: function () {
        (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
      },
      applyForce: function (t) {
        this.velocity += t;
      },
      getFrictionFactor: function () {
        return (
          1 -
          this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
        );
      },
      getRestingPosition: function () {
        return this.x + this.velocity / (1 - this.getFrictionFactor());
      },
      applyDragForce: function () {
        if (this.isDraggable && this.isPointerDown) {
          var t = this.dragX - this.x - this.velocity;
          this.applyForce(t);
        }
      },
      applySelectedAttraction: function () {
        if (
          (!this.isDraggable || !this.isPointerDown) &&
          !this.isFreeScrolling &&
          this.slides.length
        ) {
          var t =
            (-1 * this.selectedSlide.target - this.x) *
            this.options.selectedAttraction;
          this.applyForce(t);
        }
      },
    };
  }),
  (function (t, e) {
    if ("function" == typeof define && define.amd)
      define("flickityt4s/js/flickityt4s", [
        "ev-emitter/ev-emitter",
        "get-size/get-size",
        "fizzy-ui-utils/utils",
        "./cell",
        "./slide",
        "./animate",
      ], function (i, n, o, s, r, a) {
        return e(t, i, n, o, s, r, a);
      });
    else if ("object" == typeof module && module.exports)
      module.exports = e(
        t,
        require("ev-emitter"),
        require("get-size"),
        require("fizzy-ui-utils"),
        require("./cell"),
        require("./slide"),
        require("./animate")
      );
    else {
      var i = t.Flickityt4s;
      t.Flickityt4s = e(
        t,
        t.EvEmitter,
        t.getSize,
        t.fizzyUIUtils,
        i.Cell,
        i.Slide,
        i.animatePrototype
      );
    }
  })(window, function (t, e, i, n, o, s, r) {
    function a(t, e) {
      for (t = n.makeArray(t); t.length; ) e.appendChild(t.shift());
    }
    function l(t, e) {
      var i = n.getQueryElement(t);
      if (i) {
        if (((this.element = i), this.element.flickityt4sGUID)) {
          var o = f[this.element.flickityt4sGUID];
          return o && o.option(e), o;
        }
        switch (
          (c && (this.$element = c(this.element)),
          (this.options = n.extend({}, this.constructor.defaults)),
          (e.originwrapAround = e.wrapAround),
          (e.rightToLeft =
            "rtl" == document.documentElement.getAttribute("dir")),
          e.arrowIcon)
        ) {
          case "1":
            e.arrowShape = "M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z";
            break;
          case "2":
            e.arrowShape = "M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z";
            break;
          case "3":
            e.arrowShape =
              "M 0,50 L 60,00 L 50,30 L 80,30 L 80,70 L 50,70 L 60,100 Z";
        }
        this.option(e), this._create();
      } else h && h.error("Bad element for Flickityt4s: " + (i || t));
    }
    var c = t.jQuery_T4NT,
      u = t.getComputedStyle,
      h = t.console,
      d = 0,
      f = {};
    (l.defaults = {
      accessibility: !0,
      cellAlign: "center",
      freeScrollFriction: 0.075,
      friction: 0.28,
      namespaceJQueryEvents: !0,
      percentPosition: !0,
      resize: !0,
      selectedAttraction: 0.025,
      setGallerySize: !0,
      setPrevNextButtons: !1,
      checkVisibility: !1,
      sync: !1,
    }),
      (l.createMethods = []);
    var p = l.prototype;
    n.extend(p, e.prototype),
      (p._create = function () {
        var e = (this.guid = ++d);
        for (var i in ((this.element.flickityt4sGUID = e),
        (f[e] = this),
        (this.selectedIndex = 0),
        (this.restingFrames = 0),
        (this.x = 0),
        (this.velocity = 0),
        (this.originSide = RtlT4s ? "right" : "left"),
        (this.viewport = document.createElement("div")),
        (this.viewport.className = "flickityt4s-viewport"),
        this._createSlider(),
        (this.options.resize || this.options.watchCSS) &&
          t.addEventListener("resize", this),
        this.options.on)) {
          var n = this.options.on[i];
          this.on(i, n);
        }
        l.createMethods.forEach(function (t) {
          this[t]();
        }, this),
          this.options.watchCSS ? this.watchCSS() : this.activate();
      }),
      (p.option = function (t) {
        n.extend(this.options, t);
      }),
      (p.activate = function () {
        this.isActive ||
          ((this.isActive = !0),
          this.element.classList.add("flickityt4s-enabled"),
          RtlT4s && this.element.classList.add("flickityt4s-rtl"),
          this.getSize(),
          a(this._filterFindCellElements(this.element.children), this.slider),
          this.viewport.appendChild(this.slider),
          this.element.appendChild(this.viewport),
          this.reloadCells(),
          this.options.accessibility &&
            ((this.element.tabIndex = 0),
            this.element.addEventListener("keydown", this)),
          this.emitEvent("activate"),
          this.selectInitialIndex(),
          (this.isInitActivated = !0),
          this.dispatchEvent("ready"));
      }),
      (p._createSlider = function () {
        var t = document.createElement("div");
        (t.className = "flickityt4s-slider"),
          (t.style[this.originSide] = 0),
          (this.slider = t);
      }),
      (p._filterFindCellElements = function (t) {
        return n.filterFindElements(t, this.options.cellSelector);
      }),
      (p.reloadCells = function () {
        (this.cells = this._makeCells(this.slider.children)),
          this.positionCells(),
          this._getWrapShiftCells(),
          this.setGallerySize(),
          this.setPrevNextButtons();
      }),
      (p._makeCells = function (t) {
        return this._filterFindCellElements(t).map(function (t) {
          return new o(t, this);
        }, this);
      }),
      (p.getLastCell = function () {
        return this.cells[this.cells.length - 1];
      }),
      (p.getLastSlide = function () {
        return this.slides[this.slides.length - 1];
      }),
      (p.positionCells = function () {
        this._sizeCells(this.cells), this._positionCells(0);
      }),
      (p._positionCells = function (t) {
        (t = t || 0), (this.maxCellHeight = (t && this.maxCellHeight) || 0);
        var e = 0;
        if (t > 0) {
          var i = this.cells[t - 1];
          e = i.x + i.size.outerWidth;
        }
        for (var n = this.cells.length, o = t; o < n; o++) {
          var s = this.cells[o];
          s.setPosition(e),
            (e += s.size.outerWidth),
            (this.maxCellHeight = Math.max(
              s.size.outerHeight,
              this.maxCellHeight
            ));
        }
        (this.slideableWidth = e),
          this.updateSlides(),
          this._containSlides(),
          (this.slidesWidth = n
            ? this.getLastSlide().target - this.slides[0].target
            : 0),
          (this.maxVisibilityHeight = 0);
      }),
      (p._sizeCells = function (t) {
        t.forEach(function (t) {
          t.getSize();
        });
      }),
      (p.updateSlides = function () {
        if (((this.slides = []), this.cells.length)) {
          var t = new s(this);
          this.slides.push(t);
          var e = "left" == this.originSide ? "marginRight" : "marginLeft",
            i = this._getCanCellFit();
          this.cells.forEach(function (n, o) {
            if (t.cells.length) {
              var r =
                t.outerWidth - t.firstMargin + (n.size.outerWidth - n.size[e]);
              i.call(this, o, r)
                ? t.addCell(n)
                : (t.updateTarget(),
                  (t = new s(this)),
                  this.slides.push(t),
                  t.addCell(n));
            } else t.addCell(n);
          }, this),
            t.updateTarget(),
            this.updateSelectedSlide();
        }
      }),
      (p._getCanCellFit = function () {
        var t = this.options.groupCells;
        if (!t)
          return function () {
            return !1;
          };
        if ("number" == typeof t) {
          var e = parseInt(t, 10);
          return function (t) {
            return t % e != 0;
          };
        }
        var i = "string" == typeof t && t.match(/^(\d+)%$/),
          n = i ? parseInt(i[1], 10) / 100 : 1;
        return function (t, e) {
          return e <= (this.size.innerWidth + 1) * n;
        };
      }),
      (p._init = p.reposition =
        function () {
          this.positionCells(), this.positionSliderAtSelected();
        }),
      (p.getSize = function () {
        (this.size = i(this.element)),
          this.setCellAlign(),
          (this.cursorPosition = this.size.innerWidth * this.cellAlign);
      });
    var g = {
      center: { left: 0.5, right: 0.5 },
      left: { left: 0, right: 1 },
      right: { right: 0, left: 1 },
    };
    return (
      (p.setCellAlign = function () {
        var t = g[this.options.cellAlign];
        this.cellAlign = t ? t[this.originSide] : this.options.cellAlign;
      }),
      (p.setGallerySize = function () {
        if (this.options.setGallerySize) {
          var t =
            this.options.adaptiveHeight && this.selectedSlide
              ? this.selectedSlide.height
              : this.maxCellHeight;
          (t =
            this.maxVisibilityHeight && this.maxVisibilityHeight > t
              ? this.maxVisibilityHeight
              : t),
            (this.viewport.style.height = t + "px");
        }
      }),
      (p.setPrevNextButtons = function () {
        if (this.options.setPrevNextButtons) {
          var t = this.viewport.querySelector(".is-selected [data-cacl-slide]");
          if (null !== t) {
            var e = t.offsetHeight / 2;
            this.element.style.setProperty("--prev-next-top", e + "px");
          }
        }
      }),
      (p._checkVisibility = function () {
        if (this.options.checkVisibility && this.options.adaptiveHeight)
          for (
            var t = this.viewport.getBoundingClientRect().x,
              e = this.viewport.offsetWidth,
              i = this.cells.length,
              n = 0;
            n < i;
            n++
          ) {
            var o = this.cells[n],
              s = o.element.getBoundingClientRect().x - t;
            (s + o.size.innerWidth > t && s + o.size.innerWidth < e) ||
            (s > t && s < e)
              ? ((this.maxVisibilityHeight = Math.max(
                  o.size.outerHeight,
                  this.maxVisibilityHeight
                )),
                o.element.classList.add("is-t4s-visible"),
                o.element.removeAttribute("aria-hidden"))
              : (o.element.classList.remove("is-t4s-visible"),
                o.element.setAttribute("aria-hidden", !0));
          }
      }),
      (p._getWrapShiftCells = function () {
        if (this.options.originwrapAround)
          if (this.slides.length < 2) this.options.wrapAround = !1;
          else {
            (this.options.wrapAround = !0),
              this._unshiftCells(this.beforeShiftCells),
              this._unshiftCells(this.afterShiftCells);
            var t = this.cursorPosition,
              e = this.cells.length - 1;
            (this.beforeShiftCells = this._getGapCells(t, e, -1)),
              (t = this.size.innerWidth - this.cursorPosition),
              (this.afterShiftCells = this._getGapCells(t, 0, 1));
          }
      }),
      (p._getGapCells = function (t, e, i) {
        for (var n = []; t > 0; ) {
          var o = this.cells[e];
          if (!o) break;
          n.push(o), (e += i), (t -= o.size.outerWidth);
        }
        return n;
      }),
      (p._containSlides = function () {
        if (
          this.options.contain &&
          !this.options.wrapAround &&
          this.cells.length
        ) {
          var t = RtlT4s ? "marginRight" : "marginLeft",
            e = RtlT4s ? "marginLeft" : "marginRight",
            i = this.slideableWidth - this.getLastCell().size[e],
            n = i < this.size.innerWidth,
            o = this.cursorPosition + this.cells[0].size[t],
            s = i - this.size.innerWidth * (1 - this.cellAlign);
          this.slides.forEach(function (t) {
            n
              ? (t.target = i * this.cellAlign)
              : ((t.target = Math.max(t.target, o)),
                (t.target = Math.min(t.target, s)));
          }, this);
        }
      }),
      (p.dispatchEvent = function (t, e, i) {
        var n = e ? [e].concat(i) : i;
        if ((this.emitEvent(t, n), c && this.$element)) {
          var o = (t += this.options.namespaceJQueryEvents
            ? ".flickityt4s"
            : "");
          if (e) {
            var s = new c.Event(e);
            (s.type = t), (o = s);
          }
          this.$element.trigger(o, i);
        }
      }),
      (p.select = function (t, e, i) {
        if (
          this.isActive &&
          ((t = parseInt(t, 10)),
          this._wrapSelect(t),
          (this.options.wrapAround || e) &&
            (t = n.modulo(t, this.slides.length)),
          this.slides[t])
        ) {
          var o = this.selectedIndex;
          (this.selectedIndex = t),
            this.updateSelectedSlide(),
            i ? this.positionSliderAtSelected() : this.startAnimation(),
            this.options.adaptiveHeight && this.setGallerySize(),
            this.setPrevNextButtons(),
            this.dispatchEvent("select", null, [t]),
            t != o && this.dispatchEvent("change", null, [t]),
            this.dispatchEvent("cellSelect");
        }
      }),
      (p._wrapSelect = function (t) {
        var e = this.slides.length;
        if (!(this.options.wrapAround && e > 1)) return t;
        var i = n.modulo(t, e),
          o = Math.abs(i - this.selectedIndex),
          s = Math.abs(i + e - this.selectedIndex),
          r = Math.abs(i - e - this.selectedIndex);
        !this.isDragSelect && s < o
          ? (t += e)
          : !this.isDragSelect && r < o && (t -= e),
          t < 0
            ? (this.x -= this.slideableWidth)
            : t >= e && (this.x += this.slideableWidth);
      }),
      (p.previous = function (t, e) {
        this.select(this.selectedIndex - 1, t, e);
      }),
      (p.next = function (t, e) {
        this.select(this.selectedIndex + 1, t, e);
      }),
      (p.updateSelectedSlide = function () {
        var t = this.slides[this.selectedIndex];
        t &&
          (this.unselectSelectedSlide(),
          (this.selectedSlide = t),
          t.select(),
          (this.selectedCells = t.cells),
          (this.selectedElements = t.getCellElements()),
          (this.selectedCell = t.cells[0]),
          (this.selectedElement = this.selectedElements[0]));
      }),
      (p.unselectSelectedSlide = function () {
        this.selectedSlide && this.selectedSlide.unselect();
      }),
      (p.selectInitialIndex = function () {
        var t = this.options.initialIndex;
        if (this.isInitActivated) this.select(this.selectedIndex, !1, !0);
        else {
          if (t && "string" == typeof t && this.queryCell(t))
            return void this.selectCell(t, !1, !0);
          var e = 0;
          t && this.slides[t] && (e = t), this.select(e, !1, !0);
        }
      }),
      (p.selectCell = function (t, e, i) {
        var n = this.queryCell(t);
        if (n) {
          var o = this.getCellSlideIndex(n);
          this.select(o, e, i);
        }
      }),
      (p.getCellSlideIndex = function (t) {
        for (var e = 0; e < this.slides.length; e++)
          if (-1 != this.slides[e].cells.indexOf(t)) return e;
      }),
      (p.getCell = function (t) {
        for (var e = 0; e < this.cells.length; e++) {
          var i = this.cells[e];
          if (i.element == t) return i;
        }
      }),
      (p.getCells = function (t) {
        var e = [];
        return (
          (t = n.makeArray(t)).forEach(function (t) {
            var i = this.getCell(t);
            i && e.push(i);
          }, this),
          e
        );
      }),
      (p.getCellElements = function () {
        return this.cells.map(function (t) {
          return t.element;
        });
      }),
      (p.getParentCell = function (t) {
        return (
          this.getCell(t) ||
          ((t = n.getParent(t, ".flickityt4s-slider > *")), this.getCell(t))
        );
      }),
      (p.getAdjacentCellElements = function (t, e) {
        if (!t) return this.selectedSlide.getCellElements();
        e = void 0 === e ? this.selectedIndex : e;
        var i = this.slides.length;
        if (1 + 2 * t >= i) return this.getCellElements();
        for (var o = [], s = e - t; s <= e + t; s++) {
          var r = this.options.wrapAround ? n.modulo(s, i) : s,
            a = this.slides[r];
          a && (o = o.concat(a.getCellElements()));
        }
        return o;
      }),
      (p.queryCell = function (t) {
        if ("number" == typeof t) return this.cells[t];
        if ("string" == typeof t) {
          if (t.match(/^[#.]?[\d/]/)) return;
          t = this.element.querySelector(t);
        }
        return this.getCell(t);
      }),
      (p.uiChange = function () {
        this.emitEvent("uiChange");
      }),
      (p.childUIPointerDown = function (t) {
        "touchstart" != t.type && t.preventDefault(), this.focus();
      }),
      (p.onresize = function () {
        this.watchCSS(), this.resize();
      }),
      n.debounceMethod(l, "onresize", 150),
      (p.resize = function () {
        if (this.isActive && !this.isAnimating && !this.isDragging) {
          this.getSize(),
            this.options.wrapAround &&
              (this.x = n.modulo(this.x, this.slideableWidth)),
            this.positionCells(),
            this._getWrapShiftCells(),
            this.setGallerySize(),
            this.setPrevNextButtons(),
            this.emitEvent("resize");
          var t = this.selectedElements && this.selectedElements[0];
          this.selectCell(t, !1, !0);
        }
      }),
      (p.watchCSS = function () {
        this.options.watchCSS &&
          (-1 != u(this.element, ":after").content.indexOf("flickityt4s")
            ? this.activate()
            : this.deactivate());
      }),
      (p.onkeydown = function (t) {
        var e =
          document.activeElement && document.activeElement != this.element;
        if (this.options.accessibility && !e) {
          var i = l.keyboardHandlers[t.keyCode];
          i && i.call(this);
        }
      }),
      (l.keyboardHandlers = {
        37: function () {
          var t = RtlT4s ? "next" : "previous";
          this.uiChange(), this[t]();
        },
        39: function () {
          var t = RtlT4s ? "previous" : "next";
          this.uiChange(), this[t]();
        },
      }),
      (p.focus = function () {
        var e = t.pageYOffset;
        this.element.focus({ preventScroll: !0 }),
          t.pageYOffset != e && t.scrollTo(t.pageXOffset, e);
      }),
      (p.deactivate = function () {
        this.isActive &&
          (this.element.classList.remove("flickityt4s-enabled"),
          this.element.classList.remove("flickityt4s-rtl"),
          this.unselectSelectedSlide(),
          this.cells.forEach(function (t) {
            t.destroy();
          }),
          this.element.removeChild(this.viewport),
          a(this.slider.children, this.element),
          this.options.accessibility &&
            (this.element.removeAttribute("tabIndex"),
            this.element.removeEventListener("keydown", this)),
          (this.isActive = !1),
          this.emitEvent("deactivate"));
      }),
      (p.destroy = function () {
        this.deactivate(),
          t.removeEventListener("resize", this),
          this.allOff(),
          this.emitEvent("destroy"),
          c && this.$element && c.removeData(this.element, "flickityt4s"),
          delete this.element.flickityt4sGUID,
          delete f[this.guid];
      }),
      n.extend(p, r),
      (l.data = function (t) {
        var e = (t = n.getQueryElement(t)) && t.flickityt4sGUID;
        return e && f[e];
      }),
      n.htmlInit(l, "flickityt4s"),
      c && c.bridget && c.bridget("flickityt4s", l),
      (l.setJQuery = function (t) {
        c = t;
      }),
      (l.Cell = o),
      (l.Slide = s),
      l
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "unipointer/unipointer",
          ["ev-emitter/ev-emitter"],
          function (i) {
            return e(t, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("ev-emitter")))
      : (t.Unipointer = e(t, t.EvEmitter));
  })(window, function (t, e) {
    function i() {}
    var n = (i.prototype = Object.create(e.prototype));
    (n.bindStartEvent = function (t) {
      this._bindStartEvent(t, !0);
    }),
      (n.unbindStartEvent = function (t) {
        this._bindStartEvent(t, !1);
      }),
      (n._bindStartEvent = function (e, i) {
        var n = (i = void 0 === i || i)
            ? "addEventListener"
            : "removeEventListener",
          o = "mousedown";
        "ontouchstart" in t
          ? (o = "touchstart")
          : t.PointerEvent && (o = "pointerdown"),
          e[n](o, this);
      }),
      (n.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (n.getTouch = function (t) {
        for (var e = 0; e < t.length; e++) {
          var i = t[e];
          if (i.identifier == this.pointerIdentifier) return i;
        }
      }),
      (n.onmousedown = function (t) {
        var e = t.button;
        (e && 0 !== e && 1 !== e) || this._pointerDown(t, t);
      }),
      (n.ontouchstart = function (t) {
        this._pointerDown(t, t.changedTouches[0]);
      }),
      (n.onpointerdown = function (t) {
        this._pointerDown(t, t);
      }),
      (n._pointerDown = function (t, e) {
        t.button ||
          this.isPointerDown ||
          ((this.isPointerDown = !0),
          (this.pointerIdentifier =
            void 0 !== e.pointerId ? e.pointerId : e.identifier),
          this.pointerDown(t, e));
      }),
      (n.pointerDown = function (t, e) {
        this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e]);
      });
    var o = {
      mousedown: ["mousemove", "mouseup"],
      touchstart: ["touchmove", "touchend", "touchcancel"],
      pointerdown: ["pointermove", "pointerup", "pointercancel"],
    };
    return (
      (n._bindPostStartEvents = function (e) {
        if (e) {
          var i = o[e.type];
          i.forEach(function (e) {
            t.addEventListener(e, this);
          }, this),
            (this._boundPointerEvents = i);
        }
      }),
      (n._unbindPostStartEvents = function () {
        this._boundPointerEvents &&
          (this._boundPointerEvents.forEach(function (e) {
            t.removeEventListener(e, this);
          }, this),
          delete this._boundPointerEvents);
      }),
      (n.onmousemove = function (t) {
        this._pointerMove(t, t);
      }),
      (n.onpointermove = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerMove(t, t);
      }),
      (n.ontouchmove = function (t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerMove(t, e);
      }),
      (n._pointerMove = function (t, e) {
        this.pointerMove(t, e);
      }),
      (n.pointerMove = function (t, e) {
        this.emitEvent("pointerMove", [t, e]);
      }),
      (n.onmouseup = function (t) {
        this._pointerUp(t, t);
      }),
      (n.onpointerup = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerUp(t, t);
      }),
      (n.ontouchend = function (t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerUp(t, e);
      }),
      (n._pointerUp = function (t, e) {
        this._pointerDone(), this.pointerUp(t, e);
      }),
      (n.pointerUp = function (t, e) {
        this.emitEvent("pointerUp", [t, e]);
      }),
      (n._pointerDone = function () {
        this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone();
      }),
      (n._pointerReset = function () {
        (this.isPointerDown = !1), delete this.pointerIdentifier;
      }),
      (n.pointerDone = function () {}),
      (n.onpointercancel = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t);
      }),
      (n.ontouchcancel = function (t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerCancel(t, e);
      }),
      (n._pointerCancel = function (t, e) {
        this._pointerDone(), this.pointerCancel(t, e);
      }),
      (n.pointerCancel = function (t, e) {
        this.emitEvent("pointerCancel", [t, e]);
      }),
      (i.getPointerPoint = function (t) {
        return { x: t.pageX, y: t.pageY };
      }),
      i
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "unidragger/unidragger",
          ["unipointer/unipointer"],
          function (i) {
            return e(t, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("unipointer")))
      : (t.Unidragger = e(t, t.Unipointer));
  })(window, function (t, e) {
    function i() {}
    var n = (i.prototype = Object.create(e.prototype));
    (n.bindHandles = function () {
      this._bindHandles(!0);
    }),
      (n.unbindHandles = function () {
        this._bindHandles(!1);
      }),
      (n._bindHandles = function (e) {
        for (
          var i = (e = void 0 === e || e)
              ? "addEventListener"
              : "removeEventListener",
            n = e ? this._touchActionValue : "",
            o = 0;
          o < this.handles.length;
          o++
        ) {
          var s = this.handles[o];
          this._bindStartEvent(s, e),
            s[i]("click", this),
            t.PointerEvent && (s.style.touchAction = n);
        }
      }),
      (n._touchActionValue = "none"),
      (n.pointerDown = function (t, e) {
        this.okayPointerDown(t) &&
          ((this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY }),
          t.preventDefault(),
          this.pointerDownBlur(),
          this._bindPostStartEvents(t),
          this.emitEvent("pointerDown", [t, e]));
      });
    var o = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
      s = {
        radio: !0,
        checkbox: !0,
        button: !0,
        submit: !0,
        image: !0,
        file: !0,
      };
    return (
      (n.okayPointerDown = function (t) {
        var e = o[t.target.nodeName],
          i = s[t.target.type],
          n = !e || i;
        return n || this._pointerReset(), n;
      }),
      (n.pointerDownBlur = function () {
        var t = document.activeElement;
        t && t.blur && t != document.body && t.blur();
      }),
      (n.pointerMove = function (t, e) {
        var i = this._dragPointerMove(t, e);
        this.emitEvent("pointerMove", [t, e, i]), this._dragMove(t, e, i);
      }),
      (n._dragPointerMove = function (t, e) {
        var i = {
          x: e.pageX - this.pointerDownPointer.pageX,
          y: e.pageY - this.pointerDownPointer.pageY,
        };
        return (
          !this.isDragging && this.hasDragStarted(i) && this._dragStart(t, e), i
        );
      }),
      (n.hasDragStarted = function (t) {
        return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
      }),
      (n.pointerUp = function (t, e) {
        this.emitEvent("pointerUp", [t, e]), this._dragPointerUp(t, e);
      }),
      (n._dragPointerUp = function (t, e) {
        this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e);
      }),
      (n._dragStart = function (t, e) {
        (this.isDragging = !0),
          (this.isPreventingClicks = !0),
          this.dragStart(t, e);
      }),
      (n.dragStart = function (t, e) {
        this.emitEvent("dragStart", [t, e]);
      }),
      (n._dragMove = function (t, e, i) {
        this.isDragging && this.dragMove(t, e, i);
      }),
      (n.dragMove = function (t, e, i) {
        t.preventDefault(), this.emitEvent("dragMove", [t, e, i]);
      }),
      (n._dragEnd = function (t, e) {
        (this.isDragging = !1),
          setTimeout(
            function () {
              delete this.isPreventingClicks;
            }.bind(this)
          ),
          this.dragEnd(t, e);
      }),
      (n.dragEnd = function (t, e) {
        this.emitEvent("dragEnd", [t, e]);
      }),
      (n.onclick = function (t) {
        this.isPreventingClicks && t.preventDefault();
      }),
      (n._staticClick = function (t, e) {
        (this.isIgnoringMouseUp && "mouseup" == t.type) ||
          (this.staticClick(t, e),
          "mouseup" != t.type &&
            ((this.isIgnoringMouseUp = !0),
            setTimeout(
              function () {
                delete this.isIgnoringMouseUp;
              }.bind(this),
              400
            )));
      }),
      (n.staticClick = function (t, e) {
        this.emitEvent("staticClick", [t, e]);
      }),
      (i.getPointerPoint = e.getPointerPoint),
      i
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickityt4s/js/drag",
          ["./flickityt4s", "unidragger/unidragger", "fizzy-ui-utils/utils"],
          function (i, n, o) {
            return e(t, i, n, o);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(
          t,
          require("./flickityt4s"),
          require("unidragger"),
          require("fizzy-ui-utils")
        ))
      : (t.Flickityt4s = e(t, t.Flickityt4s, t.Unidragger, t.fizzyUIUtils));
  })(window, function (t, e, i, n) {
    function o() {
      return { x: t.pageXOffset, y: t.pageYOffset };
    }
    n.extend(e.defaults, { draggable: ">1", dragThreshold: 3 }),
      e.createMethods.push("_createDrag");
    var s = e.prototype;
    n.extend(s, i.prototype),
      (s._touchActionValue = "pan-y"),
      (s._createDrag = function () {
        this.on("activate", this.onActivateDrag),
          this.on("uiChange", this._uiChangeDrag),
          this.on("deactivate", this.onDeactivateDrag),
          this.on("cellChange", this.updateDraggable);
      }),
      (s.onActivateDrag = function () {
        (this.handles = [this.viewport]),
          this.bindHandles(),
          this.updateDraggable();
      }),
      (s.onDeactivateDrag = function () {
        this.unbindHandles(), this.element.classList.remove("is-draggable");
      }),
      (s.updateDraggable = function () {
        ">1" == this.options.draggable
          ? (this.isDraggable = this.slides.length > 1)
          : "smart" == this.options.draggable
          ? (this.viewport,
            (this.isDraggable =
              this.viewport.scrollWidth > this.viewport.offsetWidth))
          : (this.isDraggable = this.options.draggable),
          this.isDraggable
            ? this.element.classList.add("is-draggable")
            : this.element.classList.remove("is-draggable");
      }),
      (s.bindDrag = function () {
        (this.options.draggable = !0), this.updateDraggable();
      }),
      (s.unbindDrag = function () {
        (this.options.draggable = !1), this.updateDraggable();
      }),
      (s._uiChangeDrag = function () {
        delete this.isFreeScrolling;
      }),
      (s.pointerDown = function (e, i) {
        this.isDraggable
          ? this.okayPointerDown(e) &&
            (this._pointerDownPreventDefault(e),
            this.pointerDownFocus(e),
            document.activeElement != this.element && this.pointerDownBlur(),
            (this.dragX = this.x),
            this.viewport.classList.add("is-pointer-down"),
            (this.pointerDownScroll = o()),
            t.addEventListener("scroll", this),
            this._pointerDownDefault(e, i))
          : this._pointerDownDefault(e, i);
      }),
      (s._pointerDownDefault = function (t, e) {
        (this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY }),
          this._bindPostStartEvents(t),
          this.dispatchEvent("pointerDown", t, [e]);
      });
    var r = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
    return (
      (s.pointerDownFocus = function (t) {
        r[t.target.nodeName] || this.focus();
      }),
      (s._pointerDownPreventDefault = function (t) {
        var e = "touchstart" == t.type,
          i = "touch" == t.pointerType,
          n = r[t.target.nodeName];
        e || i || n || t.preventDefault();
      }),
      (s.hasDragStarted = function (t) {
        return Math.abs(t.x) > this.options.dragThreshold;
      }),
      (s.pointerUp = function (t, e) {
        delete this.isTouchScrolling,
          this.viewport.classList.remove("is-pointer-down"),
          this.dispatchEvent("pointerUp", t, [e]),
          this._dragPointerUp(t, e);
      }),
      (s.pointerDone = function () {
        t.removeEventListener("scroll", this), delete this.pointerDownScroll;
      }),
      (s.dragStart = function (e, i) {
        this.isDraggable &&
          ((this.dragStartPosition = this.x),
          this.startAnimation(),
          t.removeEventListener("scroll", this),
          this.dispatchEvent("dragStart", e, [i]));
      }),
      (s.pointerMove = function (t, e) {
        var i = this._dragPointerMove(t, e);
        this.dispatchEvent("pointerMove", t, [e, i]), this._dragMove(t, e, i);
      }),
      (s.dragMove = function (t, e, i) {
        if (this.isDraggable) {
          t.preventDefault(), (this.previousDragX = this.dragX);
          var n = RtlT4s ? -1 : 1;
          this.options.wrapAround && (i.x %= this.slideableWidth);
          var o = this.dragStartPosition + i.x * n;
          if (!this.options.wrapAround && this.slides.length) {
            var s = Math.max(-this.slides[0].target, this.dragStartPosition);
            o = o > s ? 0.5 * (o + s) : o;
            var r = Math.min(
              -this.getLastSlide().target,
              this.dragStartPosition
            );
            o = o < r ? 0.5 * (o + r) : o;
          }
          (this.dragX = o),
            (this.dragMoveTime = new Date()),
            this.dispatchEvent("dragMove", t, [e, i]);
        }
      }),
      (s.dragEnd = function (t, e) {
        if (this.isDraggable) {
          this.options.freeScroll && (this.isFreeScrolling = !0);
          var i = this.dragEndRestingSelect();
          if (this.options.freeScroll && !this.options.wrapAround) {
            var n = this.getRestingPosition();
            this.isFreeScrolling =
              -n > this.slides[0].target && -n < this.getLastSlide().target;
          } else
            this.options.freeScroll ||
              i != this.selectedIndex ||
              (i += this.dragEndBoostSelect());
          delete this.previousDragX,
            (this.isDragSelect = this.options.wrapAround),
            this.select(i),
            delete this.isDragSelect,
            this.dispatchEvent("dragEnd", t, [e]);
        }
      }),
      (s.dragEndRestingSelect = function () {
        var t = this.getRestingPosition(),
          e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
          i = this._getClosestResting(t, e, 1),
          n = this._getClosestResting(t, e, -1);
        return i.distance < n.distance ? i.index : n.index;
      }),
      (s._getClosestResting = function (t, e, i) {
        for (
          var n = this.selectedIndex,
            o = 1 / 0,
            s =
              this.options.contain && !this.options.wrapAround
                ? function (t, e) {
                    return t <= e;
                  }
                : function (t, e) {
                    return t < e;
                  };
          s(e, o) &&
          ((n += i), (o = e), null !== (e = this.getSlideDistance(-t, n)));

        )
          e = Math.abs(e);
        return { distance: o, index: n - i };
      }),
      (s.getSlideDistance = function (t, e) {
        var i = this.slides.length,
          o = this.options.wrapAround && i > 1,
          s = o ? n.modulo(e, i) : e,
          r = this.slides[s];
        if (!r) return null;
        var a = o ? this.slideableWidth * Math.floor(e / i) : 0;
        return t - (r.target + a);
      }),
      (s.dragEndBoostSelect = function () {
        if (
          void 0 === this.previousDragX ||
          !this.dragMoveTime ||
          new Date() - this.dragMoveTime > 100
        )
          return 0;
        var t = this.getSlideDistance(-this.dragX, this.selectedIndex),
          e = this.previousDragX - this.dragX;
        return t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0;
      }),
      (s.staticClick = function (t, e) {
        var i = this.getParentCell(t.target),
          n = i && i.element,
          o = i && this.cells.indexOf(i);
        this.dispatchEvent("staticClick", t, [e, n, o]);
      }),
      (s.onscroll = function () {
        var t = o(),
          e = this.pointerDownScroll.x - t.x,
          i = this.pointerDownScroll.y - t.y;
        (Math.abs(e) > 3 || Math.abs(i) > 3) && this._pointerDone();
      }),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickityt4s/js/prev-next-button",
          ["./flickityt4s", "unipointer/unipointer", "fizzy-ui-utils/utils"],
          function (i, n, o) {
            return e(t, i, n, o);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(
          t,
          require("./flickityt4s"),
          require("unipointer"),
          require("fizzy-ui-utils")
        ))
      : e(t, t.Flickityt4s, t.Unipointer, t.fizzyUIUtils);
  })(window, function (t, e, i, n) {
    "use strict";
    function o(t, e) {
      (this.direction = t), (this.parent = e), this._create();
    }
    var s = "http://www.w3.org/2000/svg";
    ((o.prototype = Object.create(i.prototype))._create = function () {
      (this.isEnabled = !0), (this.isPrevious = -1 == this.direction);
      var t = this.parent.options.rightToLeft ? 1 : -1;
      this.isLeft = this.direction == t;
      var e = (this.element = document.createElement("button"));
      (e.className = "flickityt4s-button flickityt4s-prev-next-button"),
        (e.className += this.isPrevious ? " previous" : " next"),
        e.setAttribute("type", "button"),
        this.disable(),
        e.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
      var i = this.createSVG();
      e.appendChild(i),
        this.parent.on("select", this.update.bind(this)),
        this.on(
          "pointerDown",
          this.parent.childUIPointerDown.bind(this.parent)
        );
    }),
      (o.prototype.activate = function () {
        this.bindStartEvent(this.element),
          this.element.addEventListener("click", this),
          this.parent.element.appendChild(this.element);
      }),
      (o.prototype.deactivate = function () {
        this.parent.element.removeChild(this.element),
          this.unbindStartEvent(this.element),
          this.element.removeEventListener("click", this);
      }),
      (o.prototype.createSVG = function () {
        var t = document.createElementNS(s, "svg");
        t.setAttribute("class", "flickityt4s-button-icon"),
          t.setAttribute("viewBox", "0 0 100 100");
        var e = document.createElementNS(s, "path"),
          i = (function (t) {
            return "string" == typeof t
              ? t
              : "M " +
                  t.x0 +
                  ",50 L " +
                  t.x1 +
                  "," +
                  (t.y1 + 50) +
                  " L " +
                  t.x2 +
                  "," +
                  (t.y2 + 50) +
                  " L " +
                  t.x3 +
                  ",50  L " +
                  t.x2 +
                  "," +
                  (50 - t.y2) +
                  " L " +
                  t.x1 +
                  "," +
                  (50 - t.y1) +
                  " Z";
          })(this.parent.options.arrowShape);
        return (
          e.setAttribute("d", i),
          e.setAttribute("class", "arrow"),
          this.isLeft ||
            e.setAttribute("transform", "translate(100, 100) rotate(180) "),
          t.appendChild(e),
          t
        );
      }),
      (o.prototype.handleEvent = n.handleEvent),
      (o.prototype.onclick = function () {
        if (this.isEnabled) {
          this.parent.uiChange();
          var t = this.isPrevious ? "previous" : "next";
          this.parent[t]();
        }
      }),
      (o.prototype.enable = function () {
        this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0));
      }),
      (o.prototype.disable = function () {
        this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1));
      }),
      (o.prototype.update = function () {
        var t = this.isPrevious ? "prev_" : "next_";
        this.parent.element.classList.remove(
          "flickityt4s_" + t + "disable",
          "flickityt4s_" + t + "enable"
        );
        var e = this.parent.slides;
        if (this.parent.options.wrapAround && e.length > 1) this.enable();
        else {
          var i = e.length ? e.length - 1 : 0,
            n = this.isPrevious ? 0 : i,
            o = this.parent.selectedIndex == n ? "disable" : "enable";
          this[o](), this.parent.element.classList.add("flickityt4s_" + t + o);
        }
      }),
      (o.prototype.destroy = function () {
        this.deactivate(), this.allOff();
      }),
      n.extend(e.defaults, {
        prevNextButtons: !0,
        arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 },
      }),
      e.createMethods.push("_createPrevNextButtons");
    var r = e.prototype;
    return (
      (r._createPrevNextButtons = function () {
        this.options.prevNextButtons &&
          ((this.prevButton = new o(-1, this)),
          (this.nextButton = new o(1, this)),
          this.on("activate", this.activatePrevNextButtons));
      }),
      (r.activatePrevNextButtons = function () {
        this.prevButton.activate(),
          this.nextButton.activate(),
          this.on("deactivate", this.deactivatePrevNextButtons);
      }),
      (r.deactivatePrevNextButtons = function () {
        this.prevButton.deactivate(),
          this.nextButton.deactivate(),
          this.off("deactivate", this.deactivatePrevNextButtons);
      }),
      (e.PrevNextButton = o),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickityt4s/js/page-dots",
          ["./flickityt4s", "unipointer/unipointer", "fizzy-ui-utils/utils"],
          function (i, n, o) {
            return e(t, i, n, o);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(
          t,
          require("./flickityt4s"),
          require("unipointer"),
          require("fizzy-ui-utils")
        ))
      : e(t, t.Flickityt4s, t.Unipointer, t.fizzyUIUtils);
  })(window, function (t, e, i, n) {
    function o(t) {
      (this.parent = t), this._create();
    }
    ((o.prototype = Object.create(i.prototype))._create = function () {
      (this.holder = document.createElement("ol")),
        (this.holder.className = "flickityt4s-page-dots"),
        (this.dots = []),
        (this.handleClick = this.onClick.bind(this)),
        this.on(
          "pointerDown",
          this.parent.childUIPointerDown.bind(this.parent)
        );
    }),
      (o.prototype.activate = function () {
        this.setDots(),
          this.holder.addEventListener("click", this.handleClick),
          this.bindStartEvent(this.holder),
          this.parent.element.appendChild(this.holder);
      }),
      (o.prototype.deactivate = function () {
        this.holder.removeEventListener("click", this.handleClick),
          this.unbindStartEvent(this.holder),
          this.parent.element.removeChild(this.holder);
      }),
      (o.prototype.setDots = function () {
        var t = this.parent.slides.length - this.dots.length;
        t > 0 ? this.addDots(t) : t < 0 && this.removeDots(-t);
      }),
      (o.prototype.addDots = function (t) {
        for (
          var e = document.createDocumentFragment(),
            i = [],
            n = this.dots.length,
            o = n + t,
            s = n;
          s < o;
          s++
        ) {
          var r = document.createElement("li");
          (r.className = "dot"),
            r.setAttribute("aria-label", "Page dot " + (s + 1)),
            e.appendChild(r),
            i.push(r);
        }
        this.holder.appendChild(e), (this.dots = this.dots.concat(i));
      }),
      (o.prototype.removeDots = function (t) {
        this.dots.splice(this.dots.length - t, t).forEach(function (t) {
          this.holder.removeChild(t);
        }, this);
      }),
      (o.prototype.updateSelected = function () {
        this.selectedDot &&
          ((this.selectedDot.className = "dot"),
          this.selectedDot.removeAttribute("aria-current")),
          this.dots.length &&
            ((this.selectedDot = this.dots[this.parent.selectedIndex]),
            (this.selectedDot.className = "dot is-selected"),
            this.selectedDot.setAttribute("aria-current", "step"));
      }),
      (o.prototype.onTap = o.prototype.onClick =
        function (t) {
          var e = t.target;
          if ("LI" == e.nodeName) {
            this.parent.uiChange();
            var i = this.dots.indexOf(e);
            this.parent.select(i);
          }
        }),
      (o.prototype.destroy = function () {
        this.deactivate(), this.allOff();
      }),
      (e.PageDots = o),
      n.extend(e.defaults, { pageDots: !0 }),
      e.createMethods.push("_createPageDots");
    var s = e.prototype;
    return (
      (s._createPageDots = function () {
        this.options.pageDots &&
          ((this.pageDots = new o(this)),
          this.on("activate", this.activatePageDots),
          this.on("select", this.updateSelectedPageDots),
          this.on("cellChange", this.updatePageDots),
          this.on("resize", this.updatePageDots),
          this.on("deactivate", this.deactivatePageDots));
      }),
      (s.activatePageDots = function () {
        this.pageDots.activate();
      }),
      (s.updateSelectedPageDots = function () {
        this.pageDots.updateSelected();
      }),
      (s.updatePageDots = function () {
        this.pageDots.setDots();
      }),
      (s.deactivatePageDots = function () {
        this.pageDots.deactivate();
      }),
      (e.PageDots = o),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickityt4s/js/player",
          ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickityt4s"],
          function (t, i, n) {
            return e(t, i, n);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(
          require("ev-emitter"),
          require("fizzy-ui-utils"),
          require("./flickityt4s")
        ))
      : e(t.EvEmitter, t.fizzyUIUtils, t.Flickityt4s);
  })(window, function (t, e, i) {
    function n(t) {
      (this.parent = t),
        (this.state = "stopped"),
        (this.onVisibilityChange = this.visibilityChange.bind(this)),
        (this.onVisibilityPlay = this.visibilityPlay.bind(this));
    }
    ((n.prototype = Object.create(t.prototype)).play = function () {
      "playing" != this.state &&
        (document.hidden
          ? document.addEventListener("visibilitychange", this.onVisibilityPlay)
          : ((this.state = "playing"),
            document.addEventListener(
              "visibilitychange",
              this.onVisibilityChange
            ),
            this.tick()));
    }),
      (n.prototype.tick = function () {
        if ("playing" == this.state) {
          var t = this.parent.options.autoPlay;
          t = "number" == typeof t ? t : 3e3;
          var e = this;
          this.clear(),
            (this.timeout = setTimeout(function () {
              e.parent.next(!0), e.tick();
            }, t));
        }
      }),
      (n.prototype.stop = function () {
        (this.state = "stopped"),
          this.clear(),
          document.removeEventListener(
            "visibilitychange",
            this.onVisibilityChange
          );
      }),
      (n.prototype.clear = function () {
        clearTimeout(this.timeout);
      }),
      (n.prototype.pause = function () {
        "playing" == this.state && ((this.state = "paused"), this.clear());
      }),
      (n.prototype.unpause = function () {
        "paused" == this.state && this.play();
      }),
      (n.prototype.visibilityChange = function () {
        this[document.hidden ? "pause" : "unpause"]();
      }),
      (n.prototype.visibilityPlay = function () {
        this.play(),
          document.removeEventListener(
            "visibilitychange",
            this.onVisibilityPlay
          );
      }),
      e.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
      i.createMethods.push("_createPlayer");
    var o = i.prototype;
    return (
      (o._createPlayer = function () {
        (this.player = new n(this)),
          this.on("activate", this.activatePlayer),
          this.on("uiChange", this.stopPlayer),
          this.on("pointerDown", this.stopPlayer),
          this.on("deactivate", this.deactivatePlayer);
      }),
      (o.activatePlayer = function () {
        this.options.autoPlay &&
          (this.player.play(),
          this.element.addEventListener("mouseenter", this));
      }),
      (o.playPlayer = function () {
        this.player.play();
      }),
      (o.stopPlayer = function () {
        this.player.stop();
      }),
      (o.pausePlayer = function () {
        this.player.pause();
      }),
      (o.unpausePlayer = function () {
        this.player.unpause();
      }),
      (o.deactivatePlayer = function () {
        this.player.stop(),
          this.element.removeEventListener("mouseenter", this);
      }),
      (o.onmouseenter = function () {
        this.options.pauseAutoPlayOnHover &&
          (this.player.pause(),
          this.element.addEventListener("mouseleave", this));
      }),
      (o.onmouseleave = function () {
        this.player.unpause(),
          this.element.removeEventListener("mouseleave", this);
      }),
      (i.Player = n),
      i
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickityt4s/js/add-remove-cell",
          ["./flickityt4s", "fizzy-ui-utils/utils"],
          function (i, n) {
            return e(t, i, n);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(
          t,
          require("./flickityt4s"),
          require("fizzy-ui-utils")
        ))
      : e(t, t.Flickityt4s, t.fizzyUIUtils);
  })(window, function (t, e, i) {
    var n = e.prototype;
    return (
      (n.insert = function (t, e) {
        var i = this._makeCells(t);
        if (i && i.length) {
          var n = this.cells.length;
          e = void 0 === e ? n : e;
          var o = (function (t) {
              var e = document.createDocumentFragment();
              return (
                t.forEach(function (t) {
                  e.appendChild(t.element);
                }),
                e
              );
            })(i),
            s = e == n;
          if (s) this.slider.appendChild(o);
          else {
            var r = this.cells[e].element;
            this.slider.insertBefore(o, r);
          }
          if (0 === e) this.cells = i.concat(this.cells);
          else if (s) this.cells = this.cells.concat(i);
          else {
            var a = this.cells.splice(e, n - e);
            this.cells = this.cells.concat(i).concat(a);
          }
          this._sizeCells(i), this.cellChange(e, !0);
        }
      }),
      (n.append = function (t) {
        this.insert(t, this.cells.length);
      }),
      (n.prepend = function (t) {
        this.insert(t, 0);
      }),
      (n.remove = function (t) {
        var e = this.getCells(t);
        if (e && e.length) {
          var n = this.cells.length - 1;
          e.forEach(function (t) {
            t.remove();
            var e = this.cells.indexOf(t);
            (n = Math.min(e, n)), i.removeFrom(this.cells, t);
          }, this),
            this.cellChange(n, !0);
        }
      }),
      (n.cellSizeChange = function (t) {
        var e = this.getCell(t);
        if (e) {
          e.getSize();
          var i = this.cells.indexOf(e);
          this.cellChange(i);
        }
      }),
      (n.cellChange = function (t, e) {
        var i = this.selectedElement;
        this._positionCells(t),
          this._getWrapShiftCells(),
          this.setGallerySize(),
          this.setPrevNextButtons();
        var n = this.getCell(i);
        n && (this.selectedIndex = this.getCellSlideIndex(n)),
          (this.selectedIndex = Math.min(
            this.slides.length - 1,
            this.selectedIndex
          )),
          this.emitEvent("cellChange", [t]),
          this.select(this.selectedIndex),
          e && this.positionSliderAtSelected();
      }),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickityt4s/js/index",
          [
            "./flickityt4s",
            "./drag",
            "./prev-next-button",
            "./page-dots",
            "./player",
            "./add-remove-cell",
            "./lazyload",
          ],
          e
        )
      : "object" == typeof module &&
        module.exports &&
        (module.exports = e(
          require("./flickityt4s"),
          require("./drag"),
          require("./prev-next-button"),
          require("./page-dots"),
          require("./player"),
          require("./add-remove-cell"),
          require("./lazyload")
        ));
  })(window, function (t) {
    return t;
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickityt4s-as-nav-for/as-nav-for",
          ["flickityt4s/js/index", "fizzy-ui-utils/utils"],
          e
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("flickityt4s"), require("fizzy-ui-utils")))
      : (t.Flickityt4s = e(t.Flickityt4s, t.fizzyUIUtils));
  })(window, function (t, e) {
    t.createMethods.push("_createAsNavFor");
    var i = t.prototype;
    return (
      (i._createAsNavFor = function () {
        this.on("activate", this.activateAsNavFor),
          this.on("deactivate", this.deactivateAsNavFor),
          this.on("destroy", this.destroyAsNavFor);
        var t = this.options.asNavFor;
        if (t) {
          var e = this;
          setTimeout(function () {
            e.setNavCompanion(t);
          });
        }
      }),
      (i.setNavCompanion = function (i) {
        i = e.getQueryElement(i);
        var n = t.data(i);
        if (n && n != this) {
          this.navCompanion = n;
          var o = this;
          (this.onNavCompanionSelect = function () {
            o.navCompanionSelect();
          }),
            n.on("select", this.onNavCompanionSelect),
            this.on("staticClick", this.onNavStaticClick),
            this.navCompanionSelect(!0);
        }
      }),
      (i.navCompanionSelect = function (t) {
        var e = this.navCompanion && this.navCompanion.selectedCells;
        if (e) {
          var i,
            n = e[0],
            o = this.navCompanion.cells.indexOf(n),
            s = o + e.length - 1,
            r = Math.floor((s - (i = o)) * this.navCompanion.cellAlign + i);
          if (
            (this.selectCell(r, !1, t),
            this.removeNavSelectedElements(),
            !(r >= this.cells.length))
          ) {
            var a = this.cells.slice(o, s + 1);
            (this.navSelectedElements = a.map(function (t) {
              return t.element;
            })),
              this.changeNavSelectedClass("add");
          }
        }
      }),
      (i.changeNavSelectedClass = function (t) {
        this.navSelectedElements.forEach(function (e) {
          e.classList[t]("is-nav-selected");
        });
      }),
      (i.activateAsNavFor = function () {
        this.navCompanionSelect(!0);
      }),
      (i.removeNavSelectedElements = function () {
        this.navSelectedElements &&
          (this.changeNavSelectedClass("remove"),
          delete this.navSelectedElements);
      }),
      (i.onNavStaticClick = function (t, e, i, n) {
        "number" == typeof n && this.navCompanion.selectCell(n);
      }),
      (i.deactivateAsNavFor = function () {
        this.removeNavSelectedElements();
      }),
      (i.destroyAsNavFor = function () {
        this.navCompanion &&
          (this.navCompanion.off("select", this.onNavCompanionSelect),
          this.off("staticClick", this.onNavStaticClick),
          delete this.navCompanion);
      }),
      t
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(["flickityt4s/js/index", "fizzy-ui-utils/utils"], e)
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("flickityt4s"), require("fizzy-ui-utils")))
      : e(t.Flickityt4s, t.fizzyUIUtils);
  })(this, function (t, e) {
    var i = t.Slide,
      n = i.prototype.updateTarget;
    (i.prototype.updateTarget = function () {
      if ((n.apply(this, arguments), this.parent.options.fade)) {
        var t = this.target - this.x,
          e = this.cells[0].x;
        this.cells.forEach(function (i) {
          var n = i.x - e - t;
          i.renderPosition(n);
        });
      }
    }),
      (i.prototype.setOpacity = function (t) {
        this.cells.forEach(function (e) {
          e.element.style.opacity = t;
        });
      });
    var o = t.prototype;
    t.createMethods.push("_createFade"),
      (o._createFade = function () {
        (this.fadeIndex = this.selectedIndex),
          (this.prevSelectedIndex = this.selectedIndex),
          this.on("select", this.onSelectFade),
          this.on("dragEnd", this.onDragEndFade),
          this.on("settle", this.onSettleFade),
          this.on("activate", this.onActivateFade),
          this.on("deactivate", this.onDeactivateFade);
      });
    var s = o.updateSlides;
    (o.updateSlides = function () {
      s.apply(this, arguments), this.options.fade;
    }),
      (o.onSelectFade = function () {
        (this.fadeIndex = Math.min(
          this.prevSelectedIndex,
          this.slides.length - 1
        )),
          (this.prevSelectedIndex = this.selectedIndex);
      }),
      (o.onSettleFade = function () {
        delete this.didDragEnd, this.options.fade;
      }),
      (o.onDragEndFade = function () {
        this.didDragEnd = !0;
      }),
      (o.onActivateFade = function () {
        this.options.fade && this.element.classList.add("is-fade");
      }),
      (o.onDeactivateFade = function () {
        this.options.fade &&
          (this.element.classList.remove("is-fade"),
          this.slides.forEach(function (t) {
            t.setOpacity("");
          }));
      });
    var r = o.positionSlider;
    o.positionSlider = function () {
      this.options.fade
        ? (this.fadeSlides(), this.dispatchScrollEvent())
        : r.apply(this, arguments);
    };
    var a = o.positionSliderAtSelected;
    (o.positionSliderAtSelected = function () {
      this.options.fade && this.setTranslateX(0), a.apply(this, arguments);
    }),
      (o.fadeSlides = function () {
        this.slides.length;
      }),
      (o.getFadeIndexes = function () {
        return this.isDragging || this.didDragEnd
          ? this.options.wrapAround
            ? this.getFadeDragWrapIndexes()
            : this.getFadeDragLimitIndexes()
          : { a: this.fadeIndex, b: this.selectedIndex };
      }),
      (o.getFadeDragWrapIndexes = function () {
        var t = this.slides.map(function (t, e) {
            return this.getSlideDistance(-this.x, e);
          }, this),
          i = t.map(function (t) {
            return Math.abs(t);
          }),
          n = Math.min.apply(Math, i),
          o = i.indexOf(n),
          s = t[o],
          r = this.slides.length,
          a = s >= 0 ? 1 : -1;
        return { a: o, b: e.modulo(o + a, r) };
      }),
      (o.getFadeDragLimitIndexes = function () {
        for (var t = 0, e = 0; e < this.slides.length - 1; e++) {
          var i = this.slides[e];
          if (-this.x < i.target) break;
          t = e;
        }
        return { a: t, b: t + 1 };
      }),
      (o.wrapDifference = function (t, e) {
        var i = e - t;
        if (!this.options.wrapAround) return i;
        var n = i + this.slideableWidth,
          o = i - this.slideableWidth;
        return (
          Math.abs(n) < Math.abs(i) && (i = n),
          Math.abs(o) < Math.abs(i) && (i = o),
          i
        );
      });
    var l = o._getWrapShiftCells;
    o._getWrapShiftCells = function () {
      this.options.fade || l.apply(this, arguments);
    };
    var c = o.shiftWrapCells;
    return (
      (o.shiftWrapCells = function () {
        this.options.fade || c.apply(this, arguments);
      }),
      t
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(["flickityt4s/js/index", "fizzy-ui-utils/utils"], e)
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("flickityt4s"), require("fizzy-ui-utils")))
      : (t.Flickityt4s = e(t.Flickityt4s, t.fizzyUIUtils));
  })(window, function (t, e) {
    "use strict";
    return (
      t.createMethods.push("_createSync"),
      (t.prototype._createSync = function () {
        this.syncers = {};
        var t = this.options.sync;
        if ((this.on("destroy", this.unsyncAll), t)) {
          var e = this;
          setTimeout(function () {
            e.sync(t);
          });
        }
      }),
      (t.prototype.sync = function (i) {
        i = e.getQueryElement(i);
        var n = t.data(i);
        n && (this._syncCompanion(n), n._syncCompanion(this));
      }),
      (t.prototype._syncCompanion = function (t) {
        function e() {
          var e = i.selectedIndex;
          t.selectedIndex != e && t.select(e);
        }
        var i = this;
        this.on("select", e),
          (this.syncers[t.guid] = { flickityt4s: t, listener: e });
      }),
      (t.prototype.unsync = function (i) {
        i = e.getQueryElement(i);
        var n = t.data(i);
        this._unsync(n);
      }),
      (t.prototype._unsync = function (t) {
        t && (this._unsyncCompanion(t), t._unsyncCompanion(this));
      }),
      (t.prototype._unsyncCompanion = function (t) {
        var e = t.guid,
          i = this.syncers[e];
        this.off("select", i.listener), delete this.syncers[e];
      }),
      (t.prototype.unsyncAll = function () {
        for (var t in this.syncers) {
          var e = this.syncers[t];
          this._unsync(e.flickityt4s);
        }
      }),
      t
    );
  }),
  (function (t, e) {
    "undefined" != typeof module && module.exports
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define(e)
      : (this.$script = e());
  })(0, function () {
    function t(t, e) {
      for (var i = 0, n = t.length; i < n; ++i) if (!e(t[i])) return l;
      return 1;
    }
    function e(e, i) {
      t(e, function (t) {
        return i(t), 1;
      });
    }
    function i(s, r, a) {
      function l(t) {
        return t.call ? t() : d[t];
      }
      function u() {
        if (!--y) {
          (d[v] = 1), m && m();
          for (var i in p) t(i.split("|"), l) && !e(p[i], l) && (p[i] = []);
        }
      }
      s = s[c] ? s : [s];
      var h = r && r.call,
        m = h ? r : a,
        v = h ? s.join("") : r,
        y = s.length;
      return (
        setTimeout(function () {
          e(s, function t(e, i) {
            return null === e
              ? u()
              : (!i &&
                  !/^https?:\/\//.test(e) &&
                  o &&
                  (e = -1 === e.indexOf(".js") ? o + e + ".js" : o + e),
                g[e]
                  ? (v && (f[v] = 1),
                    2 == g[e]
                      ? u()
                      : setTimeout(function () {
                          t(e, !0);
                        }, 0))
                  : ((g[e] = 1), v && (f[v] = 1), void n(e, u)));
          });
        }, 0),
        i
      );
    }
    function n(t, e) {
      var i,
        n = r.createElement("script");
      (n.onload =
        n.onerror =
        n[h] =
          function () {
            (n[u] && !/^c|loade/.test(n[u])) ||
              i ||
              ((n.onload = n[h] = null), (i = 1), (g[t] = 2), e());
          }),
        (n.async = 1),
        (n.src = s ? t + (-1 === t.indexOf("?") ? "?" : "&") + s : t),
        a.insertBefore(n, a.lastChild);
    }
    var o,
      s,
      r = document,
      a = r.getElementsByTagName("head")[0],
      l = !1,
      c = "push",
      u = "readyState",
      h = "onreadystatechange",
      d = {},
      f = {},
      p = {},
      g = {};
    return (
      (i.get = n),
      (i.order = function (t, e, n) {
        !(function o(s) {
          (s = t.shift()), t.length ? i(s, o) : i(s, e, n);
        })();
      }),
      (i.path = function (t) {
        o = t;
      }),
      (i.urlArgs = function (t) {
        s = t;
      }),
      (i.ready = function (n, o, s) {
        var r = [];
        return (
          !e((n = n[c] ? n : [n]), function (t) {
            d[t] || r[c](t);
          }) &&
          t(n, function (t) {
            return d[t];
          })
            ? o()
            : (function (t) {
                (p[t] = p[t] || []), p[t][c](o), s && s(r);
              })(n.join("|")),
          i
        );
      }),
      (i.done = function (t) {
        i([null], t);
      }),
      i
    );
  }),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define(e)
      : ((t = t || self),
        (function () {
          var i = t.Cookies,
            n = (t.Cookies = e());
          n.noConflict = function () {
            return (t.Cookies = i), n;
          };
        })());
  })(this, function () {
    "use strict";
    function t(t) {
      for (var e = 1; e < arguments.length; e++) {
        var i = arguments[e];
        for (var n in i) t[n] = i[n];
      }
      return t;
    }
    return (function e(i, n) {
      function o(e, o, s) {
        if ("undefined" != typeof document) {
          "number" == typeof (s = t({}, n, s)).expires &&
            (s.expires = new Date(Date.now() + 864e5 * s.expires)),
            s.expires && (s.expires = s.expires.toUTCString()),
            (e = encodeURIComponent(e)
              .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
              .replace(/[()]/g, escape));
          var r = "";
          for (var a in s)
            s[a] &&
              ((r += "; " + a), !0 !== s[a] && (r += "=" + s[a].split(";")[0]));
          return (document.cookie = e + "=" + i.write(o, e) + r);
        }
      }
      return Object.create(
        {
          set: o,
          get: function (t) {
            if ("undefined" != typeof document && (!arguments.length || t)) {
              for (
                var e = document.cookie ? document.cookie.split("; ") : [],
                  n = {},
                  o = 0;
                o < e.length;
                o++
              ) {
                var s = e[o].split("="),
                  r = s.slice(1).join("=");
                try {
                  var a = decodeURIComponent(s[0]);
                  if (((n[a] = i.read(r, a)), t === a)) break;
                } catch (t) {}
              }
              return t ? n[t] : n;
            }
          },
          remove: function (e, i) {
            o(e, "", t({}, i, { expires: -1 }));
          },
          withAttributes: function (i) {
            return e(this.converter, t({}, this.attributes, i));
          },
          withConverter: function (i) {
            return e(t({}, this.converter, i), this.attributes);
          },
        },
        {
          attributes: { value: Object.freeze(n) },
          converter: { value: Object.freeze(i) },
        }
      );
    })(
      {
        read: function (t) {
          return (
            '"' === t[0] && (t = t.slice(1, -1)),
            t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
          );
        },
        write: function (t) {
          return encodeURIComponent(t).replace(
            /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
            decodeURIComponent
          );
        },
      },
      { path: "/" }
    );
  });
var CookiesT4 = Cookies.noConflict();
!(function (t) {
  "use strict";
  function e(t, e = !0) {
    if (IsDesignMode && e) return !1;
    var i = "session" === t ? window.sessionStorage : window.localStorage;
    try {
      return i.setItem("t4s", "test"), i.removeItem("t4s"), !0;
    } catch (t) {
      return !1;
    }
  }
  var i = t(window),
    n = t(document),
    o = t("body"),
    s = window.T4Sroutes.root_url,
    r = i.width(),
    a = T4Sconfigs.cacheName + T4Sconfigs.cartCurrency + Shopify.country + s,
    l = r < 768,
    c = r < 1025;
  (isStorageSpSession = e("session")),
    (isStorageSpSessionAll = e("session", !1)),
    (isStorageSpdLocal = e("local")),
    (isStorageSpdLocalAll = e("local", !1)),
    "development" == Shopify.theme.role &&
      isStorageSpSessionAll &&
      sessionStorage.clear(),
    (T4SThemeSP.$appendComponent = t("#t4s-append-component")),
    (T4SThemeSP.cacheNameFirst = a),
    (T4SThemeSP.root_url = "/" != s ? s + "/" : "/"),
    void 0 === window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (t, e) {
      return function () {
        return t.apply(e, arguments);
      };
    }),
    (Shopify.setSelectorByValue = function (t, e) {
      for (var i = 0, n = t.options.length; i < n; i++) {
        var o = t.options[i];
        if (e == o.value || e == o.innerHTML) return (t.selectedIndex = i), i;
      }
    }),
    (Shopify.addListener = function (t, e, i) {
      t.addEventListener
        ? t.addEventListener(e, i, !1)
        : t.attachEvent("on" + e, i);
    }),
    (Shopify.postLink = function (t, e) {
      var i = (e = e || {}).method || "post",
        n = e.parameters || {},
        o = document.createElement("form");
      o.setAttribute("method", i), o.setAttribute("action", t);
      for (var s in n) {
        var r = document.createElement("input");
        r.setAttribute("type", "hidden"),
          r.setAttribute("name", s),
          r.setAttribute("value", n[s]),
          o.appendChild(r);
      }
      document.body.appendChild(o), o.submit(), document.body.removeChild(o);
    }),
    (Shopify.CountryProvinceSelector = function (t, e, i) {
      (this.countryEl = document.getElementById(t)),
        (this.provinceEl = document.getElementById(e)),
        (this.provinceContainer = document.getElementById(i.hideElement || e)),
        Shopify.addListener(
          this.countryEl,
          "change",
          Shopify.bind(this.countryHandler, this)
        ),
        this.initCountry(),
        this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
      initCountry: function () {
        var t = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler();
      },
      initProvince: function () {
        var t = this.provinceEl.getAttribute("data-default");
        t &&
          this.provinceEl.options.length > 0 &&
          Shopify.setSelectorByValue(this.provinceEl, t);
      },
      countryHandler: function (t) {
        var e = this.countryEl.options[this.countryEl.selectedIndex],
          i = e.getAttribute("data-provinces"),
          n = JSON.parse(i);
        if ((this.clearOptions(this.provinceEl), n && 0 == n.length))
          this.provinceContainer.style.display = "none";
        else {
          for (var o = 0; o < n.length; o++) {
            ((e = document.createElement("option")).value = n[o][0]),
              (e.innerHTML = n[o][1]),
              this.provinceEl.appendChild(e);
          }
          this.provinceContainer.style.display = "";
        }
      },
      clearOptions: function (t) {
        for (; t.firstChild; ) t.removeChild(t.firstChild);
      },
      setOptions: function (t, e) {
        var i = 0;
        for (e.length; i < e.length; i++) {
          var n = document.createElement("option");
          (n.value = e[i]), (n.innerHTML = e[i]), t.appendChild(n);
        }
      },
    }),
    (T4SThemeSP.resizeEventT4 = function (t, e, i) {
      try {
        window.dispatchEvent(new Event("resize"));
      } catch (t) {
        var n = window.document.createEvent("UIEvents");
        n.initUIEvent("resize", !0, !1, window, 0), window.dispatchEvent(n);
      }
    }),
    (T4SThemeSP.debounce = function (t, e, i) {
      var n;
      return function () {
        var o = this,
          s = arguments,
          r = i && !n;
        clearTimeout(n),
          (n = setTimeout(function () {
            (n = null), i || e.apply(o, s);
          }, t)),
          r && e.apply(o, s);
      };
    }),
    (T4SThemeSP.storageCurrency = function () {
      return isStorageSpdLocal ? localStorage.getItem("T4Currency") : null;
    }),
    (T4SThemeSP.fullHeightFirtSe = function () {
      var e = t("#MainContent >.t4s-section:first").find(".t4s_ratio_fh");
      if (0 != e.length) {
        var n, o, s;
        (n = i.height()),
          (o = e.offset().top) < n &&
            ((s = 100 - o / (n / 100)),
            e.css("--t4s-aspect-ratio-fh", s + "vh"));
      }
    }),
    (T4SThemeSP.handle = function (t) {
      var e = (t = (t + "").toLowerCase())
        .replace(/'|"|\(|\)|\[|\]/g, "")
        .replace(/[\s\x21-\x2f\x3a-\x40\x7b-\x7f^`\\[\]]+/g, "-")
        .replace(/\W+/g, "-")
        .replace(/^-+|-+$/g, "");
      return "" == e ? t : e;
    }),
    (T4SThemeSP._handle = function (t) {
      var e = (t = (t + "").toLowerCase())
        .replace(/'|"|\(|\)|\[|\]/g, "")
        .replace(/[\s\x21-\x2f\x3a-\x40\x7b-\x7f^`\\[\]]+/g, "_")
        .replace(/\W+/g, "_")
        .replace(/^-+|-+$/g, "");
      return "" == e ? t : e;
    }),
    (T4SThemeSP.escapeHtml = function (t) {
      return t
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }),
    (T4SThemeSP.descapeHtml = function (t) {
      return t
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;/g, "&");
    }),
    (T4SThemeSP.Images = (function () {
      return {
        preloadImages: function (e) {
          t(e).each(function () {
            t("<img/>")[0].src = this;
          });
        },
        getNewImageUrl: function (t, e = 0, i = 0) {
          return e || i
            ? (e && (t = t + "&width=" + e),
              i && (t = t + "&height=" + i),
              this.removeProtocol(t))
            : null;
        },
        removeProtocol: function (t) {
          return t.replace(/http(s)?:/, "");
        },
        lazyloadImagePath: function (t) {
          return this.removeProtocol(t + "&width=1");
        },
      };
    })()),
    (T4SThemeSP.getUID = function (t) {
      do {
        t += ~~(1e6 * Math.random());
      } while (document.getElementById(t));
      return t;
    }),
    (T4SThemeSP.Carousel = (function () {
      function e(e) {
        (this.el = e),
          (this.$el = t(e)),
          (this.UID = T4SThemeSP.getUID()),
          (n = "resize.carousel" + this.UID);
        const o = JSON.parse(this.$el.attr("data-flickityt4s-js") || f);
        this.args = Object.assign({}, r, o);
        let a = this.args.cellAlign,
          l = this.args.cellAlignLG;
        (this.args.cellAlign = m[a] || a),
          (this.args.cellAlignLG = m[l] || l),
          (this.IdSlider = this.args.t4sid),
          (this.args.fade =
            this.$el.hasClass("t4s-slide-eff-fade") || this.args.fade),
          (this.args.rightToLeft = isThemeRTL),
          (this.$deferredMedia = this.$el.find(s.productMediaWrapper)),
          this.args.isMedia &&
            ((this.isMedia =
              this.$el.find("[data-deferred-media]").length > 0 ||
              this.$el.find('[data-media-type="360"]').length > 0),
            this.isMedia &&
              ((this.$groupBtn = t(
                `[ data-t4s-group-btns="${this.args.t4sid}"]`
              )),
              (this.$mediaGroup = this.$el.closest(s.mediaGroup)))),
          this.args.wrapAround && c && (this.args.dragThreshold = 55),
          (this.args.on = {
            ready: this.init.bind(this),
            change: this.slideChange.bind(this),
            select: this.slideSelect.bind(this),
            settle: this.afterChange.bind(this),
          }),
          this.args.thumbNav && this._initCarouselNav(),
          this.args.avoidReflow &&
            (function (t) {
              if (t.id) {
                for (var e = t.firstChild; null != e && 3 == e.nodeType; )
                  e = e.nextSibling;
                var i = document.createElement("style");
                (i.innerHTML = `#${t.id} .flickity-viewport{height:${e.offsetHeight}px}`),
                  document.head.appendChild(i);
              }
            })(e),
          (this.$wrapper = this.$el.closest(s.wrapper)),
          (this.wrapper = this.$wrapper[0]),
          (this.pauseBtn = this.wrapper
            ? this.wrapper.querySelector(s.pauseButton)
            : null),
          (this.$pauseBtn = t(this.pauseBtn)),
          (this.isPlaying = this.args.autoPlay || this.args.autoPlayT4),
          (this.args.cellAlignOriginnal = this.args.cellAlign),
          (this.hasMWLG = 19041994 != this.args.minWidthLG),
          this.hasMWLG &&
            this.args.minWidthLG <= i.width() &&
            (this.args.cellAlign = this.args.cellAlignLG),
          this.args.centerSlide &&
            this.args.wrapAround &&
            ((this.args.cellAlign = "center"),
            (this.args.cellAlignOriginnal = "center")),
          (this.$carousel = this.$el.flickityt4s(this.args));
        var u = this;
        (this.flkty = this.$carousel.data("flickityt4s")),
          (this.selectedIndex = this.flkty.selectedIndex),
          setTimeout(u.actionsAPI("resize"), 0),
          setTimeout(function () {
            u.$el.addClass("t4s-enabled"),
              u.args.isSimple &&
                (u.actionsAPI("resize"),
                setTimeout(u.actionsAPI("resize"), 150));
          }, 100),
          this._selectChange(),
          this.isPlaying &&
            this.wrapper &&
            this.pauseBtn &&
            this.pauseBtn.addEventListener(
              "click",
              this._togglePause.bind(this)
            ),
          this.args.navUI && this._customNavUI(),
          this.args.dotUI && this._customDotUI(),
          this.args.parallax && this._parallaxEffect(),
          this.args.status && this._status(),
          this.args.isFilter && this._updateCarousel(),
          this.args.btnSmartTab && this._updateBtnTab(),
          this.args.prevNextButtons &&
            this._customIcon(
              this.$carousel.find(".flickityt4s-button.previous"),
              this.$carousel.find(".flickityt4s-button.next")
            ),
          this.args.selectWithSelector && this._selectWithSelector(),
          this.args.scrollbar &&
            !this.args.scrollbarDraggable &&
            this._scrollbarCarousel(),
          this.args.scrollbar &&
            this.args.scrollbarDraggable &&
            this._scrollbarDraggableCarousel();
        var d = this.args.thumbVertical;
        i.width() < 1025 && d && (this.args.thumbVertical = !1),
          i.on(
            n,
            T4SThemeSP.debounce(
              300,
              function () {
                u.hasMWLG &&
                  (u.args.minWidthLG <= i.width()
                    ? (u.flkty.options.cellAlign = u.args.cellAlignLG)
                    : (u.flkty.options.cellAlign = u.args.cellAlignOriginnal)),
                  u.actionsAPI("resize"),
                  i.width() < 1025 && d
                    ? (u.args.thumbVertical = !1)
                    : i.width() > 1024 && d && (u.args.thumbVertical = !0);
              }.bind(this)
            )
          ),
          u.$el.on(h, u.destroy.bind(u));
      }
      var n,
        o = {
          animateOut: "animate-out",
          isPlaying: "is--playing",
          isPaused: "is--paused",
          isActive: "is--active",
          isNavActive: "is-nav-selected",
          isXrShowing: "is-shopify-xr__showing",
          navItem: "t4s-carousel__nav-item",
          selected: "is-selected",
        },
        s = {
          currentSlide: `.${o.selected}`,
          wrapper: ".t4s-carousel-wrapper",
          pauseButton: ".t4s-carousel__pause",
          productMediaWrapper: "[data-product-single-media-wrapper]",
          mediaGroup: "[data-product-single-media-group]",
          dataMediaPlay: "data-is-mediaPlay",
          productMediaPlay: "[data-is-mediaPlay]",
        },
        r = {
          adaptiveHeight: !1,
          autoPlay: !1,
          avoidReflow: !1,
          thumbNav: !1,
          thumbVertical: !1,
          navUI: !1,
          dotUI: !1,
          parallax: !1,
          status: !1,
          isMedia: !1,
          t4sid: "19041994",
          t4sidTab: "19041994",
          selectWithSelector: !1,
          scrollbar: !1,
          scrollbarDraggable: !1,
          fullwidthSide: !1,
          centerSlide: !1,
          isSimple: !1,
          minWidthLG: 19041994,
          cellAlign: "center",
          cellAlignLG: "left",
          btnSmartTab: !1,
          activeTab: !1,
          customIcon: 0,
          viewBox: "0 0 100 100",
          checkVisibility: !0,
          autoPlayT4: !1,
          dragThreshold: 7,
          fade: !1,
          friction: 0.8,
          initialIndex: 0,
          pageDots: !1,
          pauseAutoPlayOnHover: !1,
          prevNextButtons: !1,
          selectedAttraction: 0.14,
        },
        a = {
          select: "select.carousel",
          clicknavUI: "click.navt4s",
          clickdotUI: "click.dott4s",
          clickThumb: "click.thumbt4s",
        },
        u = {
          video:
            '<svg viewBox="0 0 384 512"><use href="#icon-thumb-video"/></svg>',
          external_videoyoutube:
            '<svg viewBox="0 0 576 512"><use href="#icon-external-youtube"/></svg>',
          external_videovimeo:
            '<svg viewBox="0 0 448 512"><use href="#icon-external-vimeo"/></svg>',
          model:
            '<svg viewBox="0 0 512 512"><use href="#icon-thumb-model"/></svg>',
          360: '<svg viewBox="0 0 640 512"><use href="#icon-thumb-360"/></svg>',
        },
        h = "destroy.t4s",
        d = "",
        f = "{}",
        p = !1,
        g = window.CSS.supports("scroll-behavior", "smooth");
      const m = { start: "left", end: "right" };
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          init: function (t) {
            var e = this;
            (e.currentSlide = e.el.querySelector(s.currentSlide)),
              e.args.autoPlayT4 && e.autoPlayT4(),
              e.$pauseBtn.addClass(o.isPlaying),
              e.args.callbacks &&
                e.args.callbacks.onInit &&
                "function" == typeof e.args.callbacks.onInit &&
                e.args.callbacks.onInit(e.currentSlide);
          },
          slideChange: function (e) {
            i = this;
            if (
              (i.args.thumbNav && i.thumbnailsGoto(e),
              i.args.callbacks &&
                i.args.callbacks.onChange &&
                "function" == typeof i.args.callbacks.onChange &&
                i.args.callbacks.onChange(e),
              i.$carouselNavPrev &&
                i.$carouselNavPrev.length &&
                (i.$carouselNavPrev[0].classList.toggle("is--hide", 0 === e),
                i.$carouselNavNext[0].classList.toggle(
                  "is--hide",
                  e === i.$carouselNavLinks.length - 1
                )),
              i.$carousel &&
                i.$carousel.find("video").length > 0 &&
                (i.$carousel.find("video").each(function (t, e) {
                  e.pause();
                }),
                t(i.currentSlide).each(function (e, i) {
                  let n = t(this).find("video")[0];
                  void 0 !== n && n.play();
                })),
              i.isMedia && i._switchMedia(e),
              i.args.autoPlayT4 && i.autoPlayT4(),
              i.$carousel)
            ) {
              var i;
              (i = this).flkty.prevButton &&
                t(i.flkty.prevButton.element).attr(
                  "data-imgkey",
                  i.flkty.selectedIndex - 1 < 0
                    ? i.flkty.cells.length - 1
                    : i.flkty.selectedIndex - 1
                ),
                i.flkty.nextButton &&
                  t(i.flkty.nextButton.element).attr(
                    "data-imgkey",
                    i.flkty.selectedIndex + 1 >= i.flkty.cells.length
                      ? 0
                      : i.flkty.selectedIndex + 1
                  );
            }
          },
          autoPlayT4: function () {
            var t = this;
            t.time ||
              (t.wrapper &&
                t.wrapper.style.setProperty(
                  "--play-carousel-speed",
                  `${t.args.autoPlayT4}ms`
                ),
              (t.time = {})),
              (t.time.START = new Date().getTime()),
              (t.time.END = t.time.START + t.args.autoPlayT4),
              t.$pauseBtn.removeClass(o.isPlaying),
              t.isPlaying &&
                (clearTimeout(t.stayTimeout),
                (t.stayTimeout = setTimeout(function () {
                  t.actionsAPI("next", !0);
                }, t.args.autoPlayT4)),
                clearTimeout(t.pauseBtnTimeout),
                (t.pauseBtnTimeout = setTimeout(function () {
                  t.$pauseBtn.addClass(o.isPlaying);
                }, 20))),
              (t.time.REMAINING = t.args.autoPlayT4);
          },
          slideSelect: function (t) {},
          afterChange: function (t) {
            this.args.thumbNav && this.thumbnailsGoto(this.flkty.selectedIndex);
          },
          destroy: function () {
            this.$carouselNav &&
              this.$carouselNav
                .find("." + o.isNavActive)
                .removeClass(o.isNavActive),
              this.actionsAPI("destroy"),
              this.$el.off(h),
              i.off(n);
          },
          _togglePause: function () {
            var e = this,
              i = e.$pauseBtn.data("pause-title"),
              n = e.$pauseBtn.data("play-title");
            e.pauseBtn.classList.contains(o.isPaused)
              ? (e.pauseBtn.classList.remove(o.isPaused),
                e.wrapper.classList.remove(o.isPaused),
                t(".t4s-tooltip .tooltip-inner").text(i),
                e.pauseBtn.setAttribute("data-original-title", i),
                (e.isPlaying = !0),
                e.args.autoPlayT4 &&
                  ((e.time.END = new Date().getTime() + e.time.REMAINING),
                  (e.stayTimeout = setTimeout(function () {
                    e.actionsAPI("next", !0);
                  }, e.time.REMAINING))))
              : (e.wrapper.classList.add(o.isPaused),
                e.pauseBtn.classList.add(o.isPaused),
                t(".t4s-tooltip .tooltip-inner").text(n),
                e.pauseBtn.setAttribute("data-original-title", n),
                (e.isPlaying = !1),
                e.args.autoPlayT4 &&
                  (clearTimeout(e.stayTimeout),
                  (e.time.REMAINING = e.time.END - new Date().getTime()))),
              e.isPlaying && e.$pauseBtn.addClass(o.isPlaying);
          },
          actionsAPI: function (t, e = !1) {
            this.$carousel.flickityt4s(t, e);
          },
          _selectChange: function (t) {
            var e = this;
            e.$carousel.on("select.flickityt4s", function (t, i) {
              e.$carousel.trigger(a.select);
            });
          },
          _customNavUI: function (e, i) {
            var n = this,
              o = n.args.wrapAround || !1;
            (e = e || t(".btn__prev--" + n.IdSlider)),
              0 != (i = i || t(".btn__next--" + n.IdSlider)).length &&
                (n._customIcon(e, i),
                e.off(a.clicknavUI).on(a.clicknavUI, function () {
                  n.actionsAPI("previous");
                }),
                i.off(a.clicknavUI).on(a.clicknavUI, function () {
                  n.actionsAPI("next");
                }),
                n._setButtonStatus(o, e, i),
                n.$carousel.on(a.select, function () {
                  n._setButtonStatus(o, e, i);
                }));
          },
          _setButtonStatus: function (t, e, i) {
            let n = i.closest("[data-tab-active]"),
              o = this.flkty.selectedCell.target;
            n.addClass("prev_next_added"),
              n.removeClass("tab_prev_next_disable"),
              this.flkty.slides.length < 2
                ? (n.addClass("tab_prev_next_disable"),
                  e.attr("disabled", "disabled"),
                  i.attr("disabled", "disabled"))
                : o != this.flkty.cells[0].target || t
                ? o != this.flkty.getLastCell().target || t
                  ? (e.removeAttr("disabled"), i.removeAttr("disabled"))
                  : (i.attr("disabled", "disabled"), e.removeAttr("disabled"))
                : (e.attr("disabled", "disabled"), i.removeAttr("disabled"));
          },
          _customDotUI: function () {
            var e = this,
              i = t(".btn_group--cells" + e.IdSlider);
            if (i.data("build")) {
              let t = "";
              for (let i = 0; i < e.flkty.slides.length; i++)
                t +=
                  '<li class="dot btn_dott4s" aria-label="' +
                  (i + 1) +
                  '"></li>';
              i.html(t);
            }
            var n = i.find(".btn_dott4s");
            0 != n.length &&
              (n.eq(e.flkty.selectedIndex).addClass(o.selected),
              i.on(a.clickdotUI, ".btn_dott4s", function () {
                e.$carousel.flickityt4s("select", t(this).index());
              }),
              e.$carousel.on(a.select, function () {
                n.filter(`.${o.selected}`).removeClass(o.selected),
                  n.eq(e.flkty.selectedIndex).addClass(o.selected);
              }));
          },
          _parallaxEffect: function () {
            var t = this;
            if (t.$carousel.hasClass("slide-eff-parallax")) {
              if (l) e = ".t4s-slide .t4s-img-as-bg.t4s-d-md-none";
              else var e = ".t4s-slide .t4s-img-as-bg.t4s-d-md-block";
              var i = t.$carousel.find(e);
              0 != i.length &&
                t.$carousel.on("scroll.flickityt4s", function (e, n) {
                  t.flkty.slides.forEach(function (e, n) {
                    var o = i[n],
                      s = (-1 * (e.target + t.flkty.x)) / 3;
                    o.style.transform = "translateX( " + s + "px)";
                  });
                });
            }
          },
          _status: function () {
            function e() {
              void 0 != n.flkty.slides &&
                ((c = n.flkty.selectedIndex + 1),
                (u = n.flkty.slides.length),
                l && ((c = i(c, 2)), (u = i(u, 2))),
                s.text(c),
                r.text(u));
            }
            function i(t, e) {
              return (t = t.toString()).length < e ? i("0" + t, e) : t;
            }
            var n = this,
              o = t(".carousel--status" + n.IdSlider);
            if (0 != o.length) {
              var s = o.find("[data-current-slide]"),
                r = o.find("[data-total-number]"),
                l = n.args.pad || !1,
                c = 0,
                u = 0;
              e(), n.$carousel.on(a.select, e);
            }
          },
          _initCarouselNav: function () {
            var e = this;
            (e.$carouselNav = t(".carousel__nav--" + e.IdSlider)),
              0 != e.$carouselNav.length &&
                (p || e.addThumbIcons(),
                e.thumbnailsMarkup(),
                e.$carouselNavLinks
                  .eq([e.args.initialIndex])
                  .addClass(o.isNavActive),
                (e.$carouselNavPrev = t(
                  `[data-thumb-btn__prev="${e.IdSlider}"]`
                )),
                (e.$carouselNavNext = t(
                  `[data-thumb-btn__next="${e.IdSlider}"]`
                )),
                (this.$carouselNavPrev.length ||
                  this.$carouselNavNext.length) &&
                  (e.$carouselNavPrev.on(a.clickThumb, function () {
                    e.actionsAPI("previous");
                  }),
                  e.$carouselNavNext.on(a.clickThumb, function () {
                    e.actionsAPI("next");
                  })),
                e.args.isFilter
                  ? e.$carouselNav.on(
                      a.clickThumb,
                      "." + o.navItem,
                      function (i) {
                        let n = e.$carouselNav
                          .find(`.${o.navItem}:visible`)
                          .index(t(this));
                        e.$carousel.flickityt4s("select", n);
                      }
                    )
                  : e.$carouselNav.on(
                      a.clickThumb,
                      "." + o.navItem,
                      function (i) {
                        e.$carousel.flickityt4s("select", t(this).index());
                      }
                    ));
          },
          addThumbIcons: function () {
            var e = t("template[data-icons-thumb]");
            0 != e.length &&
              (T4SThemeSP.$appendComponent.after(e.html()), (p = !0));
          },
          thumbnailsMarkup: function (e) {
            var i = this;
            (d = ""),
              e ||
                (i.$el.find("[data-main-slide]").each(function () {
                  var e = t(this),
                    i = e.hasClass("is--media-hide") ? "is--media-hide" : "",
                    n = e.data("media-type"),
                    s = e.data("vhost") || "",
                    r = e.data("grname") || "",
                    a = e.data("grpvl") || "",
                    l = e.find(".t4s_ratio").attr("style"),
                    c = e.find("img"),
                    h = T4SThemeSP.Images.lazyloadImagePath(
                      c.attr("data-master") || c.attr("src")
                    ),
                    f = u[n + s] || "";
                  d += `<div class="t4s-col-item ${
                    o.navItem
                  } ${i}" data-grname="${r}" data-grpvl="${a}" data-mdtype="${n}" data-vhost="${s}"><div class="t4s_ratio t4s-carousel__nav-inner t4s-bg-11" style="${l};background: url(${h})"><img alt="${T4SThemeSP.escapeHtml(
                    c.attr("alt")
                  )}" loading="lazy" class="lazyloadt4s" src="${h}" data-widths="[80, 120, 160 ,180, 360, 540]" data-optimumx="1.8" data-sizes="auto" src="${h}"><span class="t4s-thumbnail__badge t4s-not-style t4s-op-0" aria-hidden="true">${f}</span></div></div>`;
                }),
                i.$carouselNav.empty().append(d).addClass("is--nav-ready"));
            var n = i.$el.find("[data-main-slide]:visible").length;
            if (
              ((i.$carouselNavLinks = i.$carouselNav.find(
                `.${o.navItem}:not(.is--media-hide):visible`
              )),
              i.args.thumbVertical)
            ) {
              i.$carouselNav.parents(".t4s-parent-nav").outerHeight() + 20 <
              i.$carouselNav
                .find(".t4s-col-item:not(.is--media-hide):visible")
                .outerHeight() *
                n
                ? i.$carouselNav
                    .parents(".t4s-parent-nav")
                    .addClass("thumb-nav-active")
                : i.$carouselNav
                    .parents(".t4s-parent-nav")
                    .removeClass("thumb-nav-active");
            } else {
              i.$carouselNav.parents(".t4s-parent-nav").outerWidth() + 20 <
              i.$carouselNav
                .find(".t4s-col-item:not(.is--media-hide):visible")
                .outerWidth() *
                n
                ? i.$carouselNav
                    .parents(".t4s-parent-nav")
                    .addClass("thumb-nav-active")
                : i.$carouselNav
                    .parents(".t4s-parent-nav")
                    .removeClass("thumb-nav-active");
            }
            i.$carouselNavLinks
              .eq(i.$carouselNavLinks.length - 1)
              .addClass("thumb-nav-visible-last");
          },
          thumbnailsGoto: function (e) {
            if (void 0 !== this.$carouselNavLinks) {
              var i = this.$carouselNavLinks.eq(e),
                n = i[0],
                s = isBehaviorSmooth ? 0 : 350;
              if (
                ((this.$carouselNavScroller = t(
                  `[data-thumb__scroller="${this.IdSlider}"]`
                )),
                this.$carouselNav
                  .find("." + o.isNavActive)
                  .removeClass(o.isNavActive),
                i.addClass(o.isNavActive),
                this.args.thumbVertical)
              ) {
                var r = n.offsetTop;
                g
                  ? (this.$carouselNavScroller[0].scrollTop = r - 100)
                  : this.$carouselNavScroller
                      .stop()
                      .animate({ scrollTop: r - 100 }, s);
              } else {
                var a = n.offsetLeft;
                g
                  ? (this.$carouselNavScroller[0].scrollLeft = a - 100)
                  : this.$carouselNavScroller
                      .stop()
                      .animate({ scrollLeft: a - 100 }, s);
              }
            }
          },
          _switchMedia: function (e) {
            this.$el
              .find(`.flickityt4s-slider ${s.productMediaWrapper}`)
              .eq(this.selectedIndex);
            var i = this.$el
              .find(`.flickityt4s-slider ${s.productMediaWrapper}`)
              .eq(e);
            (this.selectedIndex = this.flkty.selectedIndex),
              this.$groupBtn.removeAttr("hidden"),
              this.$mediaGroup.removeClass(o.isXrShowing),
              (this.flkty.options.draggable = !0),
              t(s.productMediaPlay).each(function () {
                this.dispatchEvent(
                  new CustomEvent("mediaHidden", {
                    bubbles: !0,
                    cancelable: !0,
                  })
                ),
                  this.removeAttribute(s.dataMediaPlay);
              }),
              i.is("[data-deferred-media]") || i.is('[data-media-type="360"]')
                ? ((this.flkty.options.draggable = !1),
                  this.flkty.updateDraggable(),
                  i.is('[data-media-type="model"]')
                    ? this.$mediaGroup.addClass(o.isXrShowing)
                    : this.$groupBtn.attr("hidden", !0),
                  i.attr(s.dataMediaPlay, ""),
                  i[0].dispatchEvent(
                    new CustomEvent("mediaVisible", {
                      bubbles: !0,
                      cancelable: !0,
                    })
                  ))
                : this.flkty.updateDraggable();
          },
          _updateCarousel: function (e) {
            var i = this;
            i.$carousel.on("update.flickityt4s", function (e) {
              t(this).flickityt4s("deactivate").flickityt4s("activate"),
                i.$carouselNav && i.thumbnailsMarkup("update");
            });
          },
          _updateBtnTab: function (e) {
            var i = this;
            let n = t("#btn-tab-smart__prev--" + i.args.t4sidTab),
              o = t("#btn-tab-smart__next--" + i.args.t4sidTab);
            0 != o.length &&
              (i.$carousel.on("updateBtnTab.flickityt4s", function (t) {
                n.off(a.clicknavUI),
                  o.off(a.clicknavUI),
                  i._customNavUI(n, o),
                  i._customIcon(n, o);
              }),
              i.args.activeTab &&
                i.$carousel.trigger("updateBtnTab.flickityt4s"));
          },
          _customIcon: function (t, e) {
            let i = this.args.customIcon;
            if (!i) return;
            let n = `<svg viewBox="${this.args.viewBox}" class="flickityt4s-button-icon t4s-cus-icon-slider is--cus-ic-${i}"><use href="#svg-slider-btn___prev-${i}"></svg><span class="t4s-flicky-btn-text">${T4Sstrings.btn_prev}</span>`,
              o = `<svg viewBox="${this.args.viewBox}" class="flickityt4s-button-icon t4s-cus-icon-slider is--cus-ic-${i}"><use href="#svg-slider-btn___next-${i}"></svg><span class="t4s-flicky-btn-text">${T4Sstrings.btn_next}</span>`;
            t.html(n), e.html(o);
          },
          _selectWithSelector: function () {
            var e = this;
            let i = t(`[data-carousel-id="${e.IdSlider}"]`);
            if (0 == i.length) return;
            i.on("click", function () {
              e.$carousel.flickityt4s("select", t(this).index());
            });
            let n = e.$carousel.find("[data-flickity-link]");
            e.$carousel.on(a.select, function () {
              i.filter(`.${o.isActive}`).removeClass(o.isActive),
                i.eq(e.flkty.selectedIndex).addClass(o.isActive);
              let s = t(e.flkty.selectedElement).data("url");
              n[0] && s && n.attr("href", s);
            });
          },
          _scrollbarCarousel: function () {
            function e() {
              clearTimeout(n.recalculateScrollSizeTimeout),
                (n.recalculateScrollSizeTimeout = setTimeout(function () {
                  n.$scrollbar.css({
                    "--width":
                      (n.flkty.size.width * n.flkty.size.width) /
                        n.flkty.slideableWidth +
                      "px",
                  }),
                    n.flkty.size.width >= n.flkty.slideableWidth
                      ? n.$scrollbar.addClass("is--hidden")
                      : n.$scrollbar.removeClass("is--hidden"),
                    (n.scrollInnerSize =
                      n.$scrollbarDrag.width() / n.$scrollbar.width());
                }, 155));
            }
            var n = this;
            (n.$scrollbar = t(".t4s-carousel-scrollbar--" + n.IdSlider)),
              n.$scrollbar[0] &&
                ((n.$scrollbarDrag = n.$scrollbar.find(
                  ".t4s-carousel-scrollbar__drag"
                )),
                (n.scrollInnerSize = 0),
                n.recalculateScrollSizeTimeout,
                e(),
                i.on(
                  `resize.scrollbar${n.IdSlider}`,
                  T4SThemeSP.debounce(400, function () {
                    e();
                  })
                ),
                n.$carousel.on("scroll.flickityt4s", function (t, e) {
                  n.$scrollbar.css({
                    "--left": e * (1 - n.scrollInnerSize) * 100 + "%",
                  });
                }));
          },
          _scrollbarDraggableCarousel: function () {},
        })),
        e
      );
    })()),
    (window.liquidWindowWidth = function () {
      return window.innerWidth;
    }),
    (T4SThemeSP.initCarousel = function () {
      var e = t(
        ".flickityt4s:not(.flickityt4s-later):not(.flickityt4s-enabled)"
      );
      0 != e.length &&
        e.each(function () {
          this.flickityt4s = new T4SThemeSP.Carousel(this);
        });
    }),
    (T4SThemeSP.initWhenVisible = function (t) {
      var e = t.threshold ? t.threshold : 0;
      new IntersectionObserver(
        (e, i) => {
          e.forEach((e) => {
            e.isIntersecting &&
              "function" == typeof t.callback &&
              (t.callback(), i.unobserve(e.target));
          });
        },
        { rootMargin: "0px 0px " + e + "px 0px" }
      ).observe(t.element);
    }),
    (T4SThemeSP.Isotopet4s = (function () {
      function e(t) {
        t.removeClass("isotopet4s-later");
        var e = t.attr("data-isotopet4s-js") || "{}",
          n = t.isotopet4s(JSON.parse(e)).addClass("isotopet4s-enabled");
        i.on(
          "resize",
          T4SThemeSP.debounce(555, function () {
            t.hasClass("isotopet4s-enabled") && n.isotopet4s("layout");
          })
        );
      }
      function n() {
        var e = t("[data-isotopet4s-filter]");
        if (0 != e.length) {
          var i = IsDesignMode ? "[data-isotopet4s-filter]>button" : ">button";
          (IsDesignMode ? o : e).on("click", i, function () {
            var e = t(this),
              i = e.closest("[data-isotopet4s-filter]"),
              n = i.data("grid"),
              o = n ? t(n) : i.next();
            i.find(".is--active").removeClass("is--active"),
              e.addClass("is--active"),
              o.isotopet4s({ filter: e.attr("data-filter") });
          });
        }
      }
      return {
        initEach: function () {
          var i = t(
            ".isotopet4s:not(.isotopet4s-later):not(.isotopet4s-enabled)"
          );
          0 != i.length &&
            (i.each(function () {
              e(t(this));
            }),
            n());
        },
        init: e,
        filter: n,
      };
    })()),
    (T4SThemeSP.T4SWrappTable = function () {
      t("table:not('.t4s-table-res')").wrap(
        "<div class='t4s-table-res-df'></div>"
      );
    }),
    (T4SThemeSP.AccordionMobileInt = function () {
      var e = t(".t4s-accordion-mb-true");
      if (0 == e.length) return;
      let i = e.data("t4s-w-toggle") || 1024;
      t(window).width() <= i
        ? e.removeClass("t4s-type-tabs").addClass("t4s-type-accordion")
        : e.removeClass("t4s-type-accordion").addClass("t4s-type-tabs");
    }),
    (T4SThemeSP.CartAttrHidden = function () {
      var e = t("[data-cart-attr-rm]"),
        i = 0;
      if (0 != e.length && !T4Sconfigs.CartAttrHidden) {
        var n = setInterval(function () {
          e.val(""), 15 == i && clearInterval(n), i++;
        }, 500);
        o.on("click", 'button[type=submit][name="checkout"]', function (t) {
          e.val("");
        });
      }
    }),
    (T4SThemeSP.announcement = function () {
      var e = {
          bar: ".t4s-announcement-bar",
          btnClose: ".t4s-announcement-bar__close",
        },
        i = t(e.bar),
        n = i.attr("data-ver"),
        o = T4Sconfigs.theme,
        s = "t4s_announcement_" + o + "_" + n,
        r = parseInt(i.attr("data-date"));
      if (0 != i.length && "closed" != CookiesT4.get(s)) {
        var a = "t4s_announcement_" + o + "_" + ("1_nt" == n ? "2_nt" : "1_nt");
        "closed" == CookiesT4.get(a) && CookiesT4.remove(a),
          t(e.btnClose).on("click", function (e) {
            i.css("min-height", "auto").attr("aria-hidden", !0).slideUp(),
              t("html").css("--announcement-height", ""),
              IsDesignMode ||
                CookiesT4.set(s, "closed", { expires: r, path: "/" });
          });
      }
    }),
    (T4SThemeSP.Marquee3k = (function () {
      function e(e) {
        (this.el = e),
          (this.$el = t(e)),
          (this.width = 0),
          (this.UID = T4SThemeSP.getUID()),
          (n = "resize.marquee" + this.UID),
          (this.marquee3kItem = e.querySelector(".t4s-marquee__item")),
          IsDesignMode
            ? setTimeout(this.resizeHandler.bind(this), 100)
            : this.resizeHandler(),
          this.$el.addClass(o.enabled);
        var s = this;
        i.on(
          n,
          T4SThemeSP.debounce(
            300,
            function () {
              s.resizeHandler();
            }.bind(this)
          )
        );
      }
      var n,
        o = {
          enabled: "marqueet4s-enabled",
          animation: "t4s-marquee--animation",
          duplicate: "t4s-marquee--duplicate",
        };
      return (
        (e.prototype = Object.assign({}, e.prototype, {
          resizeHandler: function () {
            if (this.width != window.innerWidth) {
              (this.width = window.innerWidth),
                this.marquee3kItem.classList.remove(o.animation);
              var t = this.el.querySelectorAll("." + o.duplicate);
              t.length && t.forEach((t) => t.remove());
              var e = window.innerWidth / this.marquee3kItem.offsetWidth,
                i = !1;
              e = e == 1 / 0 ? 5 : e;
              for (var n = 0; n < e; n++)
                (i = this.marquee3kItem.cloneNode(!0)).setAttribute(
                  "aria-hidden",
                  !0
                ),
                  i.classList.add(o.duplicate),
                  i.classList.add(o.animation),
                  this.el.append(i);
              this.marquee3kItem.classList.add(o.animation);
            }
          },
        })),
        e
      );
    })()),
    (T4SThemeSP.initMarquee3k = function () {
      var e = t(".t4s-marquee:not(.marqueet4s-enabled)");
      0 != e.length &&
        e.each(function () {
          this.marquee3k = new T4SThemeSP.Marquee3k(this);
        });
    }),
    (T4SThemeSP.initVarHeight = function () {
      function e() {
        o.each(function () {
          t(this)
            .closest(".t4s-section")
            .css("--var-t4s-height", t(this).height() + "px");
        });
      }
      var n = "[data-get-height]:not(.var-css-enabled)",
        o = t(n);
      0 != o.length &&
        (e(),
        i.on(
          "resize.varHeight",
          T4SThemeSP.debounce(550, function () {
            (o = t(n)), e();
          })
        ));
    });
  (function () {
    if (window.location.search.indexOf("_posted=true") < 0) return;
    let e = localStorage.getItem("t4s-recentform") || "xyz";
    t(` form:not(${window.location.hash}):not(#${e})`).each(function () {
      t(this).find("[data-t4s-response-form]").hide();
    });
  })(),
    window.location.href.indexOf(T4Sconfigs.preViewBar) < 0 ||
      t("html").addClass("is--hidden-previewbar");
  (T4SThemeSP.Helpers = (function () {
    return {
      disableBodyScroll: function () {
        var t,
          e = !1,
          i = !1;
        Element.prototype.matches ||
          (Element.prototype.matches =
            Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector),
          Element.prototype.closest ||
            (Element.prototype.closest = function (t) {
              var e = this;
              if (!document.documentElement.contains(el)) return null;
              do {
                if (e.matches(t)) return e;
                e = e.parentElement;
              } while (null !== e);
              return el;
            });
        var n = function (t) {
            (!1 !== i && t.target.closest(e)) || t.preventDefault();
          },
          o = function (e) {
            1 === e.targetTouches.length && (t = e.targetTouches[0].clientY);
          },
          s = function (e) {
            if (1 === e.targetTouches.length) {
              var n = e.targetTouches[0].clientY - t;
              0 === i.scrollTop && n > 0 && e.preventDefault(),
                i.scrollHeight - i.scrollTop <= i.clientHeight &&
                  n < 0 &&
                  e.preventDefault();
            }
          };
        return function (t, r) {
          void 0 !== r && ((e = r), (i = document.querySelector(r))),
            !0 === t
              ? (!1 !== i &&
                  (i.addEventListener("touchstart", o, !1),
                  i.addEventListener("touchmove", s, !1)),
                document.body.addEventListener("touchmove", n, !1))
              : (!1 !== i &&
                  (i.removeEventListener("touchstart", o, !1),
                  i.removeEventListener("touchmove", s, !1)),
                document.body.removeEventListener("touchmove", n, !1));
        };
      },
      debounce: function (t, e, i) {
        var n;
        return function () {
          var o = this,
            s = arguments,
            r = i && !n;
          clearTimeout(n),
            (n = setTimeout(function () {
              (n = null), i || t.apply(o, s);
            }, e)),
            r && t.apply(o, s);
        };
      },
      getScript: function (t, e) {
        return new Promise(function (i, n) {
          function o(t, e) {
            (e || !s.readyState || /loaded|complete/.test(s.readyState)) &&
              ((s.onload = null),
              (s.onreadystatechange = null),
              (s = void 0),
              e ? n() : i());
          }
          var s = document.createElement("script"),
            r = e || document.getElementsByTagName("script")[0];
          (s.async = !0),
            (s.defer = !0),
            (s.onload = o),
            (s.onreadystatechange = o),
            (s.src = t),
            r.parentNode.insertBefore(s, r);
        });
      },
      loadScript: function (e, i) {
        void 0 != e &&
          t.ajax({ url: e, dataType: "script", success: i, async: !0 });
      },
      prepareTransition: function (t) {
        t.addEventListener(
          "transitionend",
          function (t) {
            t.currentTarget.classList.remove("is-transitioning");
          },
          { once: !0 }
        );
        var e = 0;
        [
          "transition-duration",
          "-moz-transition-duration",
          "-webkit-transition-duration",
          "-o-transition-duration",
        ].forEach(function (i) {
          var n = getComputedStyle(t)[i];
          n && (n.replace(/\D/g, ""), e || (e = parseFloat(n)));
        }),
          0 !== e && (t.classList.add("is-transitioning"), t.offsetWidth);
      },
      cookiesEnabled: function () {
        var t = navigator.cookieEnabled;
        return (
          t ||
            ((document.cookie = "testcookie"),
            (t = -1 !== document.cookie.indexOf("testcookie"))),
          t
        );
      },
      promiseStylesheet: function (t) {
        var e = t,
          i = e.match(/[\w-]+\.(css)/g)[0];
        return (
          void 0 === T4SThemeSP.stylesheetPromise[i] &&
            (T4SThemeSP.stylesheetPromise[i] = new Promise(function (t) {
              let i = document.getElementsByTagName("head")[0],
                n = document.createElement("link");
              (n.rel = "stylesheet"),
                (n.type = "text/css"),
                (n.href = e),
                (n.media = "all"),
                i.appendChild(n),
                n.loaded && t(),
                n.addEventListener("load", function () {
                  setTimeout(t, 100);
                });
            })),
          T4SThemeSP.stylesheetPromise[i]
        );
      },
    };
  })()),
    (T4SThemeSP.stylesheetPromise = {}),
    (T4SThemeSP.getScrollbar = function () {
      function e() {
        const t = window.innerWidth - document.body.clientWidth;
        t >= 0 && i.css({ "--scroll-w": `${t}px` }),
          (T4SThemeSP.scrollbarWidth = t);
      }
      var i = t("html");
      e(),
        window.addEventListener(
          "resize",
          (function (t) {
            let e,
              i = null;
            const n = (...n) => {
              (e = n),
                null === i &&
                  (i = requestAnimationFrame(
                    ((n) => () => {
                      (i = null), t.apply(n, e);
                    })(this)
                  ));
            };
            return (
              (n.cancel = () => {
                cancelAnimationFrame(i), (i = null);
              }),
              n
            );
          })(e)
        );
    }),
    (T4SThemeSP.Drawer = (function () {
      function e(e, i, n = !1) {
        if (!l) {
          e && e.preventDefault();
          var s = (function (t, e) {
              return JSON.parse(t || e || "{}");
            })(i.attr(h)),
            r = n ? i : t(s.id);
          r.trigger("opendDrawer"),
            r.attr("aria-hidden", "false"),
            g.addClass(a.overlayVisible),
            (l = !0),
            o.addClass(m + f),
            p.css({ "margin-right": T4SThemeSP.scrollbarWidth }),
            T4SThemeSP.Helpers.disableBodyScroll(!0, v);
        }
      }
      function i(e, i) {
        if (l) {
          e && e.preventDefault();
          var n = void 0 !== i ? t(i.attr("data-drawer-target")) : void 0,
            s = t(".t4s-drawer[aria-hidden=false]");
          s.length > 1 && (s = n),
            s.attr("aria-hidden", "true"),
            t(".t4s-drawer[aria-hidden=false]").length <= 1 &&
              (g.removeClass(a.overlayVisible),
              (l = !1),
              s.one("transitionend", function () {
                o.removeClass(m + f),
                  p.css({ "margin-right": "" }),
                  T4SThemeSP.Helpers.disableBodyScroll(!1, v);
              }),
              g.off(c),
              o.off(c),
              o.off(u));
        }
      }
      function s() {
        n.on(c, "[" + h + "]:not([" + d + "])", function (i) {
          e(i, t(this)), r();
        }),
          (function () {
            let e = t("[data-sidebar-trigger]"),
              i = t(".t4s-btn-sidebar");
            if (0 == e.length || 0 == i.length) return;
            e.on(c, function (t) {
              t.preventDefault(), i.trigger(c);
            });
          })();
      }
      function r() {
        g.on(c, function (t) {
          i(t);
        }),
          o.on(c, "[data-drawer-close]", function (e) {
            i(e, t(this));
          }),
          o.on("keyup.drawer", function (t) {
            27 === t.keyCode &&
              (i(t), window.closeCustomKey && window.closeCustomKey());
          });
      }
      var a = { overlayVisible: "is--visible" },
        l = !1,
        c = "click.drawer",
        u = "keyup.drawer",
        h = "data-drawer-options",
        d = "data-drawer-delay",
        f = " is--opend-drawer",
        p = t("html"),
        g = t(".t4s-close-overlay"),
        m = "t4s-lock-scroll",
        v = "[data-t4s-scroll-me]";
      return {
        init: s,
        opend: function (t) {
          (l = !1), e(null, t, !0), r();
        },
        close: i,
        remove: function (e) {
          t("[" + h + '*="#' + e + '"]').removeAttr(d);
        },
      };
    })()),
    (T4SThemeSP.Reveal = (function () {
      function t(t, e) {
        t.forEach((t, s) => {
          const r = t.target;
          r.setAttribute("observed", ""),
            t.isIntersecting
              ? (r.classList.contains(i) &&
                  (r.classList.remove(i),
                  r.hasAttribute("timeline") &&
                    r.style.setProperty("--animation-order", s)),
                e.unobserve(r))
              : (r.classList.add(i), r.classList.remove(n)),
            (r.isAnimationend = !0),
            r.addEventListener("animationend", o);
        });
      }
      const e = "hdt-reveal",
        i = e + "--offscreen",
        n = e + "--cancel",
        o = (t) => {
          const e = t.target;
          e.isAnimationend &&
            (e.setAttribute("animationend", ""),
            e.removeEventListener("animationend", o));
        };
      return function (i = document, n = !1) {
        const o = Array.from(i.querySelectorAll(`[${e}]:not([observed])`));
        if (0 === o.length) return;
        if (n)
          return void o.forEach((t) => {
            t.classList.add(e + "--design-mode");
          });
        const s = new IntersectionObserver(t, {
          rootMargin: "0px 0px -50px 0px",
        });
        o.forEach((t) => s.observe(t));
      };
    })());
})(jQuery_T4NT),
  window.T4Sconfigs.revealInView &&
    window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
    (documentElementT4s.classList.add("hdt-reveal-in-view"),
    window.addEventListener("DOMContentLoaded", () => T4SThemeSP.Reveal()),
    Shopify.designMode &&
      (document.addEventListener("shopify:section:load", (t) =>
        T4SThemeSP.Reveal(t.target, !0)
      ),
      document.addEventListener("shopify:section:reorder", () =>
        T4SThemeSP.Reveal(document, !0)
      ))),
  jQuery_T4NT(document).ready(function (t) {
    T4SThemeSP.fullHeightFirtSe(),
      T4SThemeSP.initVarHeight(),
      T4SThemeSP.initMarquee3k(),
      T4SThemeSP.initCarousel(),
      T4SThemeSP.Isotopet4s.initEach(),
      T4SThemeSP.announcement(),
      T4SThemeSP.T4SWrappTable(),
      T4SThemeSP.CartAttrHidden(),
      T4SThemeSP.Drawer.init(),
      T4SThemeSP.getScrollbar(),
      "fetch" in window &&
      "assign" in Object &&
      "ResizeObserver" in window &&
      "IntersectionObserver" in window &&
      "DateTimeFormat" in Intl
        ? $script(T4Sconfigs.script2, function () {
            IsDesignMode && $script(T4Sconfigs.script9),
              $script(T4Sconfigs.script10);
          })
        : $script(T4Sconfigs.script1, function () {
            $script(T4Sconfigs.script2, function () {
              IsDesignMode && $script(T4Sconfigs.script9),
                $script(T4Sconfigs.script10);
            });
          }),
      t("[data-t4s-type]").length > 0 && $script(T4Sconfigs.script12d);
  }),
  jQuery_T4NT(window).on("resize", function () {
    T4SThemeSP.AccordionMobileInt();
  });
